// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg width=\"24\" height=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m0,6l12,12l12,-12l-24,0z\" fill=\"gray\"/><path fill=\"none\" d=\"m0,0l24,0l0,24l-24,0l0,-24z\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: "archia";
}

html {
  overflow-x: hidden;
  width: 100vw;
}

body {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  margin: 0;
  padding: 0;
}

h1 {
  font-size: 24px;
  font-weight: 900;
}

h2 {
  font-size: 18px !important;
  font-weight: 400;
}

h3 {
  font-size: 14px !important;
  font-weight: 400;
}

h4 {
  font-size: 13px !important;
  font-weight: 900;
}

h5 {
  font-size: 12px !important;
  font-weight: 900;
}

h6 {
  font-size: 11px !important;
  font-weight: 600;
}

.App {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.arrow-up {
  border-bottom: 5px solid rgba(108, 117, 125, 0.6);
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  margin-left: 0.25rem;
}

.arrow-down {
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid rgba(108, 117, 125, 0.6);
  margin-left: 0.25rem;
}

.Navbar {
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 4rem;
  justify-content: space-between;
}
.Navbar a {
  color: inherit;
  text-decoration: none;
}
.Navbar .navbar-left {
  color: rgba(108, 117, 125, 0.6);
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  padding: 1.5rem;
  text-align: center;
  width: 3rem;
}
.Navbar .navbar-left:hover {
  color: #6c757d;
}
.Navbar .navbar-middle {
  color: #6c757d;
  font-size: 18px;
  font-weight: 900;
  text-transform: uppercase;
}
.Navbar .navbar-middle span {
  color: #4c75f2;
}
.Navbar .navbar-right {
  color: #6c757d;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  padding: 1.5rem;
  text-align: center;
  width: 3rem;
}
.Navbar .language-toggle {
  cursor: pointer;
  font-weight: 900;
  text-transform: uppercase;
}
.Navbar .expand {
  background: #f6f6f7;
  color: #6c757d;
  display: flex;
  flex-direction: column;
  width: 100vw;
  z-index: 9999;
}
.Navbar .expand > * {
  border-bottom: 1px solid rgba(108, 117, 125, 0.062745098);
  border-top: 1px solid rgba(108, 117, 125, 0.062745098);
  padding: 1.5rem;
  transition: all 0.15s ease-in-out;
}
.Navbar .expand > *:hover {
  background: rgba(76, 117, 242, 0.1882352941);
}
.Navbar .expand > * span.focused {
  background: rgba(76, 117, 242, 0.062745098);
  color: #4c75f2;
  padding: 0.25rem;
}
.Navbar .expand .expand-bottom {
  align-self: flex-start;
  border: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.Navbar .expand .expand-bottom h5 {
  margin: 0;
}
.Navbar .expand .expand-bottom:hover {
  background: none;
}

.Home {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  margin-left: 9rem;
  margin-right: 3rem;
}
.Home .home-left,
.Home .home-right {
  display: flex;
  flex-direction: column;
}
.Home .home-left {
  margin-right: 2.5rem;
}
.Home .home-right {
  margin-left: 2.5rem;
}
.Home .header {
  z-index: 99;
}

.alert {
  align-items: flex-start;
  background: rgba(108, 117, 125, 0.062745098);
  border-radius: 5px;
  color: #6c757d;
  display: flex;
  flex-direction: row;
  font-size: 10px;
  padding: 0.5rem;
}
.alert svg {
  color: rgba(108, 117, 125, 0.6);
  height: 16px;
  width: 16px;
}
.alert .alert-right {
  margin-left: 0.25rem;
  text-align: right;
  width: 8.25rem;
}
.alert .alert-right a {
  background: rgba(108, 117, 125, 0.062745098);
  color: #6c757d;
  padding-left: 0.1rem;
  padding-right: 0.1rem;
}
.alert .alert-right a:hover {
  background: rgba(108, 117, 125, 0.1254901961);
}
.alert .alert-right.is-full {
  width: 100%;
}
.alert.is-green {
  background: rgba(40, 167, 69, 0.1254901961);
  color: #28a745;
}
.alert.is-green svg {
  stroke: rgba(40, 167, 69, 0.6);
}

.StateHeader {
  align-self: center;
  display: flex;
  flex-direction: row;
  height: 5.25rem;
  justify-content: space-between;
  margin-bottom: 1rem;
  position: relative;
  width: 100%;
}
.StateHeader > * {
  align-self: flex-start;
}
.StateHeader .header-left h1,
.StateHeader .header-left h5 {
  margin: 0;
}
.StateHeader .header-left h1 {
  color: #e23028;
  max-width: 20rem;
}
.StateHeader .header-left h5 {
  color: #6c757d;
  font-weight: 600;
  margin-top: 0.5rem;
}
.StateHeader .header-right {
  color: rgba(32, 26, 162, 0.6);
  display: flex;
  flex-direction: column;
  text-align: right;
}
.StateHeader .header-right h2,
.StateHeader .header-right h5 {
  font-weight: 600;
  margin: 0;
}
.StateHeader .header-right h2 {
  color: rgba(32, 26, 162, 0.8666666667);
  font-weight: 900;
}
.StateHeader .header-right a {
  background: rgba(32, 26, 162, 0.1254901961);
  color: inherit;
  text-decoration: none;
}
.StateHeader .header-right a:hover {
  background: rgba(32, 26, 162, 0.1882352941);
}

.State {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  margin-left: 9rem;
  margin-right: 3rem;
}
.State .state-left,
.State .state-right {
  display: flex;
  flex-direction: column;
}
.State .state-left {
  margin-right: 2.5rem;
  position: relative;
}
.State .state-right {
  margin-left: 2.5rem;
}
.State a {
  text-decoration: none;
}
.State .district-bar {
  margin-bottom: 2.5rem;
  width: calc(100% - 2rem);
}
.State .MapExplorer .header,
.State .MapExplorer .map-stats,
.State .MapExplorer .map-button,
.State .MapExplorer .tabs-map,
.State .MapExplorer .last-update,
.State .MapExplorer .footnote {
  display: none;
}
.State .MapExplorer .anchor {
  display: none;
}
.State .TimeseriesExplorer .anchor {
  display: none;
}

.StateMeta {
  align-self: center;
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: 3rem;
  width: calc(100% - 3rem);
}
.StateMeta.population {
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
  margin: 0;
  margin-bottom: 2.5rem;
  margin-top: 2.5rem;
}
.StateMeta.population .alert {
  margin: 0;
}
.StateMeta .meta-item {
  border-radius: 5px;
  min-height: 6rem;
  padding-left: 1rem;
  padding-top: 1rem;
}
.StateMeta .meta-item h1,
.StateMeta .meta-item h2,
.StateMeta .meta-item h3,
.StateMeta .meta-item h4,
.StateMeta .meta-item h5 {
  margin: 0;
}
.StateMeta .meta-item h5 {
  font-weight: 600;
}
.StateMeta .meta-item h2 {
  font-weight: 600;
}
.StateMeta .meta-item h3 {
  font-weight: 600;
  width: 10rem;
  word-wrap: break-word;
}
.StateMeta .meta-item h1 {
  display: inline-block;
  font-weight: 600;
}
.StateMeta .meta-item.population {
  min-height: 1rem !important;
  padding: 0 !important;
}
.StateMeta .meta-item.population h1,
.StateMeta .meta-item.population h3 {
  color: #6c757d;
}
.StateMeta .meta-item .meta-item-top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-right: 1rem;
}
.StateMeta .meta-item .meta-item-top > * {
  align-self: center;
}
.StateMeta .meta-item .meta-item-top h3 {
  width: calc(100% - 2.5rem);
}
.StateMeta .meta-item .meta-item-top svg {
  align-self: flex-start;
  cursor: pointer;
  stroke-width: 2.5px;
  width: 16px;
}
.StateMeta .meta-item .meta-item-middle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.StateMeta .meta-item .meta-item-middle * {
  align-self: center;
}
.StateMeta .meta-item .meta-item-middle svg {
  cursor: pointer;
  margin-right: 1rem;
}
.StateMeta .meta-item p {
  font-weight: 600;
  margin-bottom: 1.25rem;
  padding-right: 1rem;
}
.StateMeta .meta-item.confirmed {
  background: rgba(255, 7, 58, 0.1254901961);
}
.StateMeta .meta-item.confirmed h3,
.StateMeta .meta-item.confirmed h5,
.StateMeta .meta-item.confirmed svg,
.StateMeta .meta-item.confirmed p {
  color: rgba(255, 7, 58, 0.6);
}
.StateMeta .meta-item.confirmed h1 {
  color: #ff073a;
}
.StateMeta .meta-item.active {
  background: rgba(0, 123, 255, 0.1254901961);
}
.StateMeta .meta-item.active h3,
.StateMeta .meta-item.active h5,
.StateMeta .meta-item.active svg,
.StateMeta .meta-item.active p {
  color: rgba(0, 123, 255, 0.6);
}
.StateMeta .meta-item.active h1 {
  color: #007bff;
}
.StateMeta .meta-item.recovery {
  background: rgba(40, 167, 69, 0.1254901961);
}
.StateMeta .meta-item.recovery h3,
.StateMeta .meta-item.recovery h5,
.StateMeta .meta-item.recovery svg,
.StateMeta .meta-item.recovery p {
  color: rgba(40, 167, 69, 0.6);
}
.StateMeta .meta-item.recovery h1 {
  color: #28a745;
}
.StateMeta .meta-item.mortality {
  background: rgba(108, 117, 125, 0.062745098);
}
.StateMeta .meta-item.mortality h3,
.StateMeta .meta-item.mortality h5,
.StateMeta .meta-item.mortality svg,
.StateMeta .meta-item.mortality p {
  color: rgba(108, 117, 125, 0.6);
}
.StateMeta .meta-item.mortality h1 {
  color: #6c757d;
}
.StateMeta .meta-item.cpl {
  background: rgba(255, 193, 7, 0.1254901961);
}
.StateMeta .meta-item.cpl h3,
.StateMeta .meta-item.cpl h5,
.StateMeta .meta-item.cpl svg {
  color: rgba(253, 126, 20, 0.6);
}
.StateMeta .meta-item.cpl h1 {
  color: #fd7e14;
}
.StateMeta .meta-item.tpl {
  background: rgba(32, 26, 162, 0.1254901961);
}
.StateMeta .meta-item.tpl h3,
.StateMeta .meta-item.tpl h5,
.StateMeta .meta-item.tpl svg,
.StateMeta .meta-item.tpl p {
  color: rgba(32, 26, 162, 0.6);
}
.StateMeta .meta-item.tpl h1 {
  color: rgba(32, 26, 162, 0.8666666667);
}
.StateMeta .meta-item.tpr {
  background: rgba(253, 126, 20, 0.1254901961);
}
.StateMeta .meta-item.tpr h3,
.StateMeta .meta-item.tpr h5,
.StateMeta .meta-item.tpr p,
.StateMeta .meta-item.tpr svg {
  color: rgba(253, 126, 20, 0.6);
}
.StateMeta .meta-item.tpr h1 {
  color: #fd7e14;
}

.StateDropdown {
  align-items: center;
  display: flex;
  flex-direction: row;
  position: relative;
}
.StateDropdown .state-name {
  background: rgba(226, 48, 40, 0.062745098);
  border-radius: 5px;
  cursor: pointer;
  padding: 0.25rem;
}
.StateDropdown .state-name:hover:not(.expanded) {
  background-color: rgba(226, 48, 40, 0.1254901961);
}
.StateDropdown .dropdown {
  background: #fff;
  border-radius: 5px;
  height: 25rem;
  left: -0.25rem;
  overflow-y: scroll;
  position: absolute;
  top: 2.75rem;
  width: 15rem;
  z-index: 999;
}
.StateDropdown .dropdown .item {
  color: #dc3545;
  cursor: pointer;
  padding: 0.75rem;
}
.StateDropdown .dropdown .item:hover {
  background: rgba(220, 53, 69, 0.1882352941);
}
.StateDropdown .backdrop {
  background: rgba(220, 53, 69, 0.1254901961);
  height: 100vh;
  left: 0;
  pointer-events: none;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 10;
}

.StatisticDropdown {
  margin-left: -3px;
  margin-top: 0.5rem;
  position: relative;
}
.StatisticDropdown .triangle-icon {
  left: -16px;
  position: absolute;
  top: 2px;
}
.StatisticDropdown .triangle-icon svg {
  vertical-align: middle !important;
}
.StatisticDropdown select {
  -webkit-appearance: none;
          appearance: none;
  background-color: rgba(108, 117, 125, 0.062745098);
  border: 0;
  border-radius: 3px;
  color: #6c757d;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  max-width: 14rem;
  min-width: 3rem;
  outline-color: rgba(108, 117, 125, 0.1254901961);
  padding: 3px;
}
.StatisticDropdown select option {
  background-color: #eee;
  color: #6c757d;
  padding: 3px;
}
.StatisticDropdown select:hover {
  background-color: rgba(108, 117, 125, 0.1254901961);
}
.StatisticDropdown select.confirmed {
  background-color: rgba(255, 7, 58, 0.1254901961);
  color: #ff073a;
  outline-color: rgba(255, 7, 58, 0.1882352941);
}
.StatisticDropdown select.confirmed:hover {
  background-color: rgba(255, 7, 58, 0.1882352941);
}
.StatisticDropdown select.active {
  background-color: rgba(0, 123, 255, 0.1254901961);
  color: #007bff;
  outline-color: rgba(0, 123, 255, 0.1882352941);
}
.StatisticDropdown select.active:hover {
  background-color: rgba(0, 123, 255, 0.1882352941);
}
.StatisticDropdown select.recovered {
  background-color: rgba(40, 167, 69, 0.1254901961);
  color: #28a745;
  outline-color: rgba(40, 167, 69, 0.1882352941);
}
.StatisticDropdown select.recovered:hover {
  background-color: rgba(40, 167, 69, 0.1882352941);
}
.StatisticDropdown select.tested {
  background-color: rgba(32, 26, 162, 0.1254901961);
  color: rgba(32, 26, 162, 0.8666666667);
  outline-color: rgba(32, 26, 162, 0.1882352941);
}
.StatisticDropdown select.tested:hover {
  background-color: rgba(32, 26, 162, 0.1882352941);
}
.StatisticDropdown select.other, .StatisticDropdown select.tpr, .StatisticDropdown select.cfr {
  background-color: rgba(253, 126, 20, 0.1254901961);
  color: #fd7e14;
  outline-color: rgba(253, 126, 20, 0.1882352941);
}
.StatisticDropdown select.other:hover, .StatisticDropdown select.tpr:hover, .StatisticDropdown select.cfr:hover {
  background-color: rgba(253, 126, 20, 0.1882352941);
}
.StatisticDropdown select.vaccinated, .StatisticDropdown select.vaccinated1, .StatisticDropdown select.vaccinated2 {
  background-color: rgba(219, 85, 129, 0.1254901961);
  color: #db5581;
  outline-color: rgba(219, 85, 129, 0.1882352941);
}
.StatisticDropdown select.vaccinated:hover, .StatisticDropdown select.vaccinated1:hover, .StatisticDropdown select.vaccinated2:hover {
  background-color: rgba(219, 85, 129, 0.1882352941);
}
.StatisticDropdown select.population {
  background-color: rgba(182, 133, 77, 0.1254901961);
  color: #b6854d;
  outline-color: rgba(182, 133, 77, 0.1882352941);
}
.StatisticDropdown select.population:hover {
  background-color: rgba(182, 133, 77, 0.1882352941);
}

.labels {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}
.labels .label {
  align-items: center;
  background: rgba(108, 117, 125, 0.062745098) !important;
  border-radius: 5px !important;
  color: rgba(108, 117, 125, 0.6) !important;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  font-size: 14px;
  margin-bottom: 0.25rem;
  margin-right: 0.25rem;
  padding: 0.25rem 0.5rem;
  text-transform: capitalize;
}
.labels .label.is-selected {
  background: rgba(255, 193, 7, 0.1882352941) !important;
  color: rgba(253, 126, 20, 0.6) !important;
}
.labels .label.is-selected:hover {
  background: rgba(255, 193, 7, 0.1882352941) !important;
  color: rgba(253, 126, 20, 0.6) !important;
}
@media not all and (pointer: coarse) {
  .labels .label:hover {
    background: rgba(255, 193, 7, 0.1254901961) !important;
    color: rgba(253, 126, 20, 0.6) !important;
  }
}
.labels .label .count {
  align-items: center;
  background: inherit;
  border-radius: 50%;
  color: inherit;
  display: flex;
  flex-direction: row;
  font-size: 12px;
  height: 1.5rem;
  justify-content: center;
  margin-left: 0.25rem;
  width: 1.5rem;
}

.Banner {
  background: rgba(220, 53, 69, 0.1254901961);
  color: #dc3545;
  display: flex;
  flex-direction: row;
  font-size: 12px;
  font-weight: 600;
  justify-content: center;
  text-decoration: none;
}
.Banner .wrapper {
  align-items: center;
  align-self: center;
  display: flex;
  justify-content: center;
  padding: 1rem 0.75rem;
  padding-left: 7rem;
  text-align: center;
  word-wrap: break-word;
}
.Banner .wrapper .content {
  margin: 0 0.5rem;
}
.Banner .wrapper a {
  align-items: center;
  background-color: rgba(220, 53, 69, 0.1254901961);
  color: #dc3545;
  display: flex;
  padding: 1px;
  text-decoration: none;
  white-space: nowrap;
}
.Banner .wrapper a:hover {
  background-color: rgba(220, 53, 69, 0.1882352941);
}

.Search {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  position: relative;
  width: 100%;
}
.Search > * {
  align-self: center;
}
.Search label {
  color: #6c757d;
  font-size: 0.75rem;
  margin-bottom: 1rem;
}
.Search .line {
  background: rgba(108, 117, 125, 0.062745098);
  height: 1rem;
  width: 2px;
}
.Search input {
  -webkit-appearance: none !important;
          appearance: none !important;
  background: #1e1e30;
  border: 0;
  border-radius: 5px;
  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.1);
  color: #6c757d;
  font-size: 1rem;
  height: 4rem;
  outline: none;
  padding: 1rem;
  padding-left: 3rem;
  width: calc(100% - 0rem);
}
.Search .search-input-wrapper {
  position: relative;
  width: 100%;
}
.Search .search-placeholder {
  color: rgba(108, 117, 125, 0.6);
  font-size: 1rem;
  left: 3rem;
  opacity: 0.8;
  pointer-events: none;
  position: absolute;
  top: 1.4rem;
  transition: opacity 1s;
}
.Search .search-placeholder.disappear {
  opacity: 0;
}
.Search .search-button svg {
  color: rgba(108, 117, 125, 0.6);
  left: 0.75rem;
  position: absolute;
  top: 1.25rem;
  transition: all 0.2s ease-in-out;
}
.Search .search-button.is-expand svg {
  left: 0.5rem;
}
.Search .close-button {
  background: rgba(108, 117, 125, 0.062745098) !important;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  height: 20px;
  justify-content: center;
  position: absolute;
  right: 1rem;
  top: 1.35rem;
  transition: all 0.2s ease-in-out;
  width: 20px;
}
.Search .close-button:hover {
  background: rgba(108, 117, 125, 0.1254901961) !important;
}
.Search .close-button.is-expand {
  right: 0.75rem;
}
.Search .close-button svg {
  align-self: center;
  position: absolute;
  stroke: rgba(108, 117, 125, 0.6);
  stroke-width: 3;
  width: 12px;
}
.Search .close-button.custom {
  background: rgba(219, 85, 129, 0.1254901961) !important;
  pointer-events: none;
  z-index: 0;
}
.Search .close-button.custom svg {
  stroke: #db5581 !important;
}
.Search .feature {
  background: rgba(219, 85, 129, 0.1254901961);
  border-radius: 5px;
  color: #db5581;
  cursor: pointer;
  font-size: 0.75rem;
  padding: 0.75rem;
  text-align: center;
}
.Search .expanded {
  display: flex;
  flex-direction: row;
  margin-top: 2rem;
  padding: 1rem;
  padding-bottom: 0;
  width: calc(100% - 4rem);
}
.Search .expanded > * {
  flex: 1 1;
}
.Search .expanded h4,
.Search .expanded h3 {
  color: #6c757d;
  font-weight: 600;
  margin: 0;
  margin-bottom: 0.5rem;
}
.Search .expanded h3 {
  color: #4c75f2;
  margin-bottom: 0.75rem;
}
.Search .results {
  padding: 1rem;
  padding-bottom: 0;
  width: calc(100% - 2rem);
}
.Search .results a {
  text-decoration: none !important;
}
.Search .results .pan-divider {
  color: #6c757d;
  font-weight: 600;
  padding: 1rem 0;
}
.Search .results .result,
.Search .results .essential-result {
  align-self: flex-start;
  border-bottom: 2px solid rgba(108, 117, 125, 0.062745098);
  color: #6c757d;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  font-size: 0.9rem;
  justify-content: space-between;
  min-height: 2rem;
  padding: 1rem;
  transition: all 0.2s ease-in-out;
}
.Search .results .result:hover,
.Search .results .essential-result:hover {
  background: rgba(108, 117, 125, 0.062745098);
}
.Search .results .result > *,
.Search .results .essential-result > * {
  align-self: center;
}
.Search .results .result .result-name,
.Search .results .essential-result .result-name {
  max-width: 15rem;
}
.Search .results .result .result-type,
.Search .results .essential-result .result-type {
  background: rgba(255, 193, 7, 0.1254901961);
  border-radius: 2px;
  color: #fd7e14;
  display: flex;
  flex-direction: row;
  font-size: 0.75rem;
  padding: 0.25rem;
}
.Search .results .result .result-type:hover,
.Search .results .essential-result .result-type:hover {
  background: rgba(255, 193, 7, 0.1882352941);
}
.Search .results .result .result-type svg,
.Search .results .essential-result .result-type svg {
  margin-left: 0.25rem;
  stroke: rgba(253, 126, 20, 0.6);
  stroke-width: 3px;
}
.Search .results .result .result-type *,
.Search .results .essential-result .result-type * {
  align-self: center;
}
.Search .results .result .result-left,
.Search .results .essential-result .result-left {
  display: flex;
  flex-direction: row;
}
.Search .results .result .result-left *,
.Search .results .essential-result .result-left * {
  align-self: center;
}
.Search .results .result .result-zone,
.Search .results .essential-result .result-zone {
  border-radius: 50%;
  height: 0.75rem;
  margin-left: 0.5rem;
  width: 0.75rem;
}
.Search .results .result .result-zone.is-red,
.Search .results .essential-result .result-zone.is-red {
  background: rgba(255, 7, 58, 0.1254901961);
  border: 2px solid rgba(255, 7, 58, 0.6);
}
.Search .results .result .result-zone.is-orange,
.Search .results .essential-result .result-zone.is-orange {
  background: rgba(253, 126, 20, 0.1254901961);
  border: 2px solid rgba(253, 126, 20, 0.6);
}
.Search .results .result .result-zone.is-green,
.Search .results .essential-result .result-zone.is-green {
  background: rgba(40, 167, 69, 0.1254901961);
  border: 2px solid rgba(40, 167, 69, 0.6);
}
.Search .results .essential-result {
  display: flex;
  flex-direction: column;
}
.Search .results .essential-result .result-top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}
.Search .results .essential-result .result-top .result-top-left {
  display: flex;
  flex-direction: column;
}
.Search .results .essential-result .result-top .result-top-left .result-location {
  display: flex;
  flex-direction: row;
  font-size: 0.75rem;
}
.Search .results .essential-result .result-top .result-top-left .result-distance {
  color: #28a745;
  display: flex;
  flex-direction: row;
  font-size: 0.75rem;
}
.Search .results .essential-result .result-category {
  align-self: flex-start;
  background: rgba(219, 85, 129, 0.1254901961);
  border-radius: 2px;
  color: #db5581;
  display: flex;
  flex-direction: row;
  font-size: 0.75rem;
  height: 1rem;
  padding: 0.25rem;
  text-align: right;
  text-transform: capitalize;
}
.Search .results .essential-result .result-category:hover {
  background: rgba(219, 85, 129, 0.1882352941);
}
.Search .results .essential-result .result-category > * {
  align-self: center;
}
.Search .results .essential-result .result-category svg {
  margin-left: 0.25rem;
  stroke-width: 3px;
  width: 12px;
}
.Search .results .essential-result .result-description {
  align-self: flex-start;
  font-size: 0.75rem;
  margin-bottom: 0.5rem;
  margin-top: 1rem;
}
.Search .results .essential-result .result-contacts {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}
.Search .results .essential-result .result-contact {
  align-self: flex-start;
  background: rgba(108, 117, 125, 0.062745098);
  border-radius: 2px;
  color: #6c757d;
  display: flex;
  flex-direction: row;
  font-size: 0.75rem;
  height: 1rem;
  margin-right: 0.25rem;
  margin-top: 0.25rem;
  padding: 0.25rem;
  text-align: right;
}
.Search .results .essential-result .result-contact:hover {
  background: rgba(108, 117, 125, 0.1254901961);
}
.Search .results .essential-result .result-contact a {
  color: inherit;
}
.Search .results .essential-result .result-contact > * {
  align-self: center;
}
.Search .results .essential-result .result-contact svg {
  margin-right: 0.25rem;
  stroke: rgba(108, 117, 125, 0.6);
  stroke-width: 3px;
  width: 12px;
}
.Search .suggestions {
  display: flex;
  flex-direction: column;
  margin-right: 1rem;
}
.Search .suggestions .suggestion {
  color: rgba(108, 117, 125, 0.6);
  display: flex;
  flex-direction: row;
  padding: 0.1rem;
}
.Search .suggestions .suggestion div {
  padding-top: 1px;
}
.Search .suggestions .suggestion h4 {
  cursor: pointer;
  margin-left: 0.25rem;
  word-wrap: wrap;
}
.Search .suggestions .suggestion h4:hover {
  text-decoration: underline;
  text-decoration-thickness: 2px;
}

.header {
  align-self: center;
  display: flex;
  flex-direction: column;
  max-width: 40rem;
  width: 100%;
}
.header > * {
  align-self: center;
}

.ActionsPanel {
  margin-bottom: 0.3rem;
  padding-bottom: 1rem;
  padding-top: 1rem;
  position: relative;
  width: calc(100% - 1rem);
}
.ActionsPanel .actions {
  display: flex;
  flex-direction: row;
  justify-content: center;
  transition: all 1s;
  width: 100%;
}
.ActionsPanel .actions > * {
  align-self: center;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.ActionsPanel .actions h5 {
  color: #6c757d;
  font-weight: 600;
  margin: 0;
}
.ActionsPanel .actions svg {
  cursor: pointer;
  fill: #a6abb0;
  stroke: #a6abb0;
  stroke-width: 0.5;
  -webkit-user-select: none;
          user-select: none;
  width: 16px;
}
.ActionsPanel .actions svg:hover {
  fill: #6c757d;
  stroke: #6c757d;
}
.ActionsPanel .actions .timeline-icon {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.ActionsPanel .actions .timeline-icon svg {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.ActionsPanel .actions .timeline-icon svg path {
  align-self: center;
}
.ActionsPanel .actions .bell-icon {
  height: 24px;
  position: relative;
}
.ActionsPanel .actions .bell-icon .indicator {
  background: #4c75f2;
  border-radius: 50%;
  height: 7px;
  position: absolute;
  right: -3px;
  top: -3px;
  width: 7px;
}

.Timeline {
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
  width: 100%;
}
.Timeline .timeline {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  position: absolute;
  top: 0;
}
.Timeline .timeline .highlight {
  color: #b6854d !important;
  opacity: 0;
  position: absolute;
  text-align: center;
  top: 3.25rem;
  transform: translate3d(0, 10px, 0);
  transition: all 0.3s;
  width: 100%;
}
.Timeline .timeline .highlight.current {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}
.Timeline .timeline .highlight svg {
  fill: rgba(220, 53, 69, 0.8666666667);
  pointer-events: none;
  stroke: none;
}
.Timeline .timeline .wheel {
  align-items: center;
  color: #fff;
  display: block;
  height: 3rem;
  margin-top: -0.75rem;
  overflow: hidden;
  width: 100%;
}
.Timeline .timeline .wheel__inner {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  pointer-events: none;
  transform-style: preserve-3d;
  width: 100%;
}
.Timeline .timeline .wheel__slides {
  height: 100%;
  margin-top: 2px;
  position: relative;
  width: 100%;
}
.Timeline .timeline .wheel__slide {
  -webkit-backface-visibility: hidden;
  align-items: center;
  backface-visibility: hidden;
  display: flex;
  height: 100%;
  justify-content: center;
  position: absolute;
  width: 100%;
}
.Timeline .timeline .wheel__slide h5 {
  -moz-user-select: -moz-none;
  -webkit-user-select: none;
  border-radius: 4px;
  cursor: pointer;
  opacity: 0.6;
  padding: 4px;
  pointer-events: all;
  transition: all 0.3s;
  user-select: none;
}
.Timeline .timeline .wheel__slide h5.current {
  background-color: rgba(108, 117, 125, 0.1254901961);
  opacity: 0.8;
}
.Timeline .timeline .wheel__slide h5.current:hover {
  opacity: 1;
}
.Timeline .timeline .wheel__slide h5:hover {
  background-color: rgba(108, 117, 125, 0.1882352941);
  opacity: 0.8;
}
.Timeline .timeline .wheel__slide h5::selection {
  background: transparent !important;
}
.Timeline .timeline .wheel__slide .calendar-icon {
  align-self: center;
  cursor: pointer;
  display: flex;
  margin-left: 0.2rem;
  opacity: 0;
  transition: opacity 0.15s ease-in-out;
}
.Timeline .timeline .wheel__slide .calendar-icon.show {
  opacity: 1;
  pointer-events: all;
}
.Timeline .timeline .wheel-buttons {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  z-index: 1;
}
.Timeline .timeline .wheel-buttons .wheel-button {
  align-items: center;
  color: #6c757d;
  display: flex;
}
.Timeline .timeline .wheel-buttons .wheel-button.left svg {
  transform: rotate(180deg);
}
.Timeline .timeline .wheel-buttons .wheel-button.active svg {
  fill: #4c75f2;
  stroke: none;
}
.Timeline .timeline .wheel-buttons .wheel-button.active svg:hover {
  fill: rgba(76, 117, 242, 0.6);
  stroke: none;
}
.Timeline .Calendar {
  align-items: center;
  display: flex;
  justify-content: center;
}
.Timeline .Calendar .react-calendar {
  border-radius: 5px;
  line-height: 2em;
}
.Timeline .Calendar .react-calendar *,
.Timeline .Calendar .react-calendar *::before,
.Timeline .Calendar .react-calendar *::after {
  box-sizing: border-box;
}
.Timeline .Calendar .react-calendar .react-calendar__navigation {
  margin-bottom: 1em;
}
.Timeline .Calendar .react-calendar button {
  border: 0;
  border-radius: 5px;
  margin: 0.125rem;
  outline: none;
}
.Timeline .Calendar .react-calendar button:enabled:hover {
  cursor: pointer;
}
.Timeline .Calendar .react-calendar__viewContainer {
  display: flex;
}
.Timeline .Calendar .react-calendar__navigation {
  font-size: 25px;
}
.Timeline .Calendar .react-calendar__navigation button {
  background-color: rgba(108, 117, 125, 0.062745098);
  color: #6c757d;
  min-width: 44px;
  padding: 1em 0.5em;
}
.Timeline .Calendar .react-calendar__navigation button:enabled:hover {
  background-color: rgba(108, 117, 125, 0.2509803922);
}
.Timeline .Calendar .react-calendar__navigation button:disabled {
  background: none;
}
.Timeline .Calendar .react-calendar__navigation button div {
  align-items: center;
  display: flex;
  justify-content: center;
}
.Timeline .Calendar .react-calendar__month-view__weekdays {
  font-size: 0.75em;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
}
.Timeline .Calendar .react-calendar__month-view__weekdays__weekday {
  padding: 0.5em;
}
.Timeline .Calendar .react-calendar__tile {
  background: none;
  color: #6c757d;
  max-width: 100%;
  padding: 1em 0.5em;
  text-align: center;
}
.Timeline .Calendar .react-calendar__tile:enabled {
  background-color: rgba(108, 117, 125, 0.062745098);
}
.Timeline .Calendar .react-calendar__tile:enabled.react-calendar__tile--now {
  background-color: #ffff76;
  color: #000;
}
.Timeline .Calendar .react-calendar__tile:enabled.react-calendar__tile--now:hover {
  background-color: #ffffa9;
}
.Timeline .Calendar .react-calendar__tile:enabled.react-calendar__tile--active, .Timeline .Calendar .react-calendar__tile:enabled.react-calendar__tile--hasActive {
  background-color: #006edc;
  color: #fff;
}
.Timeline .Calendar .react-calendar__tile:enabled.react-calendar__tile--active:hover, .Timeline .Calendar .react-calendar__tile:enabled.react-calendar__tile--hasActive:hover {
  background-color: #1087ff;
}
.Timeline .Calendar .react-calendar__tile:enabled.react-calendar__month-view__days__day--neighboringMonth {
  background-color: rgba(108, 117, 125, 0.0235294118);
  color: rgba(108, 117, 125, 0.6);
}
.Timeline .Calendar .react-calendar__tile:enabled:hover {
  background-color: rgba(108, 117, 125, 0.1254901961);
}
.Timeline .Calendar .react-calendar__month-view .react-calendar__tile {
  flex-basis: calc(14.2857142857% - 0.25rem) !important;
  max-width: calc(14.2857142857% - 0.25rem) !important;
}
.Timeline .Calendar .react-calendar__year-view .react-calendar__tile {
  flex-basis: calc(33.3333333333% - 0.25rem) !important;
  max-width: calc(33.3333333333% - 0.25rem) !important;
}
.Timeline .Calendar .react-calendar__month-view__days__day--weekend {
  color: #ff073a;
}
.Timeline .Calendar .react-calendar__year-view .react-calendar__tile,
.Timeline .Calendar .react-calendar__decade-view .react-calendar__tile,
.Timeline .Calendar .react-calendar__century-view .react-calendar__tile {
  color: #6c757d;
  padding: 2em 0.5em;
}

.button {
  background: rgba(0, 123, 255, 0.1254901961);
  border: 0;
  border-radius: 5px;
  color: rgba(0, 123, 255, 0.6);
  cursor: pointer;
  display: flex;
  flex-direction: row;
  font-size: 0.75rem;
  font-weight: 900;
  margin-bottom: 0.5rem;
  margin-top: 0.25rem;
  outline: none;
  padding: 0.5rem;
  text-decoration: none;
  text-transform: uppercase;
  transition: background 0.2s ease-in-out;
}
.button svg {
  padding-right: 6px;
  stroke-width: 2px;
  width: 20px;
}
.button.is-purple {
  background: rgba(32, 26, 162, 0.1254901961);
  color: rgba(32, 26, 162, 0.6);
}
.button.is-purple:hover {
  background: rgba(32, 26, 162, 0.1882352941);
}
.button.is-green {
  background: rgba(40, 167, 69, 0.1254901961);
  color: rgba(40, 167, 69, 0.6);
}
.button.is-green:hover {
  background: rgba(40, 167, 69, 0.1882352941);
}
.button:hover {
  background: rgba(0, 123, 255, 0.1882352941);
}
.button > * {
  align-self: center;
}

.MapSwitcher {
  align-self: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: absolute;
  width: 50%;
}
.MapSwitcher .highlight {
  pointer-events: none;
  position: absolute;
}
.MapSwitcher .highlight,
.MapSwitcher .clickable {
  border-radius: 5px;
  cursor: pointer;
  height: 14rem;
  width: 25%;
  z-index: 10;
}
.MapSwitcher .clickable {
  transition: background 0.15s ease-in-out;
}
.MapSwitcher .clickable:hover.is-confirmed {
  background: rgba(255, 7, 58, 0.1254901961);
}
.MapSwitcher .clickable:hover.is-active {
  background: rgba(0, 123, 255, 0.1254901961);
}
.MapSwitcher .clickable:hover.is-recovered {
  background: rgba(40, 167, 69, 0.1254901961);
}
.MapSwitcher .clickable:hover.is-deceased {
  background: rgba(108, 117, 125, 0.062745098);
}

.Level {
  align-self: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}
.Level .level-item {
  display: flex;
  flex-direction: column;
}
.Level .level-item > * {
  align-self: center;
}
.Level h1,
.Level h5 {
  margin-bottom: 0;
}
.Level h1 {
  font-size: min(3.75vw, 22px) !important;
  font-weight: 600;
}
.Level h4 {
  margin-bottom: -0.5rem;
}
.Level h5 {
  font-weight: 600;
  overflow-wrap: break-word;
  text-align: center;
  width: 100%;
}
.Level .is-confirmed h1,
.Level .is-confirmed h5 {
  color: #ff073a;
}
.Level .is-confirmed h4 {
  color: rgba(255, 7, 58, 0.6);
}
.Level .is-active h1,
.Level .is-active h5 {
  color: #007bff;
}
.Level .is-active h4 {
  color: rgba(0, 123, 255, 0.6);
}
.Level .is-recovered h1,
.Level .is-recovered h5 {
  color: #28a745;
}
.Level .is-recovered h4 {
  color: rgba(40, 167, 69, 0.6);
}
.Level .is-deceased h1,
.Level .is-deceased h5 {
  color: #6c757d;
}
.Level .is-deceased h4 {
  color: rgba(108, 117, 125, 0.6);
}
.Level .is-tested h1,
.Level .is-tested h5 {
  color: rgba(32, 26, 162, 0.8666666667);
}
.Level .is-tested h4 {
  color: rgba(32, 26, 162, 0.6);
}
.Level .is-vaccinated h1,
.Level .is-vaccinated h5 {
  color: #db5581;
}
.Level .is-vaccinated h4 {
  color: rgba(219, 85, 129, 0.6);
}
.Level .is-tpr h1,
.Level .is-tpr h5 {
  color: #fd7e14;
}
.Level .is-tpr h4 {
  color: rgba(253, 126, 20, 0.6);
}

.VaccinationHeader {
  align-items: center;
  align-self: center;
  display: flex;
  flex-direction: column;
  margin-bottom: 0.25rem;
  margin-top: 2rem;
  width: 100%;
}
.VaccinationHeader .level-vaccinated {
  align-items: center;
  align-self: center;
  animation-delay: 200ms;
  background: rgba(219, 85, 129, 0.1254901961);
  border-radius: 5px;
  color: #db5581;
  display: flex;
  flex-direction: row;
  margin-bottom: 0.5rem;
  padding: 0.5rem;
}
.VaccinationHeader .level-vaccinated div {
  font-size: 13px;
  font-weight: 500;
  margin: 0 0 0 0.25rem;
}
.VaccinationHeader .progress-bar-wrapper {
  color: #6c757d;
  font-size: 12px;
  margin-top: 0.5rem;
  position: relative;
  width: 100%;
}
.VaccinationHeader .progress-bar-wrapper .progress-bar {
  background-color: rgba(219, 85, 129, 0.1254901961);
  border-radius: 5px;
  color: #db5581;
  height: 24px;
  margin-bottom: 0.1rem;
  margin-top: 0.1rem;
  position: relative;
}
.VaccinationHeader .progress-bar-wrapper .progress-bar.value {
  background-image: linear-gradient(45deg, rgba(219, 85, 129, 0.6) 25%, rgba(219, 85, 129, 0.1254901961) 25%, rgba(219, 85, 129, 0.1254901961) 50%, rgba(219, 85, 129, 0.6) 50%, rgba(219, 85, 129, 0.6) 75%, rgba(219, 85, 129, 0.1254901961) 75%, rgba(219, 85, 129, 0.1254901961) 100%);
  background-size: 14px 14px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  margin: 0;
  opacity: 0.6;
  position: absolute;
}
.VaccinationHeader .progress-bar-wrapper .progress-bar.value.opaque {
  background: rgba(219, 85, 129, 0.6);
}
.VaccinationHeader .progress-bar-wrapper .progress-bar.value.highlighted {
  opacity: 1;
}
.VaccinationHeader .progress-bar-wrapper .progress-bar.value span {
  margin-left: calc(100% + 0.25rem);
  width: -webkit-max-content;
  width: max-content;
}
.VaccinationHeader .progress-bar-wrapper .legend {
  opacity: 0.6;
}
.VaccinationHeader .progress-bar-wrapper .legend.highlighted {
  opacity: 1;
}
.VaccinationHeader .progress-bar-wrapper .legend .label-wrapper {
  display: flex;
}
.VaccinationHeader .progress-bar-wrapper .legend .label-wrapper .label {
  cursor: pointer;
  flex-shrink: 0;
}
.VaccinationHeader .progress-bar-wrapper .legend .arrow {
  cursor: pointer;
  margin-bottom: 0.2rem;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}

abbr {
  text-decoration: none;
}
abbr.is-cherry {
  color: #ff073a;
}
abbr.is-blue {
  color: #007bff;
}
abbr.is-green {
  color: #28a745;
}
abbr.is-gray {
  color: #6c757d;
}

.TableLoader {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}

.Icons {
  font-size: 12px;
  font-weight: 600;
}
.Icons span {
  font-size: 8px;
  font-weight: 600;
  line-height: 6px;
  position: absolute;
  right: 5px;
  top: 5px;
  -webkit-user-select: none;
          user-select: none;
}

.table-top {
  align-items: flex-end;
  align-self: center;
  display: flex;
  flex-direction: row;
  font-weight: 600;
  justify-content: space-between;
  margin-bottom: 0.25rem;
  width: 100%;
}
.table-top .table-top-left {
  display: flex;
  flex-direction: row;
}
.table-top .toggle {
  align-items: center;
  background: rgba(108, 117, 125, 0.062745098);
  border-radius: 5px;
  color: rgba(108, 117, 125, 0.6);
  cursor: pointer;
  display: flex;
  height: 2.5rem;
  justify-content: center;
  margin-right: 0.25rem;
  -webkit-user-select: none;
          user-select: none;
  width: 2.5rem;
}
.table-top .toggle.disabled {
  cursor: not-allowed;
}
.table-top .toggle svg {
  margin: 0.25rem;
}
.table-top .toggle:hover:not(.disabled) {
  background: rgba(108, 117, 125, 0.1254901961);
}
.table-top .option-toggle.is-highlighted,
.table-top .expand-table-toggle.is-highlighted {
  background: rgba(40, 167, 69, 0.1254901961);
  color: #28a745;
}
.table-top .option-toggle.is-highlighted:hover,
.table-top .expand-table-toggle.is-highlighted:hover {
  background: rgba(40, 167, 69, 0.1882352941);
}
.table-top .info-toggle.is-highlighted {
  background: rgba(255, 193, 7, 0.1254901961);
  color: #ffc107;
}
.table-top .info-toggle.is-highlighted:hover {
  background: rgba(255, 193, 7, 0.1882352941);
}
.table-top .lakh-toggle.is-highlighted {
  background: rgba(219, 85, 129, 0.1254901961);
  color: #db5581;
}
.table-top .lakh-toggle.is-highlighted:hover {
  background: rgba(219, 85, 129, 0.1882352941);
}
.table-top .delta-toggle.is-highlighted {
  background: rgba(0, 123, 255, 0.1254901961);
  color: #007bff;
}
.table-top .delta-toggle.is-highlighted:hover {
  background: rgba(0, 123, 255, 0.1882352941);
}
.table-top .expand-table-toggle {
  color: rgba(108, 117, 125, 0.6);
  margin-left: auto;
  margin-right: 0;
}
.table-top .expand-table-toggle.is-highlighted svg {
  transform: rotate(90deg);
}
.table-top .expand-table-toggle svg {
  cursor: pointer;
  margin-bottom: 0.25rem;
  transform: rotate(-90deg);
  transition: transform 0.15s ease-in-out;
}
@media (min-width: 769px) {
  .table-top {
    margin-top: 1rem;
  }
}

.table-helper {
  align-self: center;
  color: #6c757d;
  display: flex;
  flex-direction: column;
  width: calc(100% - 2rem);
}
.table-helper h5 {
  color: rgba(108, 117, 125, 0.6);
}
.table-helper .helper-top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.table-helper .info-item {
  align-items: center;
  color: #6c757d;
  display: flex;
  flex-direction: row;
  font-size: 12px;
  font-weight: 600;
  height: 1.5rem;
}
.table-helper .info-item:first-child {
  margin-top: 1rem;
}
.table-helper .info-item :first-child {
  width: 1.6rem;
}
.table-helper .info-item :first-child svg {
  width: 15px;
}
.table-helper .info-item p {
  max-width: calc(100% - 1.6rem);
}
.table-helper .info-item svg {
  color: rgba(108, 117, 125, 0.6);
  margin-bottom: 0.25rem;
}
.table-helper .info-item .is-confirmed svg {
  color: #ff073a;
}
.table-helper .info-item .is-active svg {
  color: #007bff;
}
.table-helper .info-item .is-recovered svg {
  color: #28a745;
}
.table-helper .info-item .is-deceased svg {
  color: #6c757d;
}
.table-helper .info-item .is-tested svg {
  color: rgba(32, 26, 162, 0.8666666667);
}
.table-helper .info-item .is-vaccinated svg,
.table-helper .info-item .is-vaccinated1 svg,
.table-helper .info-item .is-vaccinated2 svg {
  color: #db5581;
}
.table-helper .info-item.notes svg {
  margin-bottom: 0;
}
.table-helper .info-item.sort svg {
  margin-bottom: 0;
}
.table-helper .info-item.abbr sup {
  position: relative;
  top: -0.4em;
  vertical-align: baseline;
}
.table-helper .text {
  color: rgba(108, 117, 125, 0.6);
  font-weight: 600;
}
.table-helper .text a {
  background: rgba(108, 117, 125, 0.062745098);
  border-bottom: 2px solid rgba(108, 117, 125, 0.1254901961);
  color: #6c757d;
  text-decoration: none;
}
.table-helper .text a:hover {
  background: rgba(108, 117, 125, 0.1254901961);
}

.table-container {
  align-self: center;
  overflow-x: auto;
  width: 100%;
}

.table {
  border-radius: 3px;
  display: inline-grid;
  font-size: 12px;
  grid-template-rows: auto;
  min-width: 100%;
}
.table .state-meta {
  grid-column: 1/-1;
  left: 0;
  position: -webkit-sticky;
  position: sticky;
}
.table .state-meta .state-meta-top {
  align-items: center;
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 1.25rem;
  margin-top: 1rem;
}
.table .state-meta .state-meta-top svg {
  margin-right: 0.5rem;
}
.table .state-meta .state-meta-top .last-updated {
  align-items: center;
  color: #28a745;
  display: flex;
  flex-direction: row;
}
.table .state-meta .state-meta-top .state-page {
  align-items: center;
  background: rgba(255, 193, 7, 0.1254901961);
  border-radius: 5px;
  color: #fd7e14;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  padding: 0.75rem;
}
.table .state-meta .state-meta-top .state-page p {
  align-self: flex-end;
  flex: 1 1;
  margin: 0;
  text-align: right;
}
.table .state-meta .state-meta-top .state-page:hover {
  background: rgba(255, 193, 7, 0.1882352941);
}
.table .state-meta .state-meta-bottom {
  padding-bottom: 1.5rem;
}
.table .state-meta .state-meta-bottom .disclaimer {
  background: rgba(226, 48, 40, 0.062745098);
  border-radius: 5px;
  color: #e23028;
  margin: auto;
  padding: 1rem 0.25rem;
  text-align: center;
  width: 16rem;
}
.table .state-meta .state-meta-bottom .disclaimer svg {
  margin-right: 0.5rem;
}
.table .row {
  cursor: pointer;
  display: contents;
  width: 100%;
}
.table .row:nth-child(odd) .cell {
  background: rgba(108, 117, 125, 0.062745098);
}
.table .row.is-highlighted .cell {
  background: #edeeef !important;
}
.table .row.heading .cell {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.table .row.heading .cell:hover {
  background: #edeeef !important;
}
.table .row.is-total {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}
.table .row.is-total .cell {
  background: #edeeef !important;
  padding-bottom: 0.75rem;
}
.table .row .cell {
  align-items: center;
  border-radius: 3px;
  color: #6c757d;
  display: flex;
  flex-direction: row;
  margin-bottom: 0.25rem;
  padding: 0.5rem;
  position: relative;
}
.table .row .cell:not(:first-child) {
  flex-basis: 4rem;
  flex-grow: 1;
  flex-shrink: 0;
  justify-content: flex-end;
}
.table .row .cell:first-child {
  background: #f6f6f7;
  flex-basis: 7rem;
  flex-grow: 0;
  flex-shrink: 0;
  justify-content: space-between;
  left: 0;
  position: -webkit-sticky;
  position: sticky;
  z-index: 11;
}
.table .row .cell:first-child .sort-icon {
  left: auto;
  left: initial;
  right: 0;
}
.table .row .cell svg {
  color: rgba(108, 117, 125, 0.6);
  margin-left: 0.2rem;
  stroke-width: 2.5px;
}
.table .row .cell .sort-icon {
  left: 0;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
  position: absolute;
  top: 0;
}
.table .row .cell .sort-icon.is-confirmed svg {
  color: #ff073a;
}
.table .row .cell .sort-icon.is-active svg {
  color: #007bff;
}
.table .row .cell .sort-icon.is-recovered svg {
  color: #28a745;
}
.table .row .cell .sort-icon.is-deceased svg {
  color: #6c757d;
}
.table .row .cell .sort-icon.is-tested svg {
  color: rgba(32, 26, 162, 0.8666666667);
}
.table .row .cell .sort-icon.is-vaccinated svg, .table .row .cell .sort-icon.is-vaccinated1 svg, .table .row .cell .sort-icon.is-vaccinated2 svg {
  color: #db5581;
}
.table .row .cell.statistic {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.table .row .cell.statistic .total {
  font-size: 14px;
}
.table .row .cell.statistic .is-confirmed {
  color: #ff073a;
}
.table .row .cell.statistic .is-active {
  color: #007bff;
}
.table .row .cell.statistic .is-recovered {
  color: #28a745;
}
.table .row .cell.statistic .is-deceased {
  color: #6c757d;
}
.table .row .cell.statistic .is-tested {
  color: rgba(32, 26, 162, 0.8666666667);
}
.table .row .cell.statistic .is-vaccinated,
.table .row .cell.statistic .is-vaccinated1,
.table .row .cell.statistic .is-vaccinated2 {
  color: #db5581;
}
.table .row .cell:not(:last-child) {
  margin-right: 0.25rem;
}
.table .row .cell.heading {
  background: #f6f6f7;
  font-size: 13px;
  font-weight: 900;
  padding: 1.25rem 0.5rem 0.75rem;
  text-align: right;
}
.table .row .cell.heading.state {
  padding: 1.5rem 0.5rem 0.75rem;
}
.table .row .cell.heading.state .sort-icon {
  top: 0.5rem;
}
.table .row .cell.heading:hover {
  background: #edeeef !important;
}
.table .row .cell.heading svg {
  margin-left: 0;
  margin-right: 0.3rem;
}
.table .row .cell .state-name,
.table .row .cell .district-name {
  font-size: 14px;
  font-weight: 600;
  max-width: 7rem;
  word-wrap: break-word;
}
.table .spacer-row {
  grid-column: 1/-1;
  left: 0;
  position: -webkit-sticky;
  position: sticky;
}
.table .spacer-row .spacer {
  color: rgba(108, 117, 125, 0.6);
  margin-bottom: 1.25rem;
  margin-top: 1rem;
  text-align: center;
}
.table .spacer-row .spacer p {
  margin-left: auto;
  margin-right: auto;
  width: 10rem;
}
.table .spacer-row .spacer .fold {
  cursor: pointer;
}
.table .spacer-row .spacer .fold:hover {
  color: #6c757d;
}
.table .intersection {
  display: block;
}

.Table {
  display: flex;
  flex-direction: column;
  margin-bottom: 2.5rem;
}

.paginate {
  align-items: center;
  color: #6c757d;
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}
.paginate div {
  background: rgba(108, 117, 125, 0.062745098);
  border-radius: 5px;
  color: rgba(108, 117, 125, 0.6);
  cursor: pointer;
  display: flex;
  padding: 0.5rem;
}
.paginate div.left {
  margin-right: 1rem;
}
.paginate div.right {
  margin-left: 1rem;
}
.paginate div:hover:not(.disabled) {
  background: rgba(108, 117, 125, 0.1254901961);
}
.paginate h5 {
  margin: 0;
}

#chart {
  z-index: 10;
}

.anchor {
  cursor: pointer;
  position: absolute;
  right: 0;
  -webkit-user-select: none;
          user-select: none;
  z-index: 999;
}
.anchor svg {
  color: rgba(108, 117, 125, 0.6);
  transform: rotate(45deg);
  transition: all 0.1s ease-in-out;
}
.anchor svg:hover {
  color: #6c757d;
}
.anchor.stickied svg {
  color: #6c757d;
  transform: rotate(90deg);
}

.map-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.map-container.stickied {
  position: -webkit-sticky;
  position: sticky;
  top: -6rem;
}

.MapExplorer {
  align-self: center;
  position: relative;
  width: 100%;
}
.MapExplorer.stickied {
  position: -webkit-sticky !important;
  position: sticky !important;
  top: 0;
}
.MapExplorer.hidden {
  display: none;
}
.MapExplorer .anchor {
  top: -1.5rem;
}
.MapExplorer .svg-parent {
  display: block;
  margin: auto;
  margin-top: 2rem;
  overflow: visible;
  position: relative;
  width: 90%;
}
.MapExplorer .svg-parent.maplegend {
  margin-top: 0.6rem;
  -webkit-user-select: none;
          user-select: none;
  z-index: 1;
}
.MapExplorer .svg-parent svg {
  align-self: center;
  height: 100%;
  overflow: visible;
  width: 100%;
}
.MapExplorer .svg-parent svg text {
  fill: #6c757d;
  font-weight: 600;
  text-align: right;
}
.MapExplorer .map-button {
  background: rgba(255, 193, 7, 0.1254901961);
  border-radius: 5px;
  color: #fd7e14;
  cursor: pointer;
  font-size: 0.75rem;
  font-weight: 900;
  margin-bottom: 0.25rem;
  padding: 0.5rem;
  position: absolute;
  right: 0;
  transition: all 0.2s ease-in-out;
}
.MapExplorer .map-button:hover {
  background: rgba(255, 193, 7, 0.1882352941);
}
.MapExplorer .map-button svg {
  height: 12px;
  margin-left: 0.25rem;
  stroke: rgba(253, 126, 20, 0.6);
  stroke-width: 3px;
  vertical-align: middle;
  width: 12px;
}
.MapExplorer .panel {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  min-height: 6rem;
  padding-top: 1rem;
  position: relative;
}
.MapExplorer .panel h2 {
  font-weight: 900;
  margin-top: 0;
  transition: color 0.3s ease-in-out;
  word-wrap: break-word;
}
.MapExplorer .panel h2.confirmed {
  color: #e23028;
}
.MapExplorer .panel h2.active {
  color: #007bff;
}
.MapExplorer .panel h2.recovered {
  color: #28a745;
}
.MapExplorer .panel h2.deceased {
  color: #6c757d;
}
.MapExplorer .panel h4 {
  color: rgba(108, 117, 125, 0.6);
  margin: 0;
  word-wrap: break-word;
}
.MapExplorer .panel .panel-left {
  display: flex;
  flex: 1 1;
  flex-direction: column;
}
.MapExplorer .panel .panel-left .district {
  line-height: 15px;
  margin: 0;
  transition: color 0.3s ease-in-out;
}
.MapExplorer .panel .panel-left .district span {
  font-size: 0.75rem;
  font-weight: 600;
}
.MapExplorer .panel .panel-left .district.confirmed {
  color: #e23028;
}
.MapExplorer .panel .panel-left .district.active {
  color: #007bff;
}
.MapExplorer .panel .panel-left .district.recovered {
  color: #28a745;
}
.MapExplorer .panel .panel-left .district.deceased {
  color: #6c757d;
}
.MapExplorer .panel .panel-left .district.tested {
  color: rgba(32, 26, 162, 0.8666666667);
}
.MapExplorer .panel .panel-right {
  color: rgba(108, 117, 125, 0.6);
  display: flex;
  flex-direction: column;
}
.MapExplorer .panel .panel-right .disabled {
  cursor: not-allowed !important;
}
.MapExplorer .panel .panel-right svg {
  transition: all 0.3s ease-in-out;
}
.MapExplorer .panel .panel-right .is-highlighted {
  background: rgba(108, 117, 125, 0.1882352941) !important;
}
.MapExplorer .panel .panel-right .is-highlighted:hover:not(.disabled) {
  background: rgba(108, 117, 125, 0.1254901961) !important;
}
.MapExplorer .panel .panel-right.is-confirmed {
  color: rgba(255, 7, 58, 0.6);
}
.MapExplorer .panel .panel-right.is-confirmed .is-highlighted {
  background: rgba(255, 7, 58, 0.1254901961) !important;
}
.MapExplorer .panel .panel-right.is-confirmed .is-highlighted:hover:not(.disabled) {
  background: rgba(255, 7, 58, 0.1882352941) !important;
}
.MapExplorer .panel .panel-right.is-active {
  color: rgba(0, 123, 255, 0.6);
}
.MapExplorer .panel .panel-right.is-active .is-highlighted {
  background: rgba(0, 123, 255, 0.1254901961) !important;
}
.MapExplorer .panel .panel-right.is-active .is-highlighted:hover:not(.disabled) {
  background: rgba(0, 123, 255, 0.1882352941) !important;
}
.MapExplorer .panel .panel-right.is-recovered {
  color: rgba(40, 167, 69, 0.6);
}
.MapExplorer .panel .panel-right.is-recovered .is-highlighted {
  background: rgba(40, 167, 69, 0.1254901961) !important;
}
.MapExplorer .panel .panel-right.is-recovered .is-highlighted:hover:not(.disabled) {
  background: rgba(40, 167, 69, 0.1882352941) !important;
}
.MapExplorer .panel .panel-right.is-deceased {
  color: rgba(108, 117, 125, 0.6);
}
.MapExplorer .panel .panel-right.is-deceased .is-highlighted {
  background: rgba(108, 117, 125, 0.1882352941) !important;
}
.MapExplorer .panel .panel-right.is-deceased .is-highlighted:hover:not(.disabled) {
  background: rgba(108, 117, 125, 0.1254901961) !important;
}
.MapExplorer .panel .panel-right.is-tpr, .MapExplorer .panel .panel-right.is-cfr, .MapExplorer .panel .panel-right.is-other {
  color: rgba(253, 126, 20, 0.6);
}
.MapExplorer .panel .panel-right.is-tpr .is-highlighted, .MapExplorer .panel .panel-right.is-cfr .is-highlighted, .MapExplorer .panel .panel-right.is-other .is-highlighted {
  background: rgba(253, 126, 20, 0.1254901961) !important;
}
.MapExplorer .panel .panel-right.is-tpr .is-highlighted:hover:not(.disabled), .MapExplorer .panel .panel-right.is-cfr .is-highlighted:hover:not(.disabled), .MapExplorer .panel .panel-right.is-other .is-highlighted:hover:not(.disabled) {
  background: rgba(253, 126, 20, 0.1882352941) !important;
}
.MapExplorer .panel .panel-right.is-tested {
  color: rgba(32, 26, 162, 0.6);
}
.MapExplorer .panel .panel-right.is-tested .is-highlighted {
  background: rgba(32, 26, 162, 0.1254901961) !important;
}
.MapExplorer .panel .panel-right.is-tested .is-highlighted:hover:not(.disabled) {
  background: rgba(32, 26, 162, 0.1882352941) !important;
}
.MapExplorer .panel .panel-right.is-vaccinated, .MapExplorer .panel .panel-right.is-vaccinated1, .MapExplorer .panel .panel-right.is-vaccinated2 {
  color: rgba(219, 85, 129, 0.6);
}
.MapExplorer .panel .panel-right.is-vaccinated .is-highlighted, .MapExplorer .panel .panel-right.is-vaccinated1 .is-highlighted, .MapExplorer .panel .panel-right.is-vaccinated2 .is-highlighted {
  background: rgba(219, 85, 129, 0.1254901961) !important;
}
.MapExplorer .panel .panel-right.is-vaccinated .is-highlighted:hover:not(.disabled), .MapExplorer .panel .panel-right.is-vaccinated1 .is-highlighted:hover:not(.disabled), .MapExplorer .panel .panel-right.is-vaccinated2 .is-highlighted:hover:not(.disabled) {
  background: rgba(219, 85, 129, 0.1882352941) !important;
}
.MapExplorer .panel .panel-right.is-population {
  color: rgba(182, 133, 77, 0.6);
}
.MapExplorer .panel .panel-right.is-population .is-highlighted {
  background: rgba(182, 133, 77, 0.1254901961) !important;
}
.MapExplorer .panel .panel-right.is-population .is-highlighted:hover:not(.disabled) {
  background: rgba(182, 133, 77, 0.1882352941) !important;
}
.MapExplorer .panel .panel-right .switch-type,
.MapExplorer .panel .panel-right .switch-statistic {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: 0.25rem;
}
.MapExplorer .panel .panel-right .switch-type .toggle,
.MapExplorer .panel .panel-right .switch-statistic .toggle {
  align-items: center;
  background: rgba(108, 117, 125, 0.062745098);
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  height: 2.5rem;
  justify-content: center;
  margin-left: 0.25rem;
  -webkit-user-select: none;
          user-select: none;
  width: 2.5rem;
}
.MapExplorer .panel .panel-right .switch-type .toggle.back,
.MapExplorer .panel .panel-right .switch-statistic .toggle.back {
  margin-right: 0 !important;
}
.MapExplorer .panel .panel-right .switch-type .toggle.back svg,
.MapExplorer .panel .panel-right .switch-statistic .toggle.back svg {
  fill: #6c757d;
  stroke: transparent;
}
.MapExplorer .panel .panel-right .switch-type .toggle:hover:not(.disabled),
.MapExplorer .panel .panel-right .switch-statistic .toggle:hover:not(.disabled) {
  background: rgba(108, 117, 125, 0.1254901961);
}
.MapExplorer .panel .panel-right .switch-type .toggle svg,
.MapExplorer .panel .panel-right .switch-statistic .toggle svg {
  height: 100%;
}
.MapExplorer .panel .panel-right .switch-type .divider,
.MapExplorer .panel .panel-right .switch-statistic .divider {
  background: rgba(108, 117, 125, 0.1254901961);
  border-radius: 5px;
  margin-left: 0.25rem;
  width: 2px !important;
}
.MapExplorer .panel .panel-right .switch-statistic {
  align-self: flex-end;
  flex-direction: row;
  position: absolute;
  top: 5rem;
}
.MapExplorer .panel .panel-right .switch-statistic .statistic-option {
  background: none;
  display: flex;
  flex-direction: row;
  height: 1.25rem;
  margin-bottom: 0.25rem;
  margin-left: 0.65rem !important;
  width: 1.25rem;
}
.MapExplorer .panel .panel-right .switch-statistic .statistic-option span {
  position: absolute;
}
.MapExplorer .panel .panel-right .switch-statistic .statistic-option:hover {
  background: none;
}
.MapExplorer .panel .panel-right .switch-statistic .statistic-option svg {
  fill: rgba(108, 117, 125, 0.1254901961);
  stroke: none;
}
.MapExplorer .panel .panel-right .switch-statistic .statistic-option.is-highlighted svg {
  fill: #6c757d;
  transform: scale(1.25);
}
.MapExplorer .panel .panel-right .switch-statistic .statistic-option.is-confirmed svg {
  fill: rgba(255, 7, 58, 0.1882352941);
}
.MapExplorer .panel .panel-right .switch-statistic .statistic-option.is-confirmed.is-highlighted svg {
  fill: #ff073a;
}
.MapExplorer .panel .panel-right .switch-statistic .statistic-option.is-active svg {
  fill: rgba(0, 123, 255, 0.1882352941);
}
.MapExplorer .panel .panel-right .switch-statistic .statistic-option.is-active.is-highlighted svg {
  fill: #007bff;
}
.MapExplorer .panel .panel-right .switch-statistic .statistic-option.is-recovered svg {
  fill: rgba(40, 167, 69, 0.1882352941);
}
.MapExplorer .panel .panel-right .switch-statistic .statistic-option.is-recovered.is-highlighted svg {
  fill: #28a745;
}
.MapExplorer .panel .panel-right .switch-statistic .statistic-option.is-deceased svg {
  fill: rgba(108, 117, 125, 0.1254901961);
}
.MapExplorer .panel .panel-right .switch-statistic .statistic-option.is-deceased.is-highlighted svg {
  fill: #6c757d;
}
.MapExplorer .panel .panel-right .switch-statistic .statistic-option.is-vaccinated svg {
  fill: rgba(219, 85, 129, 0.1882352941);
}
.MapExplorer .panel .panel-right .switch-statistic .statistic-option.is-vaccinated.is-highlighted svg {
  fill: #db5581;
}
.MapExplorer .panel.bottom {
  margin-top: 0;
  padding-top: 0;
}
.MapExplorer #legend,
.MapExplorer #legend-choro {
  position: absolute;
}
.MapExplorer #chart:not(.zone),
.MapExplorer #legend:not(.zone),
.MapExplorer #legend-choro:not(.zone) {
  filter: saturate(1.5);
}
.MapExplorer #chart.zone,
.MapExplorer #legend.zone,
.MapExplorer #legend-choro.zone {
  filter: saturate(1.25);
}
.MapExplorer .disclaimer {
  align-items: center;
  -webkit-backdrop-filter: saturate(180%) blur(20px);
          backdrop-filter: saturate(180%) blur(20px);
  border-radius: 5px;
  bottom: 50%;
  display: flex;
  flex-direction: row;
  font-size: 12px;
  left: 0;
  margin-left: auto;
  margin-right: auto;
  padding: 0.5rem;
  pointer-events: none;
  position: absolute;
  right: 0;
  transition: background, color 0.3s ease-in-out;
  width: 10rem;
  z-index: 99;
}
.MapExplorer .disclaimer.is-confirmed {
  background: rgba(255, 7, 58, 0.1254901961);
  color: #ff073a;
}
.MapExplorer .disclaimer.is-active {
  background: rgba(0, 123, 255, 0.1254901961);
  color: #007bff;
}
.MapExplorer .disclaimer.is-recovered {
  background: rgba(40, 167, 69, 0.1254901961);
  color: #28a745;
}
.MapExplorer .disclaimer.is-deceased {
  background: rgba(108, 117, 125, 0.062745098);
  color: #6c757d;
}
.MapExplorer .disclaimer span {
  flex: 1 1;
}
.MapExplorer .disclaimer svg {
  align-self: flex-start;
  margin-right: 0.5rem;
  stroke-width: 2px;
  width: 16px;
}
.MapExplorer .footnote {
  color: #6c757d;
  margin-bottom: 0;
  margin-top: 1em;
  text-align: left;
  z-index: 1;
}
.MapExplorer .footnote a {
  border-bottom: 2px solid rgba(108, 117, 125, 0.1254901961);
  text-decoration: none;
}
.MapExplorer .footnote a:hover {
  background: rgba(108, 117, 125, 0.1254901961);
}

.tabs {
  display: flex;
  flex-direction: row;
  position: relative;
}
.tabs .tab {
  background: rgba(108, 117, 125, 0.062745098);
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  color: rgba(108, 117, 125, 0.6);
  cursor: pointer;
  height: 3.25rem;
  margin-right: 0.25rem;
  min-width: 5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  text-align: center;
}
.tabs .tab:hover {
  background: rgba(108, 117, 125, 0.1254901961);
}
.tabs .tab.focused {
  background: #f1f1f1;
  color: #6c757d;
}

.tabs-map {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  position: relative;
  z-index: 99;
}
.tabs-map h4 {
  display: table-cell;
  font-size: 12px !important;
  font-weight: 900;
  height: 2rem;
  margin-bottom: 0;
  margin-top: 0;
  vertical-align: middle;
}
.tabs-map .tab {
  background: rgba(108, 117, 125, 0.062745098);
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  color: rgba(108, 117, 125, 0.6);
  cursor: pointer;
  height: 2rem;
  margin-right: 0.25rem;
  margin-top: 0.25rem;
  min-width: 1.6rem;
  padding-left: 1rem;
  padding-right: 1rem;
  text-align: center;
  transition: all 0.3s ease-in-out;
}
.tabs-map .tab:hover {
  background: rgba(108, 117, 125, 0.1254901961);
}
.tabs-map .tab.focused {
  background: #f1f1f1;
  color: #6c757d;
}
.tabs-map .tab.disabled {
  background: #f1f1f1;
  color: rgba(108, 117, 125, 0.6);
}
.tabs-map sup {
  position: relative;
  top: -0.5em;
  vertical-align: top;
}

.TimeseriesExplorer {
  align-self: center;
  display: flex;
  flex-direction: column;
  width: calc(100% - 2rem);
}
.TimeseriesExplorer.stickied {
  position: -webkit-sticky !important;
  position: sticky !important;
  top: -6.5rem;
}
.TimeseriesExplorer .alert {
  align-self: flex-end;
  margin: 0;
  margin-top: 1rem;
}
.TimeseriesExplorer .state-selection {
  display: flex;
  flex-direction: row;
  margin-top: 1rem;
  max-width: calc(100% - 0.6rem);
}
.TimeseriesExplorer .state-selection .dropdown {
  min-width: 60%;
}
.TimeseriesExplorer .state-selection .dropdown select {
  -webkit-appearance: none;
          appearance: none;
  background-color: #eee;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position-x: calc(100% - 0.4rem);
  background-position-y: 50%;
  background-repeat: no-repeat;
  background-size: 0.6rem;
  border: 2px solid #e8e8e9;
  border-radius: 4px;
  color: #6c757d;
  cursor: pointer;
  font-weight: 600;
  padding: 0.5rem;
  padding-right: 1.4rem;
  width: 100%;
}
.TimeseriesExplorer .state-selection .dropdown select:focus {
  outline: none;
}
.TimeseriesExplorer .state-selection .reset-icon {
  margin: auto;
  margin-left: 0.75rem;
  margin-top: 0.5rem;
}
.TimeseriesExplorer .state-selection .reset-icon svg {
  color: rgba(108, 117, 125, 0.6);
  cursor: pointer;
  fill: #a6abb0;
  stroke: #a6abb0;
  stroke-width: 0.5;
  width: 16px;
}
.TimeseriesExplorer .state-selection .reset-icon svg:hover {
  fill: #6c757d;
  stroke: #6c757d;
}

.Timeseries {
  align-self: center;
  width: 100%;
}
.Timeseries .svg-parent {
  height: 12rem;
  margin-bottom: 1rem;
}
.Timeseries .svg-parent.is-confirmed .stem {
  stroke: rgba(255, 7, 58, 0.6);
}
.Timeseries .svg-parent.is-confirmed .trend-area {
  fill: rgba(255, 7, 58, 0.6);
}
.Timeseries .svg-parent.is-active .stem {
  stroke: rgba(0, 123, 255, 0.6);
}
.Timeseries .svg-parent.is-active .trend-area {
  fill: rgba(0, 123, 255, 0.6);
}
.Timeseries .svg-parent.is-recovered .stem {
  stroke: rgba(40, 167, 69, 0.6);
}
.Timeseries .svg-parent.is-recovered .trend-area {
  fill: rgba(40, 167, 69, 0.6);
}
.Timeseries .svg-parent.is-deceased .stem {
  stroke: rgba(108, 117, 125, 0.6);
}
.Timeseries .svg-parent.is-deceased .trend-area {
  fill: rgba(108, 117, 125, 0.6);
}
.Timeseries .svg-parent.is-tested .stem {
  stroke: rgba(32, 26, 162, 0.6);
}
.Timeseries .svg-parent.is-tested .trend-area {
  fill: rgba(32, 26, 162, 0.6);
}
.Timeseries .svg-parent.is-vaccinated .stem {
  stroke: rgba(219, 85, 129, 0.6);
}
.Timeseries .svg-parent.is-vaccinated .trend-area {
  fill: rgba(219, 85, 129, 0.6);
}
.Timeseries .svg-parent.is-tpr .stem {
  stroke: rgba(253, 126, 20, 0.6);
}
.Timeseries .svg-parent.is-tpr .trend-area {
  fill: rgba(253, 126, 20, 0.6);
}
.Timeseries .svg-parent.is-brush {
  height: 4rem;
}
.Timeseries .svg-parent svg {
  width: 100%;
}

.timeseries-header {
  align-self: center;
  position: relative;
  width: 100%;
}
.timeseries-header h1 {
  color: #6c757d;
  margin: 0;
  margin-bottom: 2rem;
  text-align: center;
}
.timeseries-header .timeseries-options {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 1rem;
}
.timeseries-header .timeseries-options .timeseries-mode {
  display: flex;
  flex-direction: row;
}
.timeseries-header .timeseries-options .scale-modes {
  align-items: flex-end;
  bottom: 0;
  color: #6c757d;
  display: flex;
  flex-direction: row;
  right: 0;
  z-index: 99;
}
.timeseries-header .timeseries-options .scale-modes:hover label.main {
  color: #6c757d;
}
.timeseries-header .timeseries-options .scale-modes .timeseries-mode {
  margin-left: 1rem;
}
.timeseries-header .timeseries-options .scale-modes > * {
  align-self: center;
}
.timeseries-header .timeseries-options label {
  color: rgba(108, 117, 125, 0.6);
  font-size: 0.75rem;
  font-weight: 900;
  margin-right: 0.25rem;
  z-index: 99;
}

.disabled input.switch {
  background: rgba(108, 117, 125, 0.062745098) !important;
  border: rgba(108, 117, 125, 0.062745098) 2px solid !important;
  cursor: not-allowed !important;
}
.disabled input.switch::after {
  background: rgba(108, 117, 125, 0.062745098) !important;
}

input.switch {
  -webkit-appearance: none;
          appearance: none;
  background-color: #fff;
  border: 2px solid #d9dadc;
  border-radius: 10px;
  cursor: pointer;
  height: 14px;
  margin: 0;
  outline: none;
  position: relative;
  transition: all 300ms ease-in-out;
  width: 24px;
}
input.switch::after {
  background-color: rgba(108, 117, 125, 0.6);
  border-radius: 50%;
  content: "";
  height: 10px;
  left: 0;
  position: absolute;
  top: 0;
  transition: all 300ms ease-in-out;
  width: 10px;
}
input.switch:checked {
  background-color: rgba(108, 117, 125, 0.6);
  transition: all 300ms ease-in-out;
}
input.switch:checked::after {
  background-color: #f8f9fa;
  left: 10px;
  transition: all 300ms ease-in-out;
}

.Timeseries,
.Minigraph {
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  width: 100%;
}
.Timeseries .stats,
.Minigraph .stats {
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  left: 0.5rem;
  padding: 0.25rem;
  pointer-events: none;
  position: absolute;
  top: 0.5rem;
}
.Timeseries .stats .stats-bottom,
.Minigraph .stats .stats-bottom {
  display: flex;
  flex-direction: row;
}
.Timeseries .stats .stats-bottom h6,
.Minigraph .stats .stats-bottom h6 {
  margin-bottom: 0.1rem;
  margin-left: 0.25rem;
}
.Timeseries .stats .stats-bottom > *,
.Minigraph .stats .stats-bottom > * {
  margin-top: auto;
}
.Timeseries .stats h2,
.Timeseries .stats h5,
.Timeseries .stats h6,
.Minigraph .stats h2,
.Minigraph .stats h5,
.Minigraph .stats h6 {
  margin: 0;
  transition: all 0.15s ease-in-out;
}
.Timeseries .stats h5,
.Minigraph .stats h5 {
  color: rgba(255, 7, 58, 0.6);
}
.Timeseries .stats h5.title,
.Minigraph .stats h5.title {
  color: rgba(255, 7, 58, 0.6);
}
.Timeseries .stats h2,
.Timeseries .stats h6,
.Minigraph .stats h2,
.Minigraph .stats h6 {
  color: #ff073a;
}
.Timeseries .stats.is-recovered h5,
.Minigraph .stats.is-recovered h5 {
  color: rgba(40, 167, 69, 0.6);
}
.Timeseries .stats.is-recovered h5.title,
.Minigraph .stats.is-recovered h5.title {
  color: rgba(40, 167, 69, 0.6);
}
.Timeseries .stats.is-recovered h2,
.Timeseries .stats.is-recovered h6,
.Minigraph .stats.is-recovered h2,
.Minigraph .stats.is-recovered h6 {
  color: #28a745;
}
.Timeseries .stats.is-deceased h5,
.Minigraph .stats.is-deceased h5 {
  color: rgba(108, 117, 125, 0.6);
}
.Timeseries .stats.is-deceased h5.title,
.Minigraph .stats.is-deceased h5.title {
  color: rgba(108, 117, 125, 0.6);
}
.Timeseries .stats.is-deceased h2,
.Timeseries .stats.is-deceased h6,
.Minigraph .stats.is-deceased h2,
.Minigraph .stats.is-deceased h6 {
  color: #6c757d;
}
.Timeseries .stats.is-active h5,
.Minigraph .stats.is-active h5 {
  color: rgba(0, 123, 255, 0.6);
}
.Timeseries .stats.is-active h5.title,
.Minigraph .stats.is-active h5.title {
  color: rgba(0, 123, 255, 0.6);
}
.Timeseries .stats.is-active h2,
.Timeseries .stats.is-active h6,
.Minigraph .stats.is-active h2,
.Minigraph .stats.is-active h6 {
  color: #007bff;
}
.Timeseries .stats.is-tested h5,
.Minigraph .stats.is-tested h5 {
  color: rgba(32, 26, 162, 0.6);
}
.Timeseries .stats.is-tested h5.title,
.Minigraph .stats.is-tested h5.title {
  color: rgba(32, 26, 162, 0.6);
}
.Timeseries .stats.is-tested h2,
.Timeseries .stats.is-tested h6,
.Minigraph .stats.is-tested h2,
.Minigraph .stats.is-tested h6 {
  color: rgba(32, 26, 162, 0.8666666667);
}
.Timeseries .stats.is-vaccinated h5,
.Minigraph .stats.is-vaccinated h5 {
  color: rgba(219, 85, 129, 0.6);
}
.Timeseries .stats.is-vaccinated h5.title,
.Minigraph .stats.is-vaccinated h5.title {
  color: rgba(219, 85, 129, 0.6);
}
.Timeseries .stats.is-vaccinated h2,
.Timeseries .stats.is-vaccinated h6,
.Minigraph .stats.is-vaccinated h2,
.Minigraph .stats.is-vaccinated h6 {
  color: #db5581;
}
.Timeseries .stats.is-tpr h5,
.Minigraph .stats.is-tpr h5 {
  color: rgba(253, 126, 20, 0.6);
}
.Timeseries .stats.is-tpr h5.title,
.Minigraph .stats.is-tpr h5.title {
  color: rgba(253, 126, 20, 0.6);
}
.Timeseries .stats.is-tpr h2,
.Timeseries .stats.is-tpr h6,
.Minigraph .stats.is-tpr h2,
.Minigraph .stats.is-tpr h6 {
  color: #fd7e14;
}
.Timeseries .svg-parent,
.Minigraph .svg-parent {
  align-self: center;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
}
.Timeseries .svg-parent svg .domain,
.Timeseries .svg-parent svg .tick,
.Minigraph .svg-parent svg .domain,
.Minigraph .svg-parent svg .tick {
  stroke-width: 1.5;
}
.Timeseries .svg-parent svg .domain line,
.Timeseries .svg-parent svg .tick line,
.Minigraph .svg-parent svg .domain line,
.Minigraph .svg-parent svg .tick line {
  stroke-width: 1.5;
}
.Timeseries .svg-parent svg text,
.Minigraph .svg-parent svg text {
  font-size: 9px;
  font-weight: 600;
  stroke: transparent;
}
.Timeseries .svg-parent.is-confirmed,
.Minigraph .svg-parent.is-confirmed {
  background: rgba(255, 7, 58, 0.1254901961);
}
.Timeseries .svg-parent.is-confirmed svg .domain,
.Timeseries .svg-parent.is-confirmed svg .tick,
.Timeseries .svg-parent.is-confirmed svg line,
.Minigraph .svg-parent.is-confirmed svg .domain,
.Minigraph .svg-parent.is-confirmed svg .tick,
.Minigraph .svg-parent.is-confirmed svg line {
  stroke: #ff073a;
}
.Timeseries .svg-parent.is-confirmed svg text,
.Minigraph .svg-parent.is-confirmed svg text {
  color: rgba(255, 7, 58, 0.6);
}
.Timeseries .svg-parent.is-recovered,
.Minigraph .svg-parent.is-recovered {
  background: rgba(40, 167, 69, 0.1254901961);
}
.Timeseries .svg-parent.is-recovered svg .domain,
.Timeseries .svg-parent.is-recovered svg .tick,
.Timeseries .svg-parent.is-recovered svg line,
.Minigraph .svg-parent.is-recovered svg .domain,
.Minigraph .svg-parent.is-recovered svg .tick,
.Minigraph .svg-parent.is-recovered svg line {
  stroke: #28a745;
}
.Timeseries .svg-parent.is-recovered svg text,
.Minigraph .svg-parent.is-recovered svg text {
  color: rgba(40, 167, 69, 0.6);
}
.Timeseries .svg-parent.is-deceased,
.Minigraph .svg-parent.is-deceased {
  background: rgba(108, 117, 125, 0.062745098);
}
.Timeseries .svg-parent.is-deceased svg .domain,
.Timeseries .svg-parent.is-deceased svg .tick,
.Timeseries .svg-parent.is-deceased svg line,
.Minigraph .svg-parent.is-deceased svg .domain,
.Minigraph .svg-parent.is-deceased svg .tick,
.Minigraph .svg-parent.is-deceased svg line {
  stroke: #6c757d;
}
.Timeseries .svg-parent.is-deceased svg text,
.Minigraph .svg-parent.is-deceased svg text {
  color: rgba(108, 117, 125, 0.6);
}
.Timeseries .svg-parent.is-active,
.Minigraph .svg-parent.is-active {
  background: rgba(0, 123, 255, 0.1254901961);
}
.Timeseries .svg-parent.is-active svg .domain,
.Timeseries .svg-parent.is-active svg .tick,
.Timeseries .svg-parent.is-active svg line,
.Minigraph .svg-parent.is-active svg .domain,
.Minigraph .svg-parent.is-active svg .tick,
.Minigraph .svg-parent.is-active svg line {
  stroke: #007bff;
}
.Timeseries .svg-parent.is-active svg text,
.Minigraph .svg-parent.is-active svg text {
  color: rgba(0, 123, 255, 0.6);
}
.Timeseries .svg-parent.is-tested,
.Minigraph .svg-parent.is-tested {
  background: rgba(32, 26, 162, 0.1254901961);
}
.Timeseries .svg-parent.is-tested svg .domain,
.Timeseries .svg-parent.is-tested svg .tick,
.Timeseries .svg-parent.is-tested svg line,
.Minigraph .svg-parent.is-tested svg .domain,
.Minigraph .svg-parent.is-tested svg .tick,
.Minigraph .svg-parent.is-tested svg line {
  stroke: rgba(32, 26, 162, 0.8666666667);
}
.Timeseries .svg-parent.is-tested svg text,
.Minigraph .svg-parent.is-tested svg text {
  color: rgba(32, 26, 162, 0.6);
}
.Timeseries .svg-parent.is-vaccinated,
.Minigraph .svg-parent.is-vaccinated {
  background: rgba(219, 85, 129, 0.1254901961);
}
.Timeseries .svg-parent.is-vaccinated svg .domain,
.Timeseries .svg-parent.is-vaccinated svg .tick,
.Timeseries .svg-parent.is-vaccinated svg line,
.Minigraph .svg-parent.is-vaccinated svg .domain,
.Minigraph .svg-parent.is-vaccinated svg .tick,
.Minigraph .svg-parent.is-vaccinated svg line {
  stroke: #db5581;
}
.Timeseries .svg-parent.is-vaccinated svg text,
.Minigraph .svg-parent.is-vaccinated svg text {
  color: rgba(219, 85, 129, 0.6);
}
.Timeseries .svg-parent.is-tpr,
.Minigraph .svg-parent.is-tpr {
  background: rgba(253, 126, 20, 0.1254901961);
}
.Timeseries .svg-parent.is-tpr svg .domain,
.Timeseries .svg-parent.is-tpr svg .tick,
.Timeseries .svg-parent.is-tpr svg line,
.Minigraph .svg-parent.is-tpr svg .domain,
.Minigraph .svg-parent.is-tpr svg .tick,
.Minigraph .svg-parent.is-tpr svg line {
  stroke: #fd7e14;
}
.Timeseries .svg-parent.is-tpr svg text,
.Minigraph .svg-parent.is-tpr svg text {
  color: rgba(253, 126, 20, 0.6);
}
.Timeseries .svg-parent.is-brush .overlay,
.Minigraph .svg-parent.is-brush .overlay {
  fill: rgba(108, 117, 125, 0.2509803922);
  pointer-events: all;
}
.Timeseries .svg-parent.is-brush .selection,
.Minigraph .svg-parent.is-brush .selection {
  cursor: move;
  stroke: none;
}
.Timeseries .svg-parent.is-brush svg .domain,
.Timeseries .svg-parent.is-brush svg .tick,
.Timeseries .svg-parent.is-brush svg line,
.Minigraph .svg-parent.is-brush svg .domain,
.Minigraph .svg-parent.is-brush svg .tick,
.Minigraph .svg-parent.is-brush svg line {
  stroke: #6c757d;
}
.Timeseries .svg-parent.is-brush svg text,
.Minigraph .svg-parent.is-brush svg text {
  color: #6c757d;
}

.Minigraph {
  align-self: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0;
  margin-bottom: 2rem;
  margin-top: 1rem;
}
.Minigraph .svg-parent {
  background: transparent !important;
}

.floating-buttons {
  bottom: 1rem;
  display: flex;
  flex-direction: column;
  padding: 0;
  position: fixed;
  right: 1rem;
  width: 3rem;
  z-index: 1;
}
.floating-buttons button {
  -webkit-backdrop-filter: saturate(180%) blur(2px);
          backdrop-filter: saturate(180%) blur(2px);
  background: rgba(255, 193, 7, 0.6);
  border: 0;
  border-radius: 50%;
  color: #fd7e14;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  margin: 0.25rem;
  outline: none;
  padding: 0.75rem;
  transition: all 0.2s ease-in-out;
}
.floating-buttons button:hover {
  background: #ffa500;
}
.floating-buttons button:hover svg {
  stroke: #ffa500;
}
.floating-buttons button svg {
  align-self: center;
  stroke: #fd7e14;
}

.Links {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.link {
  align-self: center;
  margin-bottom: 1rem;
  margin-top: 1rem;
  width: 34rem;
}
.link a {
  background: rgba(0, 123, 255, 0.1254901961);
  color: #007bff;
  font-weight: 900;
  text-decoration: none;
  text-transform: uppercase;
  transition: background 0.2s ease-in-out;
  word-wrap: break-word;
}
.link a:hover {
  background: rgba(0, 123, 255, 0.1882352941);
}
.link h3 {
  color: #343a40;
  font-weight: 900;
  margin-bottom: 0;
}

footer {
  display: flex;
  flex-direction: column;
  margin-bottom: 4rem;
  margin-top: 4rem;
  width: 100%;
}
footer > * {
  align-self: center;
  text-align: center;
}
footer h5 {
  color: #6c757d;
  font-weight: 600;
  margin: 0;
  margin-bottom: 2rem;
}
footer svg {
  margin-right: 0.5rem;
  padding: 0.25rem;
}
footer .telegram {
  color: rgba(0, 123, 255, 0.6);
}
footer .telegram:hover {
  color: #007bff;
}
footer .github {
  color: rgba(108, 117, 125, 0.6);
}
footer .github:hover {
  color: #6c757d;
}
footer .instagram {
  color: rgba(219, 85, 129, 0.6);
}
footer .instagram:hover {
  color: #db5581;
}
footer .twitter {
  color: rgba(76, 117, 242, 0.6);
}
footer .twitter:hover {
  color: #4c75f2;
}
footer .api {
  color: rgba(255, 193, 7, 0.6);
}
footer .api:hover {
  color: #ffc107;
}
footer .mail {
  color: rgba(182, 133, 77, 0.6);
}
footer .mail:hover {
  color: #b6854d;
}

.Volunteers {
  align-items: center;
  align-self: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 1.5rem;
  margin-left: 6rem;
  margin-top: 4rem;
  min-height: 30rem;
  width: calc(100% - 6rem);
}
.Volunteers .wrapper {
  max-width: 80%;
}
.Volunteers .wrapper .description {
  background: rgba(0, 123, 255, 0.1254901961);
  border-radius: 0.25rem;
  color: #007bff;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 3rem;
  padding: 1rem;
  text-align: justify;
  text-justify: inter-word;
}
.Volunteers .members {
  display: grid;
  grid-auto-rows: 6.5rem;
  grid-column-gap: 1%;
  grid-row-gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(20rem, 1fr));
  width: 80%;
}
.Volunteers .members .last {
  display: flex;
  position: relative;
}
.Volunteers .members .last .Member {
  background-color: #f6f6f7;
  box-sizing: border-box;
  height: 100%;
  position: absolute;
  width: 70%;
}
.Volunteers .members .last .Member:hover {
  background-color: #edeeef;
}
.Volunteers .members .last .Member.second {
  background-color: #fff;
  left: 15%;
}
.Volunteers .members .last .Member.second:hover {
  background-color: #edeeef;
}
.Volunteers .members .last .Member.third {
  left: 30%;
}
.Volunteers .members .Member {
  align-items: center;
  background-color: rgba(108, 117, 125, 0.062745098);
  border-radius: 0.25rem;
  display: flex;
  flex-direction: row;
  padding: 1rem;
  position: relative;
  text-decoration: none;
}
.Volunteers .members .Member > a {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
.Volunteers .members .Member:hover {
  background-color: rgba(108, 117, 125, 0.1254901961);
}
.Volunteers .members .Member .image {
  aspect-ratio: 1;
  border-radius: 10px;
  height: 100%;
  margin-right: 1rem;
}
.Volunteers .members .Member .image svg {
  border-radius: 10px;
  height: 100%;
  width: 100%;
}
.Volunteers .members .Member .link-external {
  align-self: flex-start;
  color: #6c757d;
  margin-left: 1rem;
}
.Volunteers .members .Member .details {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 0;
  pointer-events: none;
  position: relative;
  white-space: nowrap;
  width: 100%;
}
.Volunteers .members .Member .details > * {
  overflow: hidden;
  text-overflow: ellipsis;
}
.Volunteers .members .Member .details .name {
  color: rgba(52, 58, 64, 0.9333333333);
  font-weight: 600;
  margin: 0;
  margin-bottom: 0.25rem;
}
.Volunteers .members .Member .details .bio {
  color: #007bff;
  font-size: 12px;
  margin: 0;
  margin-bottom: 0.25rem;
}
.Volunteers .members .Member .details .socials {
  align-items: center;
  cursor: pointer;
  display: flex;
  line-height: 1.5rem;
  margin-top: auto;
  transition: opacity 0.15s ease-in-out;
}
.Volunteers .members .Member .details .socials .icon {
  pointer-events: all;
}
.Volunteers .members .Member .details .socials svg {
  margin-right: 0.5rem;
}
.Volunteers .members .Member .details .socials .github {
  color: rgba(108, 117, 125, 0.7333333333);
}
.Volunteers .members .Member .details .socials .github:hover {
  color: #6c757d;
}
.Volunteers .members .Member .details .socials .linkedin {
  color: rgba(0, 123, 255, 0.6);
}
.Volunteers .members .Member .details .socials .linkedin:hover {
  color: #007bff;
}
.Volunteers .members .Member .details .socials .instagram {
  color: rgba(219, 85, 129, 0.6);
}
.Volunteers .members .Member .details .socials .instagram:hover {
  color: #db5581;
}
.Volunteers .members .Member .details .socials .twitter {
  color: rgba(76, 117, 242, 0.6);
}
.Volunteers .members .Member .details .socials .twitter:hover {
  color: #4c75f2;
}

.About {
  display: flex;
  flex-direction: column;
  min-height: 30rem;
  width: 100%;
}
.About > * {
  align-self: center;
  margin-bottom: 1.5rem;
  width: 34rem;
}
.About > *:first-child {
  margin-top: 4rem;
}
.About h2 {
  font-weight: 600;
  margin: 0;
  text-transform: none;
}
.About .question {
  color: #343a40;
  margin: 0;
  margin-bottom: 0.25rem;
}
.About .answer {
  color: #007bff;
  line-height: 1.5rem;
}
.About a {
  background: rgba(0, 123, 255, 0.1254901961);
  color: #007bff;
  text-decoration: none;
}
.About a:hover {
  text-decoration: underline;
}

.pills {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.pills > button {
  background-color: rgba(255, 193, 7, 0.1254901961);
  border: 2px rgba(255, 193, 7, 0.1254901961) solid;
  border-bottom: 0;
  border-top: 0;
  color: #fd7e14;
  cursor: pointer;
  font-size: 10px !important;
  font-weight: 600;
  margin: 0;
  padding: 10px 15px;
  text-align: center;
  transition: background 0.25s ease-in-out;
}
.pills > button:hover {
  background: rgba(255, 193, 7, 0.1882352941);
}
.pills > button.selected {
  background-color: rgba(255, 193, 7, 0.6);
}
.pills > button:focus:not(:focus-visible) {
  outline: none;
}
.pills > button:first-of-type {
  border: 0;
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;
}
.pills > button:last-of-type {
  border: 0;
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
}

.updates-header {
  align-self: center;
  color: #343a40;
  width: 100%;
}
.updates-header h2 {
  color: #4c75f2;
  font-weight: 900;
}
.updates-header h3 {
  color: rgba(0, 123, 255, 0.6);
  font-weight: 900;
}
.updates-header h3:hover svg {
  color: #007bff;
}
.updates-header h3 svg {
  height: 1rem;
}

.updates-footer {
  align-self: center;
  color: #343a40;
  margin-left: auto;
}
.updates-footer .telegram {
  color: #007bff;
}
.updates-footer .telegram:hover {
  color: rgba(32, 26, 162, 0.8666666667);
}
.updates-footer h4 {
  color: rgba(0, 123, 255, 0.6);
  font-weight: 900;
  margin-top: 0.5rem;
}
.updates-footer h4 svg {
  height: 1rem;
  margin-bottom: -0.1rem;
  margin-left: 0.25rem;
}
.updates-footer h4:hover {
  color: #007bff;
}

.updates {
  align-self: center;
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  min-height: 22rem !important;
  width: 100%;
}
.updates .update {
  background: rgba(108, 117, 125, 0.062745098);
  border-radius: 5px;
  margin-bottom: 0.5rem;
  padding: 0.75rem;
  transition: all 0.2s ease-in-out;
}
.updates .update:hover {
  background: rgba(108, 117, 125, 0.1254901961);
}
.updates .update h5,
.updates .update h4 {
  margin: 0;
}
.updates .update h5 {
  color: rgba(108, 117, 125, 0.6);
  margin-bottom: 0.15rem;
}
.updates .update h4 {
  color: #6c757d;
  font-weight: 600;
}
.updates .button {
  background: rgba(76, 117, 242, 0.062745098);
  color: #4c75f2;
  display: flex;
  flex-direction: row;
  height: 3rem;
  width: 13rem;
}
.updates .button > * {
  align-self: center;
}
.updates .button:hover {
  background: rgba(76, 117, 242, 0.1882352941);
}
.updates a {
  color: inherit;
  display: flex;
  flex-direction: row;
  text-decoration: none;
}
.updates a > * {
  align-self: center;
}

.district-bar {
  align-self: center;
  display: flex;
  flex-direction: column;
}
.district-bar .district-bar-bottom .button {
  background: rgba(108, 117, 125, 0.062745098);
  color: #6c757d;
  flex-basis: 15%;
  font-weight: 600;
  height: 2.5rem;
  justify-content: center;
  margin-top: 0.75rem;
  text-transform: inherit;
  width: 5rem;
}
.district-bar .district-bar-bottom .button:hover {
  background: rgba(108, 117, 125, 0.1254901961);
}
.district-bar .district-bar-top {
  align-self: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}
.district-bar .district-bar-top.expanded {
  flex-direction: column;
}
.district-bar .district-bar-top h2 {
  font-weight: 900;
  margin-bottom: 0.5rem;
  margin-top: 0;
}
.district-bar .district-bar-top h2.confirmed {
  color: #dc3545;
}
.district-bar .district-bar-top h2.active {
  color: #007bff;
}
.district-bar .district-bar-top h2.recovered {
  color: #28a745;
}
.district-bar .district-bar-top h2.deceased {
  color: #6c757d;
}
.district-bar .district-bar-top h2.vaccinated {
  color: #db5581;
}
.district-bar .district-bar-left {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.district-bar .district-bar-right {
  display: flex;
  flex-basis: 15rem;
  flex-grow: 1;
  justify-content: center;
  position: relative;
}
.district-bar .district-bar-right .happy-sign {
  display: flex;
  flex-direction: row;
  position: absolute;
  top: 4rem;
}
.district-bar .district-bar-right .DeltaBarGraph {
  margin-top: 1rem;
  width: 100%;
}
.district-bar .district-bar-right .DeltaBarGraph svg {
  width: 100%;
}
.district-bar .district-bar-right .DeltaBarGraph svg .label {
  font-size: 11px;
  font-weight: 900;
  text-anchor: middle;
}
.district-bar .districts {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 10rem;
}
.district-bar .districts.is-grid {
  display: grid;
  grid-auto-flow: column;
  grid-gap: 0.5rem;
  padding-bottom: 0.5rem;
  width: 100%;
}
.district-bar .districts .district {
  display: flex;
  flex-direction: row;
  height: 2.5rem;
  justify-content: flex-start;
  margin-right: 0.5rem;
}
.district-bar .districts .district h2,
.district-bar .districts .district h5 {
  color: #6c757d;
  font-weight: 600;
  margin: 0;
}
.district-bar .districts .district h5 {
  display: inline-block !important;
  margin-left: 0.5rem;
  margin-top: 0.15rem;
  width: auto !important;
}
.district-bar .districts .district > * {
  align-self: center;
}
.district-bar .districts .district .delta {
  display: flex;
  flex-direction: row;
  margin-left: 0.5rem;
  margin-top: 4px;
}
.district-bar .districts .district .delta h6 {
  margin: 0;
}
.district-bar .districts .district .delta h6.confirmed {
  color: rgba(220, 53, 69, 0.6);
}
.district-bar .districts .district .delta h6.active {
  color: rgba(0, 123, 255, 0.6);
}
.district-bar .districts .district .delta h6.recovered {
  color: rgba(40, 167, 69, 0.6);
}
.district-bar .districts .district .delta h6.deceased {
  color: rgba(108, 117, 125, 0.6);
}
.district-bar .districts .district .delta h6.vaccianted {
  color: rgba(219, 85, 129, 0.6);
}
.district-bar .districts .district .delta svg {
  stroke-width: 4;
  vertical-align: bottom;
  width: 10px;
}
.district-bar .districts .district .delta svg.confirmed {
  color: rgba(220, 53, 69, 0.6);
}
.district-bar .districts .district .delta svg.active {
  color: rgba(0, 123, 255, 0.6);
}
.district-bar .districts .district .delta svg.recovered {
  color: rgba(40, 167, 69, 0.6);
}
.district-bar .districts .district .delta svg.deceased {
  color: rgba(108, 117, 125, 0.6);
}
.district-bar .districts .district .delta svg.vaccinated {
  color: rgba(219, 85, 129, 0.6);
}
.district-bar .districts .district .delta > * {
  align-self: center;
}

.LanguageSwitcher {
  align-self: center;
  display: flex;
  flex-direction: column;
  margin-left: 5rem;
  width: 34rem;
}
.LanguageSwitcher h3 {
  align-self: center;
  color: #4c75f2;
  font-weight: 600;
  margin-bottom: 2rem;
}
.LanguageSwitcher .close-button {
  align-self: center;
  background: rgba(76, 117, 242, 0.062745098);
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 1rem;
  min-width: 1rem;
  padding: 1rem;
}
.LanguageSwitcher .close-button:hover {
  background: rgba(76, 117, 242, 0.1882352941);
}
.LanguageSwitcher .close-button svg {
  color: rgba(76, 117, 242, 0.6);
  stroke-width: 2.5px;
}
.LanguageSwitcher .close-button svg:hover {
  color: #4c75f2;
}
.LanguageSwitcher .languages {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 2.5rem;
  min-height: 10rem;
}
.LanguageSwitcher .languages .language {
  border-radius: 5px;
  color: rgba(76, 117, 242, 0.6);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-weight: 600;
  justify-content: center;
  padding: 1rem;
  -webkit-user-select: none;
          user-select: none;
}
.LanguageSwitcher .languages .language:hover {
  color: #4c75f2;
}
.LanguageSwitcher .languages .language.is-highlighted {
  background: rgba(76, 117, 242, 0.062745098);
  color: #4c75f2;
}

.SunMoon {
  cursor: pointer;
}

.Tooltip {
  background-color: #000 !important;
  border-radius: 8px !important;
  color: #fff;
  font-size: 13px !important;
  font-weight: 600;
  padding: 0.5rem;
}
.Tooltip .message {
  margin: 0;
}
.Tooltip .message :not(:last-child) {
  margin-bottom: 0.5rem;
}

.frac {
  display: inline-block;
  letter-spacing: 0.001em;
  position: relative;
  text-align: center;
  vertical-align: middle;
}
.frac span {
  display: block;
  padding: 0.1em;
}
.frac span.bottom {
  border-top: thin solid;
}

@media (min-width: 769px) {
  .Home,
  .State {
    padding-top: 5rem;
  }
  .Navbar {
    background: #f6f6f7;
    flex-direction: column;
    height: 100%;
    justify-content: flex-start;
    min-width: 5rem;
    position: fixed;
    z-index: 999;
  }
  .Navbar .navbar-left {
    margin-bottom: 0.5rem;
    margin-top: auto;
    order: 3;
    text-align: center;
  }
  .Navbar .navbar-middle {
    font-size: 0.6rem;
    order: 1;
    padding-bottom: 2rem;
    padding-top: 2rem;
    text-align: center;
    width: 46px;
    word-wrap: break-word;
  }
  .Navbar .navbar-right {
    align-items: center;
    background: #f6f6f7;
    display: flex;
    flex-direction: column;
    order: 2;
    padding-bottom: 0;
    padding-top: 0;
  }
  .Navbar .navbar-right span {
    display: flex;
    flex-direction: row;
    height: 1.5rem;
    justify-content: center;
    margin-bottom: 1.5rem;
    margin-top: 1.5rem;
  }
  .Navbar .navbar-right span:hover {
    color: rgba(76, 117, 242, 0.8666666667);
  }
  .Navbar .expand {
    background: #f6f6f7;
    flex-direction: column;
    height: calc(100% - 5.5rem);
    padding-left: 0;
    padding-top: 5.75rem;
    top: 0;
    width: 15rem;
  }
  .Navbar .expand > * {
    border: 0;
    color: #6c757d;
    font-weight: 600;
    height: 1.5rem;
    width: 12rem;
  }
  .dark-mode .Navbar,
  .dark-mode .expand,
  .dark-mode .navbar-right {
    background: #1e1e30 !important;
  }
  .State .state-left,
  .State .state-right {
    min-width: 33rem;
    width: 40%;
  }
  .Home .home-left,
  .Home .home-right {
    min-width: 33rem;
    width: 40%;
  }
  .Home .home-left.expanded,
  .Home .home-right.expanded {
    width: min(100%, max(71rem, 80% + 5rem));
  }
  .Home .home-left.expanded {
    margin-bottom: 2.5rem;
    margin-right: 0;
  }
  .Home .home-right.expanded {
    flex-direction: row;
    margin-left: 0;
  }
  .map-container.expanded {
    margin-right: 2.5rem;
    width: 50%;
  }
  .TimeseriesExplorer.expanded {
    margin-left: 2.5rem;
    width: calc(50% - 2rem);
  }
  footer {
    margin-bottom: 5rem;
  }
}
@media (max-width: 769px) {
  .table-container,
  .header,
  .TimeseriesExplorer,
  .map-container,
  .Links,
  .Summary,
  .Volunteers,
  .About,
  .updates,
  .updates-header,
  .StateMeta,
  .timeline,
  .table-top,
  .LanguageSwitcher,
  .VaccinationHeader {
    width: calc(100% - 2rem);
  }
  .Home,
  .State {
    display: flex;
    flex-direction: column;
    margin-left: 0;
    margin-right: 0;
    padding-top: 1rem;
    width: 100%;
  }
  .Home .home-left,
  .Home .home-right,
  .Home .state-left,
  .Home .state-right,
  .State .home-left,
  .State .home-right,
  .State .state-left,
  .State .state-right {
    display: flex;
    flex-direction: column;
    margin: 0;
    width: 100%;
  }
  .map-container {
    align-self: center;
  }
  .MapExplorer .svg-parent {
    width: 100%;
  }
  .MapExplorer .header {
    margin-top: 2rem;
  }
  .link,
  .faq {
    width: calc(100% - 2rem);
  }
  .Timeseries .svg-parent {
    width: 100%;
  }
  .Minigraph .svg-parent {
    padding: 0;
  }
  .map-stats .stats .timestamp {
    width: 4.5rem;
  }
  a.button {
    display: flex;
    flex: row 1;
    justify-content: center;
    width: 10rem;
  }
  a.button > * {
    align-self: center;
  }
  a.button svg {
    width: 38px;
  }
  .Banner .wrapper {
    flex-direction: column;
    padding-left: 0.75rem;
    width: 100%;
  }
  .Banner .wrapper .content {
    margin: 0.5rem 0;
  }
  .cards-container {
    padding: 0.5rem;
  }
  .cards-container .cards .card {
    flex: 0 1 100%;
    height: 25rem;
    margin-bottom: 0;
  }
  .cards-container .cards .chart-title {
    padding: 20px 0 10px;
  }
  .cards-container .cards .card-big {
    height: 30rem;
  }
  .Demographics {
    margin-left: 0;
    width: 100%;
  }
  .Demographics .select .react-date-picker__calendar {
    position: fixed;
    top: 2.3rem !important;
  }
  .Demographics .header {
    margin: 0;
    padding-left: 1rem;
    padding-right: 1rem;
    width: calc(100% - 2rem);
  }
  .Demographics .reminder {
    padding-bottom: 1rem;
    padding-top: 1rem;
    width: calc(100% - 4rem);
  }
  .Demographics .Patients {
    width: calc(100% - 2rem);
  }
  .Demographics .modal .modal-content {
    width: calc(100% - 5rem);
  }
  .Demographics .modal .modal-content .meta {
    height: 20rem;
  }
  .Demographics .filters-left {
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .Demographics .filters {
    align-self: center;
    height: auto;
    justify-content: center;
    padding: 0.5rem;
  }
  .patients-summary {
    width: calc(100% - 2rem);
  }
  .patients-summary .modal .modal-content {
    width: calc(100% - 5rem);
  }
  .patients-summary .modal .modal-content .meta {
    height: 20rem;
  }
  .patientdb-wrapper {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
  .patientdb-wrapper .Patients {
    width: 100%;
  }
  .patientdb-wrapper .day {
    justify-content: center;
    width: 100%;
  }
  .Navbar .expand {
    height: calc(100% - 4rem);
    overflow: auto;
    transform: none !important;
  }
  .Navbar .expand-bottom {
    margin-top: auto;
  }
  .Navbar .navbar-right span {
    display: none;
  }
  .Navbar .navbar-right span:first-child {
    display: inline;
    display: initial;
  }
  .Search .result-name {
    max-width: 10rem !important;
  }
  .State .MapExplorer,
  .State .StateHeader {
    width: calc(100% - 2rem);
  }
  .State .district-bar {
    width: calc(100% - 3rem);
  }
  .State .district-bar h1 {
    padding-left: 0;
  }
  .StateMeta {
    display: grid;
    grid-gap: 1rem;
    grid-template-rows: repeat(auto-fit, minmax(5rem));
    margin-bottom: 2.5rem;
  }
  .StateMeta .meta-item {
    min-width: 1rem;
  }
  .timeline {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .LanguageSwitcher {
    margin-left: 0;
  }
  .VaccinationHeader {
    margin-bottom: 2rem;
    margin-top: 1rem;
  }
  .timeseries-header .timeseries-options {
    flex-direction: column;
  }
  .timeseries-header .timeseries-options .moving-average {
    margin-top: 0.75rem;
  }
  .MapSwitcher .highlight,
  .MapSwitcher .clickable {
    height: 13rem;
  }
  .Volunteers {
    margin-left: 0;
  }
  .Volunteers .wrapper,
  .Volunteers .members {
    max-width: 100%;
    width: 100%;
  }
}
.dark-mode {
  background: #161625 !important;
  color: #bdbdbd;
}
.dark-mode .switch-wrapper > div {
  background: #161625 !important;
}
.dark-mode .is-tested {
  color: #9673b9 !important;
}
.dark-mode .is-tested svg {
  color: #9673b9 !important;
}
.dark-mode .expand {
  background: #1e1e30 !important;
}
.dark-mode .Navbar,
.dark-mode .expand {
  border-right: 0;
}
.dark-mode .Navbar .navbar-middle,
.dark-mode .expand .navbar-middle {
  color: #bdbdbd;
}
.dark-mode .table .cell:first-child {
  background: #1e1e30 !important;
}
.dark-mode .table .cell.heading {
  background: #1e1e30 !important;
}
.dark-mode .table .cell.heading:hover {
  background: #212130 !important;
}
.dark-mode .table .is-highlighted .cell,
.dark-mode .table .is-total .cell {
  background: #1e1e30 !important;
}
.dark-mode .Search input {
  background: #1e1e30 !important;
}
.dark-mode .State .header-right h5 {
  color: rgba(150, 115, 185, 0.7333333333) !important;
}
.dark-mode .State .header-right h2 {
  color: #9673b9 !important;
}
.dark-mode .State .header-right a {
  background: rgba(64, 0, 128, 0.3137254902) !important;
}
.dark-mode .State .breadcrumb ul {
  background: #1e1e30 !important;
}
.dark-mode .State .breadcrumb ul::after {
  border-bottom-color: #1e1e30 !important;
}
.dark-mode .State .breadcrumb ul li a {
  color: #6c757d !important;
}
.dark-mode .State .breadcrumb ul li a:hover {
  color: #fff !important;
}
.dark-mode .StateHeader .header-right {
  color: rgba(150, 115, 185, 0.7333333333);
}
.dark-mode .StateHeader .header-right h2 {
  color: #9673b9;
}
.dark-mode .StateHeader .header-right a {
  background: rgba(64, 0, 128, 0.3137254902);
}
.dark-mode .StateHeader .header-right a:hover {
  background: rgba(64, 0, 128, 0.5647058824) !important;
}
.dark-mode .MapExplorer #chart.zone,
.dark-mode .MapExplorer #legend-choro.zone {
  filter: none;
}
.dark-mode .MapExplorer #chart:not(.zone),
.dark-mode .MapExplorer #legend-choro:not(.zone) {
  filter: invert(1) hue-rotate(180deg) saturate(1.5) url("#balance-color");
}
.dark-mode .MapExplorer .maplegend {
  background: #161625 !important;
}
.dark-mode .MapExplorer .meta h1.tested {
  color: #9673b9 !important;
}
.dark-mode .MapExplorer .meta h2.tested {
  color: #9673b9 !important;
}
.dark-mode .MapExplorer .panel .panel-left .tested {
  color: #9673b9 !important;
}
.dark-mode .MapExplorer .stats.tested {
  background: rgba(64, 0, 128, 0.3137254902) !important;
}
.dark-mode .MapExplorer .stats.tested h1 {
  color: #9673b9 !important;
}
.dark-mode .MapExplorer .stats.tested h5,
.dark-mode .MapExplorer .stats.tested h6 {
  color: rgba(150, 115, 185, 0.7333333333) !important;
}
.dark-mode .MapExplorer .stats.tested svg {
  stroke: rgba(150, 115, 185, 0.7333333333) !important;
}
.dark-mode .MapExplorer .stats.tested svg:hover {
  stroke: #9673b9 !important;
}
.dark-mode .MapExplorer .disclaimer {
  color: #f6f6f7;
}
.dark-mode .Timeseries .stats.is-tested h5,
.dark-mode .Minigraph .stats.is-tested h5 {
  color: rgba(150, 115, 185, 0.7333333333) !important;
}
.dark-mode .Timeseries .stats.is-tested h5.title,
.dark-mode .Minigraph .stats.is-tested h5.title {
  color: rgba(150, 115, 185, 0.7333333333) !important;
}
.dark-mode .Timeseries .stats.is-tested h2,
.dark-mode .Timeseries .stats.is-tested h6,
.dark-mode .Minigraph .stats.is-tested h2,
.dark-mode .Minigraph .stats.is-tested h6 {
  color: #9673b9 !important;
}
.dark-mode .Timeseries .svg-parent.is-tested,
.dark-mode .Minigraph .svg-parent.is-tested {
  background: rgba(64, 0, 128, 0.3137254902) !important;
}
.dark-mode .Timeseries .svg-parent.is-tested svg circle,
.dark-mode .Timeseries .svg-parent.is-tested svg .domain,
.dark-mode .Timeseries .svg-parent.is-tested svg .tick,
.dark-mode .Minigraph .svg-parent.is-tested svg circle,
.dark-mode .Minigraph .svg-parent.is-tested svg .domain,
.dark-mode .Minigraph .svg-parent.is-tested svg .tick {
  stroke: #9673b9 !important;
}
.dark-mode .Timeseries .svg-parent.is-tested svg circle,
.dark-mode .Minigraph .svg-parent.is-tested svg circle {
  fill: #9673b9 !important;
}
.dark-mode .Timeseries .svg-parent.is-tested svg .trend,
.dark-mode .Timeseries .svg-parent.is-tested svg line,
.dark-mode .Minigraph .svg-parent.is-tested svg .trend,
.dark-mode .Minigraph .svg-parent.is-tested svg line {
  stroke: rgba(150, 115, 185, 0.6) !important;
}
.dark-mode .Timeseries .svg-parent.is-tested svg .trend-area,
.dark-mode .Minigraph .svg-parent.is-tested svg .trend-area {
  fill: rgba(150, 115, 185, 0.6) !important;
}
.dark-mode .Timeseries .svg-parent.is-tested svg text,
.dark-mode .Minigraph .svg-parent.is-tested svg text {
  color: rgba(150, 115, 185, 0.7333333333) !important;
  stroke: transparent;
}
.dark-mode .Timeseries .svg-parent.is-brush .handle--custom,
.dark-mode .Minigraph .svg-parent.is-brush .handle--custom {
  stroke: #f6f6f7;
}
.dark-mode .tpl {
  background: rgba(64, 0, 128, 0.3137254902) !important;
}
.dark-mode .tpl h3,
.dark-mode .tpl h5,
.dark-mode .tpl svg,
.dark-mode .tpl p {
  color: rgba(150, 115, 185, 0.7333333333) !important;
}
.dark-mode .tpl h1 {
  color: #9673b9 !important;
}
.dark-mode .tab.focused {
  background: #1e1e30 !important;
  color: #bdbdbd !important;
}
.dark-mode .pills button.selected {
  background: #ffc10750;
}
.dark-mode .TimeseriesExplorer .state-selection .dropdown select {
  background: #1e1e30;
  background-image: linear-gradient(45deg, transparent 50%, #6c757d 50%), linear-gradient(135deg, #6c757d 50%, transparent 50%);
  background-position: calc(100% - 13px) 50%, calc(100% - 8px) 50%;
  background-repeat: no-repeat;
  background-size: 5px 5px, 5px 5px;
  border-color: rgba(148, 148, 148, 0.1019607843);
}
.dark-mode input.switch {
  background-color: #161625 !important;
  border: 2px solid rgba(108, 117, 125, 0.6) !important;
}
.dark-mode input.switch:checked {
  background-color: rgba(108, 117, 125, 0.6) !important;
}
.dark-mode input.switch:checked::after {
  background-color: #cfcfcf !important;
}
.dark-mode input.switch::after {
  background-color: #cfcfcf !important;
}
.dark-mode .disabled input.switch {
  background: #343a40 !important;
  border: rgba(108, 117, 125, 0.062745098) 2px solid !important;
  opacity: 0.7;
}
.dark-mode .disabled input.switch::after {
  background: #6c757d !important;
}
.dark-mode .Volunteers .members .last .Member:hover {
  background-color: #212130;
}
.dark-mode .Volunteers .members .last .Member.second {
  background-color: #161625;
}
.dark-mode .Volunteers .members .last .Member.second:hover {
  background-color: #212130;
}
.dark-mode .Volunteers .members .Member {
  background-color: #1e1e30;
}
.dark-mode .Volunteers .members .Member:hover {
  background-color: rgba(108, 117, 125, 0.1254901961);
}
.dark-mode .Volunteers .members .Member .details .name {
  color: #6c757d;
}
.dark-mode .About .question {
  color: #6c757d !important;
}
.dark-mode .Demographics .filters {
  background: #1e1e30 !important;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.12), inset 0 -1px 0 0 #1e1e30;
}
.dark-mode .Demographics .legend {
  background: #1e1e30 !important;
}
.dark-mode .Demographics .react-date-picker {
  background: #1e1e30;
  border-color: rgba(148, 148, 148, 0.1019607843) !important;
}
.dark-mode .Demographics .modal-content {
  background: #1e1e30 !important;
}
.dark-mode .Demographics .modal {
  background: rgba(30, 30, 48, 0.7333333333) !important;
}
.dark-mode .StateDropdown .dropdown {
  background: #1e1e30 !important;
}
.dark-mode .StatisticDropdown select option {
  background: #1e1e30;
  color: #6c757d;
}
.dark-mode .TableLoader svg rect {
  fill: #1e1e30 !important;
}

.fadeInUp {
  animation-duration: 0.45s;
  animation-fill-mode: both;
  animation-name: fadeInUp;
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translate3d(0, 20px, 0);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
.fadeInDown {
  animation-duration: 0.45s;
  animation-fill-mode: both;
  animation-name: fadeInDown;
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -20px, 0);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
.rotateDownRight {
  animation-duration: 0.25s;
  animation-fill-mode: both;
  animation-name: rotateDownRight;
}

@keyframes rotateDownRight {
  100% {
    transform: rotate(-90deg);
  }
}
.rotateRightDown {
  animation-duration: 0.25s;
  animation-fill-mode: both;
  animation-name: rotateRightDown;
}

@keyframes rotateRightDown {
  0% {
    transform: rotate(-90deg);
  }
}
.fadeOutDown {
  animation-duration: 0.45s;
  animation-fill-mode: both;
  animation-name: fadeOutDown;
}

@keyframes fadeOutDown {
  0% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  100% {
    opacity: 0;
    transform: translate3d(0, 20px, 0);
  }
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AA4EA;EACE,qBAAA;AA3EF;;AA8EA;EACE,kBAAA;EACA,YAAA;AA3EF;;AA8EA;EACE,wCAAA;EACA,2BAAA;EACA,SAAA;EACA,UAAA;AA3EF;;AA8EA;EACE,eAAA;EACA,gBAAA;AA3EF;;AA8EA;EACE,0BAAA;EACA,gBAAA;AA3EF;;AA8EA;EACE,0BAAA;EACA,gBAAA;AA3EF;;AA8EA;EACE,0BAAA;EACA,gBAAA;AA3EF;;AA8EA;EACE,0BAAA;EACA,gBAAA;AA3EF;;AA8EA;EACE,0BAAA;EACA,gBAAA;AA3EF;;AA8EA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;AA3EF;;AA8EA;EACE,iDAAA;EACA,kCAAA;EACA,mCAAA;EACA,oBAAA;AA3EF;;AA8EA;EACE,kCAAA;EACA,mCAAA;EACA,8CAAA;EACA,oBAAA;AA3EF;;AA8EA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,8BAAA;AA3EF;AA6EE;EACE,cAAA;EACA,qBAAA;AA3EJ;AA8EE;EACE,+BAhHO;EAiHP,eAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AA5EJ;AA8EI;EACE,cA7HC;AAiDP;AAgFE;EACE,cAlIG;EAmIH,eAAA;EACA,gBAAA;EACA,yBAAA;AA9EJ;AAgFI;EACE,cArKE;AAuFR;AAkFE;EACE,cA7IG;EA8IH,eAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AAhFJ;AAmFE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;AAjFJ;AAoFE;EACE,mBA3JgB;EA4JhB,cA9JG;EA+JH,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;AAlFJ;AAoFI;EACE,yDAAA;EACA,sDAAA;EACA,eAAA;EACA,iCAAA;AAlFN;AAoFM;EACE,4CAtMM;AAoHd;AAsFQ;EACE,2CA5MI;EA6MJ,cA9MF;EA+ME,gBAAA;AApFV;AAyFI;EACE,sBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAvFN;AAyFM;EACE,SAAA;AAvFR;AA0FM;EACE,gBAAA;AAxFR;;AA8FA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AA3FF;AA6FE;;EAEE,aAAA;EACA,sBAAA;AA3FJ;AA8FE;EACE,oBAAA;AA5FJ;AA+FE;EACE,mBAAA;AA7FJ;AAgGE;EACE,WAAA;AA9FJ;;AAkGA;EACE,uBAAA;EACA,4CArOW;EAsOX,kBAAA;EACA,cAxOK;EAyOL,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AA/FF;AAiGE;EACE,+BA3OO;EA4OP,YAAA;EACA,WAAA;AA/FJ;AAkGE;EACE,oBAAA;EACA,iBAAA;EACA,cAAA;AAhGJ;AAkGI;EACE,4CAzPO;EA0PP,cA3PC;EA4PD,oBAAA;EACA,qBAAA;AAhGN;AAkGM;EACE,6CA7PK;AA6Jb;AAoGI;EACE,WAAA;AAlGN;AAsGE;EACE,2CA7QU;EA8QV,cA/QI;AA2KR;AAsGI;EACE,8BA/QM;AA2KZ;;AAyGA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AAtGF;AAwGE;EACE,sBAAA;AAtGJ;AA0GI;;EAEE,SAAA;AAxGN;AA2GI;EACE,cAjRE;EAkRF,gBAAA;AAzGN;AA4GI;EACE,cA7SC;EA8SD,gBAAA;EACA,kBAAA;AA1GN;AA8GE;EACE,6BAvSS;EAwST,aAAA;EACA,sBAAA;EACA,iBAAA;AA5GJ;AA8GI;;EAEE,gBAAA;EACA,SAAA;AA5GN;AA+GI;EACE,sCAtTG;EAuTH,gBAAA;AA7GN;AAgHI;EACE,2CA1TS;EA2TT,cAAA;EACA,qBAAA;AA9GN;AAgHM;EACE,2CA9TO;AAgNf;;AAoHA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AAjHF;AAmHE;;EAEE,aAAA;EACA,sBAAA;AAjHJ;AAoHE;EACE,oBAAA;EACA,kBAAA;AAlHJ;AAqHE;EACE,mBAAA;AAnHJ;AAsHE;EACE,qBAAA;AApHJ;AAuHE;EACE,qBAAA;EACA,wBAAA;AArHJ;AAyHI;;;;;;EAME,aAAA;AAvHN;AA0HI;EACE,aAAA;AAxHN;AA6HI;EACE,aAAA;AA3HN;;AAgIA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,qCAAA;EACA,mBAAA;EACA,wBAAA;AA7HF;AA+HE;EACE,wBAAA;EACA,8BAAA;EACA,yCAAA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;AA7HJ;AA+HI;EACE,SAAA;AA7HN;AAiIE;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AA/HJ;AAiII;;;;;EAKE,SAAA;AA/HN;AAkII;EACE,gBAAA;AAhIN;AAmII;EACE,gBAAA;AAjIN;AAoII;EACE,gBAAA;EACA,YAAA;EACA,qBAAA;AAlIN;AAqII;EACE,qBAAA;EACA,gBAAA;AAnIN;AAsII;EACE,2BAAA;EACA,qBAAA;AApIN;AAsIM;;EAEE,cAlcD;AA8TP;AAwII;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAtIN;AAwIM;EACE,kBAAA;AAtIR;AAyIM;EACE,0BAAA;AAvIR;AA0IM;EACE,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AAxIR;AA4II;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AA1IN;AA4IM;EACE,kBAAA;AA1IR;AA6IM;EACE,eAAA;EACA,kBAAA;AA3IR;AA+II;EACE,gBAAA;EACA,sBAAA;EACA,mBAAA;AA7IN;AAgJI;EACE,0CAvgBS;AAyXf;AAgJM;;;;EAIE,4BA9gBK;AAgYb;AAiJM;EACE,cAnhBC;AAoYT;AAmJI;EACE,2CAliBO;AAiZb;AAmJM;;;;EAIE,6BAriBG;AAoZX;AAoJM;EACE,cA7iBD;AA2ZP;AAsJI;EACE,2CAnhBQ;AA+Xd;AAsJM;;;;EAIE,6BAvhBI;AAmYZ;AAuJM;EACE,cA9hBA;AAyYR;AAyJI;EACE,4CA9hBO;AAuYb;AAyJM;;;;EAIE,+BAjiBG;AA0YX;AA0JM;EACE,cAziBD;AAiZP;AA4JI;EACE,2CAtjBS;AA4Zf;AA4JM;;;EAGE,8BAhkBK;AAsab;AA6JM;EACE,cArkBC;AA0aT;AA+JI;EACE,2CAjjBS;AAoZf;AA+JM;;;;EAIE,6BArjBK;AAwZb;AAgKM;EACE,sCA5jBC;AA8ZT;AAkKI;EACE,4CAvlBS;AAubf;AAkKM;;;;EAIE,8BA9lBK;AA8bb;AAmKM;EACE,cAnmBC;AAkcT;;AAuKA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AApKF;AAsKE;EACE,0CA1kBU;EA2kBV,kBAAA;EACA,eAAA;EACA,gBAAA;AApKJ;AAuKM;EACE,iDAhlBM;AA2ad;AA0KE;EACE,gBArpBI;EAspBJ,kBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;AAxKJ;AA0KI;EACE,cA5oBA;EA6oBA,eAAA;EACA,gBAAA;AAxKN;AA0KM;EACE,2CA9oBI;AAseZ;AA6KE;EACE,2CAtpBQ;EAupBR,aAAA;EACA,OAAA;EACA,oBAAA;EACA,eAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;AA3KJ;;AA+KA;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;AA5KF;AA8KE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;AA5KJ;AA8KI;EACE,iCAAA;AA5KN;AAgLE;EACE,wBAAA;UAAA,gBAAA;EACA,kDAhqBS;EAiqBT,SAAA;EACA,kBAAA;EACA,cApqBG;EAqqBH,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gDAvqBS;EAwqBT,YAAA;AA9KJ;AAgLI;EACE,sBAAA;EACA,cA/qBC;EAgrBD,YAAA;AA9KN;AAiLI;EACE,mDAjrBO;AAkgBb;AAkLI;EACE,gDA7sBS;EA8sBT,cAhtBG;EAitBH,6CA9sBS;AA8hBf;AAkLM;EACE,gDAjtBO;AAiiBf;AAoLI;EACE,iDAnuBO;EAouBP,cAruBC;EAsuBD,8CApuBO;AAkjBb;AAoLM;EACE,iDAvuBK;AAqjBb;AAsLI;EACE,iDA/sBQ;EAgtBR,cAjtBE;EAktBF,8CAhtBQ;AA4hBd;AAsLM;EACE,iDAntBM;AA+hBd;AAwLI;EACE,iDA3sBS;EA4sBT,sCA7sBG;EA8sBH,8CA5sBS;AAshBf;AAwLM;EACE,iDA/sBO;AAyhBf;AA0LI;EAGE,kDA9uBS;EA+uBT,cAjvBG;EAkvBH,+CA/uBS;AAqjBf;AA4LM;EACE,kDAlvBO;AAwjBf;AA8LI;EAGE,kDA9tBO;EA+tBP,cAhuBC;EAiuBD,+CA/tBO;AAiiBb;AAgMM;EACE,kDAluBK;AAoiBb;AAkMI;EACE,kDApuBQ;EAquBR,cAtuBE;EAuuBF,+CAruBQ;AAqiBd;AAkMM;EACE,kDAxuBM;AAwiBd;;AAsMA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AAnMF;AAqME;EACE,mBAAA;EACA,uDAAA;EACA,6BAAA;EACA,0CAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,0BAAA;AAnMJ;AAqMI;EACE,sDAAA;EACA,yCAAA;AAnMN;AAqMM;EACE,sDAAA;EACA,yCAAA;AAnMR;AAuMI;EACE;IACE,sDAAA;IACA,yCAAA;EArMN;AACF;AAwMI;EACE,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,oBAAA;EACA,aAAA;AAtMN;;AA2MA;EACE,2CA10BU;EA20BV,cA50BI;EA60BJ,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;AAxMF;AA0ME;EACE,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;AAxMJ;AA0MI;EACE,gBAAA;AAxMN;AA2MI;EACE,mBAAA;EACA,iDAn2BM;EAo2BN,cAr2BA;EAs2BA,aAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;AAzMN;AA2MM;EACE,iDAz2BI;AAgqBZ;;AA+MA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AA5MF;AA8ME;EACE,kBAAA;AA5MJ;AA+ME;EACE,cA52BG;EA62BH,kBAAA;EACA,mBAAA;AA7MJ;AAgNE;EACE,4CAj3BS;EAk3BT,YAAA;EACA,UAAA;AA9MJ;AAiNE;EACE,mCAAA;UAAA,2BAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,0CAAA;EACA,cA73BG;EA83BH,eAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,wBAAA;AA/MJ;AAkNE;EACE,kBAAA;EACA,WAAA;AAhNJ;AAmNE;EACE,+BAx4BO;EAy4BP,eAAA;EACA,UAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;AAjNJ;AAmNI;EACE,UAAA;AAjNN;AAsNI;EACE,+BAx5BK;EAy5BL,aAAA;EACA,kBAAA;EACA,YAAA;EACA,gCAAA;AApNN;AAwNM;EACE,YAAA;AAtNR;AA2NE;EACE,uDAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,WAAA;AAzNJ;AA2NI;EACE,wDAAA;AAzNN;AA4NI;EACE,cAAA;AA1NN;AA6NI;EACE,kBAAA;EACA,kBAAA;EACA,gCA/7BK;EAg8BL,eAAA;EACA,WAAA;AA3NN;AA8NI;EACE,uDAAA;EACA,oBAAA;EACA,UAAA;AA5NN;AA8NM;EACE,0BAAA;AA5NR;AAiOE;EACE,4CAp8BS;EAq8BT,kBAAA;EACA,cAv8BG;EAw8BH,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AA/NJ;AAkOE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,wBAAA;AAhOJ;AAkOI;EACE,SAAA;AAhON;AAmOI;;EAEE,cA3+BC;EA4+BD,gBAAA;EACA,SAAA;EACA,qBAAA;AAjON;AAoOI;EACE,cA/gCE;EAghCF,sBAAA;AAlON;AAsOE;EACE,aAAA;EACA,iBAAA;EACA,wBAAA;AApOJ;AAsOI;EACE,gCAAA;AApON;AAuOI;EACE,cAjgCC;EAkgCD,gBAAA;EACA,eAAA;AArON;AAwOI;;EAEE,sBAAA;EACA,yDAAA;EACA,cA1gCC;EA2gCD,eAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,8BAAA;EACA,gBAAA;EACA,aAAA;EACA,gCAAA;AAtON;AAwOM;;EACE,4CAphCK;AA+yBb;AAwOM;;EACE,kBAAA;AArOR;AAwOM;;EACE,gBAAA;AArOR;AAwOM;;EACE,2CAziCO;EA0iCP,kBAAA;EACA,cAjjCC;EAkjCD,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AArOR;AAuOQ;;EACE,2CAjjCK;AA60Bf;AAuOQ;;EACE,oBAAA;EACA,+BA5jCG;EA6jCH,iBAAA;AApOV;AAuOQ;;EACE,kBAAA;AApOV;AAwOM;;EACE,aAAA;EACA,mBAAA;AArOR;AAuOQ;;EACE,kBAAA;AApOV;AAwOM;;EACE,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AArOR;AAuOQ;;EACE,0CA7lCK;EA8lCL,uCAAA;AApOV;AAuOQ;;EACE,4CAzlCK;EA0lCL,yCAAA;AApOV;AAuOQ;;EACE,2CArlCI;EAslCJ,wCAAA;AApOV;AAyOI;EACE,aAAA;EACA,sBAAA;AAvON;AAyOM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AAvOR;AAyOQ;EACE,aAAA;EACA,sBAAA;AAvOV;AAyOU;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAvOZ;AA0OU;EACE,cAjnCJ;EAknCI,aAAA;EACA,mBAAA;EACA,kBAAA;AAxOZ;AA6OM;EACE,sBAAA;EACA,4CAvmCK;EAwmCL,kBAAA;EACA,cA1mCD;EA2mCC,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;AA3OR;AA6OQ;EACE,4CAlnCG;AAu4Bb;AA8OQ;EACE,kBAAA;AA5OV;AA+OQ;EACE,oBAAA;EACA,iBAAA;EACA,WAAA;AA7OV;AAiPM;EACE,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;AA/OR;AAkPM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AAhPR;AAmPM;EACE,sBAAA;EACA,4CAhqCK;EAiqCL,kBAAA;EACA,cAnqCD;EAoqCC,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AAjPR;AAmPQ;EACE,6CA3qCG;AA07Bb;AAoPQ;EACE,cAAA;AAlPV;AAqPQ;EACE,kBAAA;AAnPV;AAsPQ;EACE,qBAAA;EACA,gCAvrCC;EAwrCD,iBAAA;EACA,WAAA;AApPV;AA0PE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;AAxPJ;AA0PI;EACE,+BArsCK;EAssCL,aAAA;EACA,mBAAA;EACA,eAAA;AAxPN;AA0PM;EACE,gBAAA;AAxPR;AA2PM;EACE,eAAA;EACA,oBAAA;EACA,eAAA;AAzPR;AA2PQ;EACE,0BAAA;EACA,8BAAA;AAzPV;;AAgQA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;AA7PF;AA+PE;EACE,kBAAA;AA7PJ;;AAiQA;EACE,qBAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;AA9PF;AAgQE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AA9PJ;AAgQI;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;AA9PN;AAiQI;EACE,cAjwCC;EAkwCD,gBAAA;EACA,SAAA;AA/PN;AAkQI;EACE,eAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,WAAA;AAhQN;AAkQM;EACE,aA/wCD;EAgxCC,eAhxCD;AAghCP;AAoQI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAlQN;AAoQM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAlQR;AAoQQ;EACE,kBAAA;AAlQV;AAuQI;EACE,YAAA;EACA,kBAAA;AArQN;AAuQM;EACE,mBAt0CA;EAu0CA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AArQR;;AA2QA;EACE,mBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,WAAA;AAxQF;AA0QE;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,kBAAA;EACA,MAAA;AAxQJ;AA0QI;EACE,yBAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,oBAAA;EACA,WAAA;AAxQN;AA0QM;EACE,UAAA;EACA,+BAAA;AAxQR;AA2QM;EACE,qCAAA;EACA,oBAAA;EACA,YAAA;AAzQR;AA6QI;EACE,mBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,WAAA;AA3QN;AA8QI;EACE,mBAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EACA,4BAAA;EACA,WAAA;AA5QN;AA+QI;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AA7QN;AAgRI;EACE,mCAAA;EACA,mBAAA;EACA,2BAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AA9QN;AAgRM;EACE,2BAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;AA9QR;AAgRQ;EACE,mDAAA;EACA,YAAA;AA9QV;AAgRU;EACE,UAAA;AA9QZ;AAkRQ;EACE,mDAAA;EACA,YAAA;AAhRV;AAmRQ;EACE,kCAAA;AAjRV;AAqRM;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,qCAAA;AAnRR;AAqRQ;EACE,UAAA;EACA,mBAAA;AAnRV;AAwRI;EACE,aAAA;EACA,6BAAA;EACA,WAAA;EACA,UAAA;AAtRN;AAwRM;EACE,mBAAA;EACA,cAj7CD;EAk7CC,aAAA;AAtRR;AAyRU;EACE,yBAAA;AAvRZ;AA4RU;EACE,aAz9CJ;EA09CI,YAAA;AA1RZ;AA4RY;EACE,6BAz9CF;EA09CE,YAAA;AA1Rd;AAkSE;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;AAhSJ;AAkSI;EACE,kBAAA;EACA,gBAAA;AAhSN;AAkSM;;;EAKE,sBAAA;AAhSR;AAmSM;EACE,kBAAA;AAjSR;AAoSM;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AAlSR;AAqSU;EACE,eAAA;AAnSZ;AAySI;EACE,aAAA;AAvSN;AA0SI;EACE,eAAA;AAxSN;AA0SM;EACE,kDAn/CK;EAo/CL,cAr/CD;EAs/CC,eAAA;EACA,kBAAA;AAxSR;AA2SU;EACE,mDAAA;AAzSZ;AA6SQ;EACE,gBAAA;AA3SV;AA8SQ;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;AA5SV;AAiTI;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AA/SN;AAkTI;EACE,cAAA;AAhTN;AAmTI;EACE,gBAAA;EACA,cAxhDC;EAyhDD,eAAA;EACA,kBAAA;EACA,kBAAA;AAjTN;AAmTM;EACE,kDA7hDK;AA4uCb;AAmTQ;EACE,yBAAA;EACA,WArkDF;AAoxCR;AAmTU;EACE,yBAAA;AAjTZ;AAqTQ;EAEE,yBAAA;EACA,WAllDF;AA8xCR;AAsTU;EACE,yBAAA;AApTZ;AAwTQ;EACE,mDAAA;EACA,+BAAA;AAtTV;AAyTQ;EACE,mDAtjDG;AA+vCb;AA6TM;EACE,qDAAA;EACA,oDAAA;AA3TR;AAgUM;EACE,qDAAA;EACA,oDAAA;AA9TR;AAkUI;EACE,cApmDG;AAoyCT;AAsUM;;;EACE,cAplDD;EAqlDC,kBAAA;AAlUR;;AAwUA;EACE,2CA7nDW;EA8nDX,SAAA;EACA,kBAAA;EACA,6BA7nDS;EA8nDT,eAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,uCAAA;AArUF;AAuUE;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;AArUJ;AAwUE;EACE,2CAzmDW;EA0mDX,6BAxmDS;AAkyCb;AAwUI;EACE,2CA5mDS;AAsyCf;AA0UE;EACE,2CAhoDU;EAioDV,6BA/nDQ;AAuzCZ;AA0UI;EACE,2CAnoDQ;AA2zCd;AA4UE;EACE,2CAtqDS;AA41Cb;AA6UE;EACE,kBAAA;AA3UJ;;AA+UA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,UAAA;AA5UF;AA8UE;EACE,oBAAA;EACA,kBAAA;AA5UJ;AA+UE;;EAEE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;AA7UJ;AAgVE;EACE,wCAAA;AA9UJ;AAiVM;EACE,0CA9rDO;AA+2Cf;AAkVM;EACE,2CA9sDK;AA83Cb;AAmVM;EACE,2CAprDM;AAm2Cd;AAoVM;EACE,4CAprDK;AAk2Cb;;AAwVA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AArVF;AAuVE;EACE,aAAA;EACA,sBAAA;AArVJ;AAuVI;EACE,kBAAA;AArVN;AAyVE;;EAEE,gBAAA;AAvVJ;AA0VE;EACE,uCAAA;EACA,gBAAA;AAxVJ;AA2VE;EACE,sBAAA;AAzVJ;AA4VE;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;AA1VJ;AA8VI;;EAEE,cA1vDG;AA85CT;AA+VI;EACE,4BA7vDO;AAg6Cb;AAkWI;;EAEE,cAhxDC;AAg7CP;AAmWI;EACE,6BAhxDK;AA+6CX;AAsWI;;EAEE,cA7vDE;AAy5CR;AAuWI;EACE,6BA9vDM;AAy5CZ;AA0WI;;EAEE,cApwDC;AA45CP;AA2WI;EACE,+BApwDK;AA25CX;AA8WI;;EAEE,sCArwDG;AAy5CT;AA+WI;EACE,6BAtwDO;AAy5Cb;AAkXI;;EAEE,cA3wDC;AA25CP;AAmXI;EACE,8BA5wDK;AA25CX;AAsXI;;EAEE,cAnzDG;AA+7CT;AAuXI;EACE,8BAtzDO;AAi8Cb;;AA0XA;EACE,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;AAvXF;AAyXE;EACE,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,4CA3yDS;EA4yDT,kBAAA;EACA,cA9yDG;EA+yDH,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AAvXJ;AAyXI;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;AAvXN;AA2XE;EACE,cA30DG;EA40DH,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AAzXJ;AA2XI;EACE,kDAl0DO;EAm0DP,kBAAA;EACA,cAr0DC;EAs0DD,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAzXN;AA2XM;EACE,wRAAA;EAUA,0BAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;AAlYR;AAoYQ;EACE,mCA91DC;AA49CX;AAqYQ;EACE,UAAA;AAnYV;AAsYQ;EACE,iCAAA;EACA,0BAAA;EAAA,kBAAA;AApYV;AAyYI;EACE,YAAA;AAvYN;AAyYM;EACE,UAAA;AAvYR;AA0YM;EACE,aAAA;AAxYR;AA0YQ;EACE,eAAA;EACA,cAAA;AAxYV;AA4YM;EACE,eAAA;EACA,qBAAA;EACA,0BAAA;EAAA,uBAAA;EAAA,kBAAA;AA1YR;;AAgZA;EACE,qBAAA;AA7YF;AA+YE;EACE,cAl7DK;AAqiDT;AAgZE;EACE,cAj8DG;AAmjDP;AAiZE;EACE,cAv6DI;AAwhDR;AAkZE;EACE,cAv6DG;AAuhDP;;AAoZA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AAjZF;;AAoZA;EACE,eAAA;EACA,gBAAA;AAjZF;AAmZE;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,yBAAA;UAAA,iBAAA;AAjZJ;;AAqZA;EACE,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;EACA,sBAAA;EACA,WAAA;AAlZF;AAoZE;EACE,aAAA;EACA,mBAAA;AAlZJ;AAqZE;EACE,mBAAA;EACA,4CAh9DS;EAi9DT,kBAAA;EACA,+BA/8DO;EAg9DP,eAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EACA,qBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,aAAA;AAnZJ;AAqZI;EACE,mBAAA;AAnZN;AAsZI;EACE,eAAA;AApZN;AAwZM;EACE,6CAn+DK;AA6kDb;AA6ZI;;EACE,2CAj/DQ;EAk/DR,cAn/DE;AAylDR;AA4ZM;;EACE,2CAp/DM;AA2lDd;AA+ZI;EACE,2CAjgES;EAkgET,cAngEG;AAsmDT;AA+ZM;EACE,2CApgEO;AAumDf;AAmaI;EACE,4CAp/DO;EAq/DP,cAt/DC;AAqlDP;AAmaM;EACE,4CAv/DK;AAslDb;AAuaI;EACE,2CAhjEO;EAijEP,cAljEC;AA6oDP;AAuaM;EACE,2CAnjEK;AA8oDb;AA0aE;EACE,+BArhEO;EAshEP,iBAAA;EACA,eAAA;AAxaJ;AA2aM;EACE,wBAAA;AAzaR;AA6aI;EACE,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,uCAAA;AA3aN;AA+aE;EA3GF;IA4GI,gBAAA;EA5aF;AACF;;AA+aA;EACE,kBAAA;EACA,cAljEK;EAmjEL,aAAA;EACA,sBAAA;EACA,wBAAA;AA5aF;AA8aE;EACE,+BApjEO;AAwoDX;AA+aE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AA7aJ;AAgbE;EACE,mBAAA;EACA,cAnkEG;EAokEH,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA9aJ;AAgbI;EACE,gBAAA;AA9aN;AAibI;EACE,aAAA;AA/aN;AAibM;EACE,WAAA;AA/aR;AAmbI;EACE,8BAAA;AAjbN;AAobI;EACE,+BAvlEK;EAwlEL,sBAAA;AAlbN;AAsbM;EACE,cAxnEC;AAosDT;AAybM;EACE,cAzoED;AAktDP;AA4bM;EACE,cAjnEA;AAurDR;AA+bM;EACE,cAnnED;AAsrDP;AAkcM;EACE,sCA/mEC;AA+qDT;AAucM;;;EACE,cAlnED;AA+qDP;AAwcM;EACE,gBAAA;AAtcR;AA2cM;EACE,gBAAA;AAzcR;AA8cM;EACE,kBAAA;EACA,WAAA;EACA,wBAAA;AA5cR;AAidE;EACE,+BAvpEO;EAwpEP,gBAAA;AA/cJ;AAidI;EACE,4CA9pEO;EA+pEP,0DAAA;EACA,cAjqEC;EAkqED,qBAAA;AA/cN;AAidM;EACE,6CAlqEK;AAmtDb;;AAqdA;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;AAldF;;AAqdA;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;EACA,eAAA;AAldF;AAodE;EACE,iBAAA;EACA,OAAA;EACA,wBAAA;EAAA,gBAAA;AAldJ;AAodI;EACE,mBAAA;EACA,aAAA;EACA,2BAAA;EACA,eAAA;EACA,8BAAA;EACA,sBAAA;EACA,gBAAA;AAldN;AAodM;EACE,oBAAA;AAldR;AAqdM;EACE,mBAAA;EACA,cAhtEA;EAitEA,aAAA;EACA,mBAAA;AAndR;AAsdM;EACE,mBAAA;EACA,2CA3tEO;EA4tEP,kBAAA;EACA,cAnuEC;EAouED,eAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AApdR;AAsdQ;EACE,oBAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;AApdV;AAudQ;EACE,2CA1uEK;AAqxDf;AA0dI;EACE,sBAAA;AAxdN;AA0dM;EACE,0CAptEM;EAqtEN,kBAAA;EACA,cAvtEA;EAwtEA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;AAxdR;AA0dQ;EACE,oBAAA;AAxdV;AA8dE;EACE,eAAA;EACA,iBAAA;EACA,WAAA;AA5dJ;AA+dM;EACE,4CAjwEK;AAoyDb;AAkeM;EACE,8BAAA;AAheR;AAqeM;EACE,eAAA;EACA,yBAAA;UAAA,iBAAA;AAneR;AAqeQ;EACE,8BAAA;AAneV;AAweI;EACE,wBAAA;EAAA,gBAAA;EACA,MAAA;AAteN;AAweM;EACE,8BAAA;EACA,uBAAA;AAteR;AA0eI;EACE,mBAAA;EACA,kBAAA;EACA,cApyEC;EAqyED,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;AAxeN;AA0eM;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;AAxeR;AA2eM;EACE,mBA1yEmB;EA2yEnB,gBAAA;EACA,YAAA;EACA,cAAA;EACA,8BAAA;EACA,OAAA;EACA,wBAAA;EAAA,gBAAA;EACA,WAAA;AAzeR;AA2eQ;EACE,UAAA;EAAA,aAAA;EACA,QAAA;AAzeV;AA6eM;EACE,+BA/zEG;EAg0EH,mBAAA;EACA,mBAAA;AA3eR;AA8eM;EACE,OAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;AA5eR;AA+eU;EACE,cAx2EH;AA23DT;AAkfU;EACE,cAz3EL;AAy4DP;AAqfU;EACE,cAj2EJ;AA82DR;AAwfU;EACE,cAn2EL;AA62DP;AA2fU;EACE,sCA/1EH;AAs2DT;AAggBU;EACE,cAl2EL;AAo2DP;AAmgBM;EACE,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;AAjgBR;AAmgBQ;EACE,eAAA;AAjgBV;AAogBQ;EACE,cAx5ED;AAs5DT;AAqgBQ;EACE,cAv6EH;AAo6DP;AAsgBQ;EACE,cA74EF;AAy4DR;AAugBQ;EACE,cA74EH;AAw4DP;AAwgBQ;EACE,sCAv4ED;AAi4DT;AAygBQ;;;EAGE,cAx4EH;AAi4DP;AA2gBM;EACE,qBAAA;AAzgBR;AA4gBM;EACE,mBA95EY;EA+5EZ,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,iBAAA;AA1gBR;AA4gBQ;EACE,8BAAA;AA1gBV;AA4gBU;EACE,WAAA;AA1gBZ;AA8gBQ;EACE,8BAAA;AA5gBV;AA+gBQ;EACE,cAAA;EACA,oBAAA;AA7gBV;AAihBM;;EAEE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AA/gBR;AAohBE;EACE,iBAAA;EACA,OAAA;EACA,wBAAA;EAAA,gBAAA;AAlhBJ;AAohBI;EACE,+BAp8EK;EAq8EL,sBAAA;EACA,gBAAA;EACA,kBAAA;AAlhBN;AAohBM;EACE,iBAAA;EACA,kBAAA;EACA,YAAA;AAlhBR;AAqhBM;EACE,eAAA;AAnhBR;AAqhBQ;EACE,cAv9EH;AAo8DP;AAyhBE;EACE,cAAA;AAvhBJ;;AA2hBA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;AAxhBF;;AA2hBA;EACE,mBAAA;EACA,cA1+EK;EA2+EL,aAAA;EACA,uBAAA;EACA,gBAAA;AAxhBF;AA0hBE;EACE,4CA/+ES;EAg/ET,kBAAA;EACA,+BA9+EO;EA++EP,eAAA;EACA,aAAA;EACA,eAAA;AAxhBJ;AA0hBI;EACE,kBAAA;AAxhBN;AA2hBI;EACE,iBAAA;AAzhBN;AA6hBM;EACE,6CA9/EK;AAm+Db;AAgiBE;EACE,SAAA;AA9hBJ;;AAkiBA;EACE,WAAA;AA/hBF;;AAkiBA;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,yBAAA;UAAA,iBAAA;EACA,YAAA;AA/hBF;AAiiBE;EACE,+BAnhFO;EAohFP,wBAAA;EACA,gCAAA;AA/hBJ;AAiiBI;EACE,cA5hFC;AA6/DP;AAoiBI;EACE,cAliFC;EAmiFD,wBAAA;AAliBN;;AAuiBA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AApiBF;AAsiBE;EACE,wBAAA;EAAA,gBAAA;EACA,UAAA;AApiBJ;;AAwiBA;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;AAriBF;AAuiBE;EACE,mCAAA;EAAA,2BAAA;EACA,MAAA;AAriBJ;AAwiBE;EACE,aAAA;AAtiBJ;AAyiBE;EACE,YAAA;AAviBJ;AA0iBE;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;AAxiBJ;AA0iBI;EACE,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,UAAA;AAxiBN;AA2iBI;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;AAziBN;AA2iBM;EACE,aA1lFD;EA2lFC,gBAAA;EACA,iBAAA;AAziBR;AA8iBE;EACE,2CA1mFW;EA2mFX,kBAAA;EACA,cAlnFK;EAmnFL,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,gCAAA;AA5iBJ;AA8iBI;EACE,2CAtnFS;AA0kEf;AA+iBI;EACE,YAAA;EACA,oBAAA;EACA,+BAloFO;EAmoFP,iBAAA;EACA,sBAAA;EACA,WAAA;AA7iBN;AAijBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AA/iBJ;AAijBI;EACE,gBAAA;EACA,aAAA;EACA,kCAAA;EACA,qBAAA;AA/iBN;AAijBM;EACE,cApnFA;AAqkER;AAkjBM;EACE,cAjrFD;AAioEP;AAmjBM;EACE,cAvpFA;AAsmER;AAojBM;EACE,cAvpFD;AAqmEP;AAsjBI;EACE,+BAxpFK;EAypFL,SAAA;EACA,qBAAA;AApjBN;AAujBI;EACE,aAAA;EACA,SAAA;EACA,sBAAA;AArjBN;AAujBM;EACE,iBAAA;EACA,SAAA;EACA,kCAAA;AArjBR;AAujBQ;EACE,kBAAA;EACA,gBAAA;AArjBV;AAwjBQ;EACE,cA1pFF;AAomER;AAyjBQ;EACE,cAvtFH;AAgqEP;AA0jBQ;EACE,cA7rFF;AAqoER;AA2jBQ;EACE,cA7rFH;AAooEP;AA4jBQ;EACE,sCAvrFD;AA6nET;AA+jBI;EACE,+BAnsFK;EAosFL,aAAA;EACA,sBAAA;AA7jBN;AA+jBM;EACE,8BAAA;AA7jBR;AAgkBM;EACE,gCAAA;AA9jBR;AAikBM;EACE,wDAAA;AA/jBR;AAkkBU;EACE,wDAAA;AAhkBZ;AAqkBM;EACE,4BApvFK;AAirEb;AAqkBQ;EACE,qDAAA;AAnkBV;AAskBY;EACE,qDAAA;AApkBd;AA0kBM;EACE,6BA1wFG;AAksEX;AA0kBQ;EACE,sDAAA;AAxkBV;AA2kBY;EACE,sDAAA;AAzkBd;AA+kBM;EACE,6BA3vFI;AA8qEZ;AA+kBQ;EACE,sDAAA;AA7kBV;AAglBY;EACE,sDAAA;AA9kBd;AAolBM;EACE,+BApwFG;AAkrEX;AAolBQ;EACE,wDAAA;AAllBV;AAqlBY;EACE,wDAAA;AAnlBd;AAylBM;EAGE,8BAryFK;AA4sEb;AA2lBQ;EACE,uDAAA;AAzlBV;AA4lBY;EACE,uDAAA;AA1lBd;AAgmBM;EACE,6BAzxFK;AA2rEb;AAgmBQ;EACE,sDAAA;AA9lBV;AAimBY;EACE,sDAAA;AA/lBd;AAqmBM;EAGE,8BApyFG;AA+rEX;AAumBQ;EACE,uDAAA;AArmBV;AAwmBY;EACE,uDAAA;AAtmBd;AA4mBM;EACE,8BA9yFI;AAosEZ;AA4mBQ;EACE,uDAAA;AA1mBV;AA6mBY;EACE,uDAAA;AA3mBd;AAinBM;;EAEE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AA/mBR;AAinBQ;;EACE,mBAAA;EACA,4CAz1FG;EA01FH,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,uBAAA;EACA,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,aAAA;AA9mBV;AAgnBU;;EACE,0BAAA;AA7mBZ;AA+mBY;;EACE,aAz2FP;EA02FO,mBAAA;AA5mBd;AAinBY;;EACE,6CA72FD;AA+vEb;AAknBU;;EACE,YAAA;AA/mBZ;AAmnBQ;;EACE,6CAv3FG;EAw3FH,kBAAA;EACA,oBAAA;EACA,qBAAA;AAhnBV;AAonBM;EACE,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AAlnBR;AAonBQ;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,+BAAA;EACA,cAAA;AAlnBV;AAonBU;EACE,kBAAA;AAlnBZ;AAqnBU;EACE,gBAAA;AAnnBZ;AAsnBU;EACE,uCAt5FC;EAu5FD,YAAA;AApnBZ;AAwnBY;EACE,aA/5FP;EAg6FO,sBAAA;AAtnBd;AA2nBY;EACE,oCA17FC;AAi0Ef;AA6nBc;EACE,aAl8FP;AAu0ET;AAioBY;EACE,qCAl9FD;AAm1Eb;AAmoBc;EACE,aAz9FT;AAw1EP;AAuoBY;EACE,qCAh8FA;AA2zEd;AAyoBc;EACE,aAv8FR;AAg0ER;AA6oBY;EACE,uCAv8FD;AA4zEb;AA+oBc;EACE,aA/8FT;AAk0EP;AAmpBY;EACE,sCAr8FD;AAozEb;AAqpBc;EACE,aA58FT;AAyzEP;AA2pBI;EACE,aAAA;EACA,cAAA;AAzpBN;AA6pBE;;EAEE,kBAAA;AA3pBJ;AAiqBI;;;EACE,qBAAA;AA7pBN;AAgqBI;;;EACE,sBAAA;AA5pBN;AAgqBE;EACE,mBAAA;EACA,kDAAA;UAAA,0CAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,OAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,QAAA;EACA,8CAAA;EACA,YAAA;EACA,WAAA;AA9pBJ;AAgqBI;EACE,0CAniGS;EAoiGT,cAtiGG;AAw4ET;AAiqBI;EACE,2CApjGO;EAqjGP,cAtjGC;AAu5EP;AAkqBI;EACE,2CA3hGQ;EA4hGR,cA7hGE;AA63ER;AAmqBI;EACE,4CA5hGO;EA6hGP,cA9hGC;AA63EP;AAoqBI;EACE,SAAA;AAlqBN;AAqqBI;EACE,sBAAA;EACA,oBAAA;EACA,iBAAA;EACA,WAAA;AAnqBN;AAuqBE;EACE,cA9iGG;EA+iGH,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;AArqBJ;AAuqBI;EACE,0DAAA;EACA,qBAAA;AArqBN;AAuqBM;EACE,6CAtjGK;AAi5Eb;;AA2qBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAxqBF;AA0qBE;EACE,4CApkGS;EAqkGT,2BAAA;EACA,4BAAA;EACA,+BApkGO;EAqkGP,eAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAxqBJ;AA0qBI;EACE,6CA/kGO;AAu6Eb;AA2qBI;EACE,mBA/kGQ;EAglGR,cAvlGC;AA86EP;;AA8qBA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AA3qBF;AA6qBE;EACE,mBAAA;EACA,0BAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AA3qBJ;AA8qBE;EACE,4CA7mGS;EA8mGT,8BAAA;EACA,+BAAA;EACA,2BAAA;EACA,4BAAA;EACA,+BA/mGO;EAgnGP,eAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;AA5qBJ;AA8qBI;EACE,6CA5nGO;AAg9Eb;AA+qBI;EACE,mBA5nGQ;EA6nGR,cApoGC;AAu9EP;AAgrBI;EACE,mBAjoGQ;EAkoGR,+BAroGK;AAu9EX;AAkrBE;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;AAhrBJ;;AAorBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,wBAAA;AAjrBF;AAmrBE;EACE,mCAAA;EAAA,2BAAA;EACA,YAAA;AAjrBJ;AAorBE;EACE,oBAAA;EACA,SAAA;EACA,gBAAA;AAlrBJ;AAqrBE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;AAnrBJ;AAqrBI;EACE,cAAA;AAnrBN;AAqrBM;EACE,wBAAA;UAAA,gBAAA;EACA,sBAAA;EACA,yDAAA;EACA,0CAAA;EACA,0BAAA;EACA,4BAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAxrGD;EAyrGC,eAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;AAnrBR;AAqrBQ;EACE,aAAA;AAnrBV;AAwrBI;EACE,YAAA;EACA,oBAAA;EACA,kBAAA;AAtrBN;AAwrBM;EACE,+BAvsGG;EAwsGH,eAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AAtrBR;AAwrBQ;EACE,aAntGH;EAotGG,eAptGH;AA8hFP;;AA6rBA;EACE,kBAAA;EACA,WAAA;AA1rBF;AA4rBE;EACE,aAAA;EACA,mBAAA;AA1rBJ;AA6rBM;EACE,6BA3vGK;AAgkFb;AA8rBM;EACE,2BA/vGK;AAmkFb;AAisBM;EACE,8BA7wGG;AA8kFX;AAksBM;EACE,4BAjxGG;AAilFX;AAqsBM;EACE,8BA1vGI;AAujFZ;AAssBM;EACE,4BA9vGI;AA0jFZ;AAysBM;EACE,gCA/vGG;AAwjFX;AA0sBM;EACE,8BAnwGG;AA2jFX;AA6sBM;EACE,8BAhwGK;AAqjFb;AA8sBM;EACE,4BApwGK;AAwjFb;AAitBM;EACE,+BArwGG;AAsjFX;AAktBM;EACE,6BAzwGG;AAyjFX;AAqtBM;EACE,+BA9yGK;AA2lFb;AAstBM;EACE,6BAlzGK;AA8lFb;AAwtBI;EACE,YAAA;AAttBN;AAytBI;EACE,WAAA;AAvtBN;;AA4tBA;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;AAztBF;AA2tBE;EACE,cAzzGG;EA0zGH,SAAA;EACA,mBAAA;EACA,kBAAA;AAztBJ;AA4tBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AA1tBJ;AA4tBI;EACE,aAAA;EACA,mBAAA;AA1tBN;AA6tBI;EACE,qBAAA;EACA,SAAA;EACA,cA70GC;EA80GD,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AA3tBN;AA+tBU;EACE,cAt1GL;AAynFP;AAkuBM;EACE,iBAAA;AAhuBR;AAmuBM;EACE,kBAAA;AAjuBR;AAquBI;EACE,+BAj2GK;EAk2GL,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;AAnuBN;;AA0uBI;EACE,uDAAA;EACA,6DAAA;EACA,8BAAA;AAvuBN;AAyuBM;EACE,uDAAA;AAvuBR;;AA8uBE;EACE,wBAAA;UAAA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,iCAAA;EACA,WAAA;AA3uBJ;AA6uBI;EACE,0CAv4GK;EAw4GL,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,iCAAA;EACA,WAAA;AA3uBN;AA8uBI;EACE,0CAn5GK;EAo5GL,iCAAA;AA5uBN;AA8uBM;EACE,yBAh8GA;EAi8GA,UAAA;EACA,iCAAA;AA5uBR;;AAkvBA;;EAEE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;AA/uBF;AAivBE;;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;AA9uBJ;AAgvBI;;EACE,aAAA;EACA,mBAAA;AA7uBN;AA+uBM;;EACE,qBAAA;EACA,oBAAA;AA5uBR;AA+uBM;;EACE,gBAAA;AA5uBR;AAgvBI;;;;;;EAGE,SAAA;EACA,iCAAA;AA3uBN;AA8uBI;;EACE,4BAh+GO;AAqvFb;AA6uBM;;EACE,4BAn+GK;AAyvFb;AA8uBI;;;;EAEE,cA1+GG;AAgwFT;AA8uBM;;EACE,6BAz9GI;AA8uFZ;AA6uBQ;;EACE,6BA59GE;AAkvFZ;AA8uBM;;;;EAEE,cAr+GA;AA2vFR;AA+uBM;;EACE,+BAn+GG;AAuvFX;AA8uBQ;;EACE,+BAt+GC;AA2vFX;AA+uBM;;;;EAEE,cAh/GD;AAqwFP;AAgvBM;;EACE,6BAphHG;AAuyFX;AA+uBQ;;EACE,6BAvhHC;AA2yFX;AAgvBM;;;;EAEE,cAjiHD;AAqzFP;AAivBM;;EACE,6BAx/GK;AA0wFb;AAgvBQ;;EACE,6BA3/GG;AA8wFb;AAivBM;;;;EAEE,sCApgHC;AAuxFT;AAkvBM;;EACE,8BAlgHG;AAmxFX;AAivBQ;;EACE,8BArgHC;AAuxFX;AAkvBM;;;;EAEE,cA9gHD;AAgyFP;AAmvBM;;EACE,8BAhjHK;AAg0Fb;AAkvBQ;;EACE,8BAnjHG;AAo0Fb;AAmvBM;;;;EAEE,cA1jHC;AA20FT;AAovBE;;EACE,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AAjvBJ;AAovBM;;;;EAEE,iBAAA;AAhvBR;AAkvBQ;;;;EACE,iBAAA;AA7uBV;AAivBM;;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;AA9uBR;AAkvBI;;EACE,0CAhmHS;AAi3Ff;AAkvBQ;;;;;;EAGE,eAxmHD;AA23FT;AAgvBQ;;EACE,4BA3mHG;AA83Fb;AAkvBI;;EACE,2CA9lHQ;AA+2Fd;AAkvBQ;;;;;;EAGE,eArmHF;AAw3FR;AAgvBQ;;EACE,6BAtmHE;AAy3FZ;AAkvBI;;EACE,4CA1mHO;AA23Fb;AAkvBQ;;;;;;EAGE,eAjnHH;AAo4FP;AAgvBQ;;EACE,+BAjnHC;AAo4FX;AAkvBI;;EACE,2CA5pHO;AA66Fb;AAkvBQ;;;;;;EAGE,eAnqHH;AAs7FP;AAgvBQ;;EACE,6BAnqHC;AAs7FX;AAkvBI;;EACE,2CAhoHS;AAi5Ff;AAkvBQ;;;;;;EAGE,uCAvoHD;AA05FT;AAgvBQ;;EACE,6BAxoHG;AA25Fb;AAkvBI;;EACE,4CA3oHO;AA45Fb;AAkvBQ;;;;;;EAGE,eAlpHH;AAq6FP;AAgvBQ;;EACE,8BAnpHC;AAs6FX;AAkvBI;;EACE,4CAvrHS;AAw8Ff;AAkvBQ;;;;;;EAGE,eA/rHD;AAk9FT;AAgvBQ;;EACE,8BAlsHG;AAq9Fb;AAmvBM;;EACE,uCAAA;EACA,mBAAA;AAhvBR;AAmvBM;;EACE,YAAA;EACA,YAAA;AAhvBR;AAovBQ;;;;;;EAGE,eAzsHH;AA09FP;AAkvBQ;;EACE,cA7sHH;AA89FP;;AAsvBA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AAnvBF;AAqvBE;EACE,kCAAA;AAnvBJ;;AAuvBA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;AApvBF;AAsvBE;EACE,iDAAA;UAAA,yCAAA;EACA,kCApvHS;EAqvHT,SAAA;EACA,kBAAA;EACA,cA/vHK;EAgwHL,eAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,gCAAA;AApvBJ;AAsvBI;EACE,mBAAA;AApvBN;AAsvBM;EACE,eAAA;AApvBR;AAwvBI;EACE,kBAAA;EACA,eAlxHG;AA4hGT;;AA2vBA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAxvBF;;AA2vBA;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AAxvBF;AA0vBE;EACE,2CAvzHS;EAwzHT,cAzzHG;EA0zHH,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,uCAAA;EACA,qBAAA;AAxvBJ;AA0vBI;EACE,2CA/zHO;AAukGb;AA4vBE;EACE,cA9xHQ;EA+xHR,gBAAA;EACA,gBAAA;AA1vBJ;;AA8vBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AA3vBF;AA6vBE;EACE,kBAAA;EACA,kBAAA;AA3vBJ;AA8vBE;EACE,cAvzHG;EAwzHH,gBAAA;EACA,SAAA;EACA,mBAAA;AA5vBJ;AA+vBE;EACE,oBAAA;EACA,gBAAA;AA7vBJ;AAgwBE;EACE,6BAj2HO;AAmmGX;AAgwBI;EACE,cAx2HC;AA0mGP;AAkwBE;EACE,+BAv0HO;AAukGX;AAkwBI;EACE,cA90HC;AA8kGP;AAowBE;EACE,8BAj0HO;AA+jGX;AAowBI;EACE,cAv0HC;AAqkGP;AAswBE;EACE,8BAp3HQ;AAgnGZ;AAswBI;EACE,cA33HE;AAunGR;AAwwBE;EACE,6BAz2HS;AAmmGb;AAwwBI;EACE,cA/2HG;AAymGT;AA0wBE;EACE,8BAr1HQ;AA6kGZ;AA0wBI;EACE,cA31HE;AAmlGR;;AA6wBA;EACE,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;AA1wBF;AA4wBE;EACE,cAAA;AA1wBJ;AA4wBI;EACE,2CAp6HO;EAq6HP,sBAAA;EACA,cAv6HC;EAw6HD,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;AA1wBN;AA8wBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,2DAAA;EACA,UAAA;AA5wBJ;AA8wBI;EACE,aAAA;EACA,kBAAA;AA5wBN;AA8wBM;EACE,yBA15HY;EA25HZ,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AA5wBR;AA8wBQ;EACE,yBA35HU;AA+oGpB;AA+wBQ;EACE,sBA78HF;EA88HE,SAAA;AA7wBV;AA+wBU;EACE,yBAn6HQ;AAspGpB;AAixBQ;EACE,SAAA;AA/wBV;AAoxBI;EACE,mBAAA;EACA,kDAt7HO;EAu7HP,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;AAlxBN;AAoxBM;EACE,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;AAlxBR;AAqxBM;EACE,mDAr8HK;AAkrGb;AAsxBM;EACE,eAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AApxBR;AAsxBQ;EACE,mBAAA;EACA,YAAA;EACA,WAAA;AApxBV;AAwxBM;EACE,sBAAA;EACA,cA19HD;EA29HC,iBAAA;AAtxBR;AAyxBM;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AAvxBR;AAyxBQ;EACE,gBAAA;EACA,uBAAA;AAvxBV;AA0xBQ;EACE,qCAAA;EACA,gBAAA;EACA,SAAA;EACA,sBAAA;AAxxBV;AA2xBQ;EACE,cAvhIH;EAwhIG,eAAA;EACA,SAAA;EACA,sBAAA;AAzxBV;AA4xBQ;EACE,mBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,qCAAA;AA1xBV;AA4xBU;EACE,mBAAA;AA1xBZ;AA6xBU;EACE,oBAAA;AA3xBZ;AA8xBU;EACE,wCAAA;AA5xBZ;AA8xBY;EACE,cA/gIP;AAmvGP;AAgyBU;EACE,6BAljID;AAoxGX;AAgyBY;EACE,cAzjIP;AA2xGP;AAkyBU;EACE,8BA1gID;AA0uGX;AAkyBY;EACE,cAhhIP;AAgvGP;AAoyBU;EACE,8BA7jIA;AA2xGZ;AAoyBY;EACE,cApkIN;AAkyGR;;AA2yBA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;AAxyBF;AA0yBE;EACE,kBAAA;EACA,qBAAA;EACA,YAAA;AAxyBJ;AA2yBE;EACE,gBAAA;AAzyBJ;AA4yBE;EACE,gBAAA;EACA,SAAA;EACA,oBAAA;AA1yBJ;AA6yBE;EACE,cAjkIQ;EAkkIR,SAAA;EACA,sBAAA;AA3yBJ;AA8yBE;EACE,cA/mIG;EAgnIH,mBAAA;AA5yBJ;AA+yBE;EACE,2CAnnIS;EAonIT,cArnIG;EAsnIH,qBAAA;AA7yBJ;AA+yBI;EACE,0BAAA;AA7yBN;;AAkzBA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AA/yBF;AAizBE;EACE,iDA1mIW;EA2mIX,iDAAA;EACA,gBAAA;EACA,aAAA;EACA,cApnIK;EAqnIL,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,wCAAA;AA/yBJ;AAizBI;EACE,2CAvnIS;AAw0Gf;AAkzBI;EACE,wCA1nIO;AA00Gb;AAozBM;EACE,aAAA;AAlzBR;AAszBI;EACE,SAAA;EACA,8BAAA;EACA,2BAAA;AApzBN;AAuzBI;EACE,SAAA;EACA,+BAAA;EACA,4BAAA;AArzBN;;AA0zBA;EACE,kBAAA;EACA,cAvoIU;EAwoIV,WAAA;AAvzBF;AAyzBE;EACE,cA9qII;EA+qIJ,gBAAA;AAvzBJ;AA0zBE;EACE,6BAprIO;EAqrIP,gBAAA;AAxzBJ;AA2zBM;EACE,cA7rID;AAo4GP;AA6zBI;EACE,YAAA;AA3zBN;;AAg0BA;EACE,kBAAA;EACA,cAjqIU;EAkqIV,iBAAA;AA7zBF;AA+zBE;EACE,cA7sIG;AAg5GP;AA+zBI;EACE,sCApqIG;AAu2GT;AAi0BE;EACE,6BAjtIO;EAktIP,gBAAA;EACA,kBAAA;AA/zBJ;AAi0BI;EACE,YAAA;EACA,sBAAA;EACA,oBAAA;AA/zBN;AAk0BI;EACE,cAhuIC;AAg6GP;;AAq0BA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,4BAAA;EACA,WAAA;AAl0BF;AAo0BE;EACE,4CA3sIS;EA4sIT,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gCAAA;AAl0BJ;AAo0BI;EACE,6CAhtIO;AA84Gb;AAq0BI;;EAEE,SAAA;AAn0BN;AAs0BI;EACE,+BAxtIK;EAytIL,sBAAA;AAp0BN;AAu0BI;EACE,cAjuIC;EAkuID,gBAAA;AAr0BN;AAy0BE;EACE,2CAnwIU;EAowIV,cArwII;EAswIJ,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AAv0BJ;AAy0BI;EACE,kBAAA;AAv0BN;AA00BI;EACE,4CA9wIQ;AAs8Gd;AA40BE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;AA10BJ;AA40BI;EACE,kBAAA;AA10BN;;AA+0BA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;AA50BF;AA+0BI;EACE,4CAzwIO;EA0wIP,cA3wIC;EA4wID,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AA70BN;AA+0BM;EACE,6CAlxIK;AAq8Gb;AAk1BE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,WAAA;AAh1BJ;AAk1BI;EACE,sBAAA;AAh1BN;AAm1BI;EACE,gBAAA;EACA,qBAAA;EACA,aAAA;AAj1BN;AAm1BM;EACE,cA9zIF;AA6+GN;AAo1BM;EACE,cAl1ID;AAggHP;AAq1BM;EACE,cAxzIA;AAq+GR;AAs1BM;EACE,cAxzID;AAo+GP;AAu1BM;EACE,cA7yID;AAw9GP;AA01BE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAx1BJ;AA21BE;EACE,aAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;AAz1BJ;AA21BI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AAz1BN;AA41BI;EACE,gBAAA;EACA,WAAA;AA11BN;AA41BM;EACE,WAAA;AA11BR;AA41BQ;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AA11BV;AAg2BE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;AA91BJ;AAg2BI;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;AA91BN;AAi2BI;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,2BAAA;EACA,oBAAA;AA/1BN;AAi2BM;;EAEE,cA53ID;EA63IC,gBAAA;EACA,SAAA;AA/1BR;AAk2BM;EACE,gCAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;AAh2BR;AAm2BM;EACE,kBAAA;AAj2BR;AAo2BM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AAl2BR;AAo2BQ;EACE,SAAA;AAl2BV;AAo2BU;EACE,6BAt6IF;AAokHV;AAq2BU;EACE,6BAx7ID;AAqlHX;AAs2BU;EACE,6BA/5IA;AA2jHZ;AAu2BU;EACE,+BA95ID;AAyjHX;AAw2BU;EACE,8BAp5ID;AA8iHX;AA02BQ;EACE,eAAA;EACA,sBAAA;EACA,WAAA;AAx2BV;AA02BU;EACE,6BAh8IF;AAwlHV;AA22BU;EACE,6BAl9ID;AAymHX;AA42BU;EACE,6BAz7IA;AA+kHZ;AA62BU;EACE,+BAx7ID;AA6kHX;AA82BU;EACE,8BA96ID;AAkkHX;AAg3BQ;EACE,kBAAA;AA92BV;;AAq3BA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;AAl3BF;AAo3BE;EACE,kBAAA;EACA,cAl/II;EAm/IJ,gBAAA;EACA,mBAAA;AAl3BJ;AAq3BE;EACE,kBAAA;EACA,2CAx/IU;EAy/IV,kBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;AAn3BJ;AAq3BI;EACE,4CAlgJQ;AA+oHd;AAs3BI;EACE,8BApgJM;EAqgJN,mBAAA;AAp3BN;AAs3BM;EACE,cA5gJA;AAwpHR;AAy3BE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,qBAAA;EACA,iBAAA;AAv3BJ;AAy3BI;EACE,kBAAA;EACA,8BAvhJM;EAwhJN,eAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,yBAAA;UAAA,iBAAA;AAv3BN;AAy3BM;EACE,cAriJA;AA8qHR;AA03BM;EACE,2CAxiJM;EAyiJN,cA1iJA;AAkrHR;;AA83BA;EACE,eAAA;AA33BF;;AA83BA;EACE,iCAAA;EACA,6BAAA;EACA,WAhkJM;EAikJN,0BAAA;EACA,gBAAA;EACA,eAAA;AA33BF;AA63BE;EACE,SAAA;AA33BJ;AA63BI;EACE,qBAAA;AA33BN;;AAg4BA;EACE,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AA73BF;AA+3BE;EACE,cAAA;EACA,cAAA;AA73BJ;AA+3BI;EACE,sBAAA;AA73BN;;AAk4BA;EACE;;IAEE,iBAAA;EA/3BF;EAk4BA;IACE,mBA9jJgB;IA+jJhB,sBAAA;IACA,YAAA;IACA,2BAAA;IACA,eAAA;IACA,eAAA;IACA,YAAA;EAh4BF;EAk4BE;IACE,qBAAA;IACA,gBAAA;IACA,QAAA;IACA,kBAAA;EAh4BJ;EAm4BE;IACE,iBAAA;IACA,QAAA;IACA,oBAAA;IACA,iBAAA;IACA,kBAAA;IACA,WAAA;IACA,qBAAA;EAj4BJ;EAo4BE;IACE,mBAAA;IACA,mBAzlJc;IA0lJd,aAAA;IACA,sBAAA;IACA,QAAA;IACA,iBAAA;IACA,cAAA;EAl4BJ;EAo4BI;IACE,aAAA;IACA,mBAAA;IACA,cAAA;IACA,uBAAA;IACA,qBAAA;IACA,kBAAA;EAl4BN;EAo4BM;IACE,uCAnoJG;EAiwHX;EAu4BE;IACE,mBA/mJc;IAgnJd,sBAAA;IACA,2BAAA;IACA,eAAA;IACA,oBAAA;IACA,MAAA;IACA,YAAA;EAr4BJ;EAu4BI;IACE,SAAA;IACA,cA3nJD;IA4nJC,gBAAA;IACA,cAAA;IACA,YAAA;EAr4BN;EA24BE;;;IAGE,8BAAA;EAz4BJ;EA84BE;;IAEE,gBAAA;IACA,UAAA;EA54BJ;EAi5BE;;IAEE,gBAAA;IACA,UAAA;EA/4BJ;EAi5BI;;IACE,wCAAA;EA94BN;EAm5BI;IACE,qBAAA;IACA,eAAA;EAj5BN;EAs5BI;IACE,mBAAA;IACA,cAAA;EAp5BN;EA05BE;IACE,oBAAA;IACA,UAAA;EAx5BJ;EA65BE;IACE,mBAAA;IACA,uBAAA;EA35BJ;EA+5BA;IACE,mBAAA;EA75BF;AACF;AAg6BA;EACE;;;;;;;;;;;;;;;IAeE,wBAAA;EA95BF;EAi6BA;;IAEE,aAAA;IACA,sBAAA;IACA,cAAA;IACA,eAAA;IACA,iBAAA;IACA,WAAA;EA/5BF;EAi6BE;;;;;;;;IAIE,aAAA;IACA,sBAAA;IACA,SAAA;IACA,WAAA;EA35BJ;EA+5BA;IACE,kBAAA;EA75BF;EAi6BE;IACE,WAAA;EA/5BJ;EAk6BE;IACE,gBAAA;EAh6BJ;EAo6BA;;IAEE,wBAAA;EAl6BF;EAs6BE;IACE,WAAA;EAp6BJ;EAy6BE;IACE,UAAA;EAv6BJ;EA66BI;IACE,aAAA;EA36BN;EAi7BE;IACE,aAAA;IACA,WAAA;IACA,uBAAA;IACA,YAAA;EA/6BJ;EAi7BI;IACE,kBAAA;EA/6BN;EAk7BI;IACE,WAAA;EAh7BN;EAs7BE;IACE,sBAAA;IACA,qBAAA;IACA,WAAA;EAp7BJ;EAs7BI;IACE,gBAAA;EAp7BN;EAy7BA;IACE,eAAA;EAv7BF;EA07BI;IACE,cAAA;IACA,aAAA;IACA,gBAAA;EAx7BN;EA27BI;IACE,oBAAA;EAz7BN;EA47BI;IACE,aAAA;EA17BN;EA+7BA;IACE,cAAA;IACA,WAAA;EA77BF;EAg8BI;IACE,eAAA;IACA,sBAAA;EA97BN;EAk8BE;IACE,SAAA;IACA,kBAAA;IACA,mBAAA;IACA,wBAAA;EAh8BJ;EAm8BE;IACE,oBAAA;IACA,iBAAA;IACA,wBAAA;EAj8BJ;EAo8BE;IACE,wBAAA;EAl8BJ;EAs8BI;IACE,wBAAA;EAp8BN;EAs8BM;IACE,aAAA;EAp8BR;EAy8BE;IACE,eAAA;IACA,8BAAA;EAv8BJ;EA08BE;IACE,kBAAA;IACA,YAAA;IACA,uBAAA;IACA,eAAA;EAx8BJ;EA48BA;IACE,wBAAA;EA18BF;EA68BI;IACE,wBAAA;EA38BN;EA68BM;IACE,aAAA;EA38BR;EAi9BA;IACE,6BAAA;IACA,8BAAA;EA/8BF;EAi9BE;IACE,WAAA;EA/8BJ;EAk9BE;IACE,uBAAA;IACA,WAAA;EAh9BJ;EAq9BE;IACE,yBAAA;IACA,cAAA;IACA,0BAAA;EAn9BJ;EAs9BE;IACE,gBAAA;EAp9BJ;EAw9BI;IACE,aAAA;EAt9BN;EAw9BM;IACE,eAAA;IAAA,gBAAA;EAt9BR;EA69BE;IACE,2BAAA;EA39BJ;EAg+BE;;IAEE,wBAAA;EA99BJ;EAi+BE;IACE,wBAAA;EA/9BJ;EAi+BI;IACE,eAAA;EA/9BN;EAo+BA;IACE,aAAA;IACA,cAAA;IACA,kDAAA;IACA,qBAAA;EAl+BF;EAo+BE;IACE,eAAA;EAl+BJ;EAs+BA;IACE,0BAAA;IACA,2BAAA;EAp+BF;EAu+BA;IACE,cAAA;EAr+BF;EAw+BA;IACE,mBAAA;IACA,gBAAA;EAt+BF;EA0+BE;IACE,sBAAA;EAx+BJ;EA0+BI;IACE,mBAAA;EAx+BN;EA8+BE;;IAEE,aAAA;EA5+BJ;EAg/BA;IACE,cAAA;EA9+BF;EAg/BE;;IAEE,eAAA;IACA,WAAA;EA9+BJ;AACF;AAo/BA;EACE,8BAAA;EACA,cAAA;AAl/BF;AAo/BE;EACE,8BAAA;AAl/BJ;AAq/BE;EACE,yBAAA;AAn/BJ;AAq/BI;EACE,yBAAA;AAn/BN;AAu/BE;EACE,8BAAA;AAr/BJ;AAw/BE;;EAEE,eAAA;AAt/BJ;AAw/BI;;EACE,cAAA;AAr/BN;AA2/BM;EACE,8BAAA;AAz/BR;AA4/BM;EACE,8BAAA;AA1/BR;AA4/BQ;EACE,8BAAA;AA1/BV;AAigCM;;EACE,8BAAA;AA9/BR;AAogCI;EACE,8BAAA;AAlgCN;AAwgCM;EACE,mDAAA;AAtgCR;AAygCM;EACE,yBAAA;AAvgCR;AA0gCM;EACE,qDAAA;AAxgCR;AA6gCM;EACE,8BAAA;AA3gCR;AA6gCQ;EACE,uCAAA;AA3gCV;AA+gCU;EACE,yBAAA;AA7gCZ;AA+gCY;EACE,sBAAA;AA7gCd;AAshCI;EACE,wCA/iKc;AA2hIpB;AAshCM;EACE,cAnjKQ;AA+hIhB;AAuhCM;EACE,0CArjKc;AAgiItB;AAuhCQ;EACE,qDAAA;AArhCV;AA8hCM;;EACE,YAAA;AA3hCR;AA8hCM;;EACE,wEAAA;AA3hCR;AA+hCI;EACE,8BAAA;AA7hCN;AAkiCQ;EACE,yBAAA;AAhiCV;AAqiCQ;EACE,yBAAA;AAniCV;AA0iCQ;EACE,yBAAA;AAxiCV;AA8iCM;EACE,qDAAA;AA5iCR;AA8iCQ;EACE,yBAAA;AA5iCV;AA+iCQ;;EAEE,mDAAA;AA7iCV;AAgjCQ;EACE,oDAAA;AA9iCV;AAgjCU;EACE,0BAAA;AA9iCZ;AAojCI;EACE,cA5pKc;AA0mIpB;AA0jCQ;;EACE,mDAAA;AAvjCV;AAyjCU;;EACE,mDAAA;AAtjCZ;AA0jCQ;;;;EAEE,yBAAA;AAtjCV;AA4jCM;;EACE,qDAAA;AAzjCR;AA4jCU;;;;;;EAGE,0BAAA;AAvjCZ;AA0jCU;;EACE,wBAAA;AAvjCZ;AA0jCU;;;;EAEE,2CAAA;AAtjCZ;AAyjCU;;EACE,yCAAA;AAtjCZ;AAyjCU;;EACE,mDAAA;EACA,mBAAA;AAtjCZ;AA4jCQ;;EACE,eAptKU;AA2pIpB;AA+jCE;EACE,qDAAA;AA7jCJ;AA+jCI;;;;EAIE,mDAAA;AA7jCN;AAgkCI;EACE,yBAAA;AA9jCN;AAmkCI;EACE,8BAAA;EACA,yBAAA;AAjkCN;AAukCM;EACE,qBAAA;AArkCR;AA6kCQ;EACE,mBAAA;EACA,6HAAA;EAEA,gEAAA;EACA,4BAAA;EACA,iCAAA;EACA,+CAAA;AA5kCV;AAmlCI;EACE,oCAAA;EACA,qDAAA;AAjlCN;AAmlCM;EACE,qDAAA;AAjlCR;AAmlCQ;EACE,oCAAA;AAjlCV;AAqlCM;EACE,oCAAA;AAnlCR;AA0lCM;EACE,8BAAA;EACA,6DAAA;EACA,YAAA;AAxlCR;AA0lCQ;EACE,8BAAA;AAxlCV;AAkmCU;EACE,yBAAA;AAhmCZ;AAmmCU;EACE,yBAxxKE;AAurId;AAmmCY;EACE,yBAAA;AAjmCd;AAumCM;EACE,yBAAA;AArmCR;AAumCQ;EACE,mDA9zKG;AAytIb;AAymCU;EACE,cAt0KL;AA+tIP;AA+mCI;EACE,yBAAA;AA7mCN;AAknCI;EACE,8BAAA;EACA,qEAAA;AAhnCN;AAmnCI;EACE,8BAAA;AAjnCN;AAonCI;EACE,mBAAA;EACA,0DAAA;AAlnCN;AAqnCI;EACE,8BAAA;AAnnCN;AAsnCI;EACE,qDAAA;AApnCN;AAynCI;EACE,8BAAA;AAvnCN;AA6nCM;EACE,mBAAA;EACA,cAr3KD;AA0vIP;AAkoCM;EACE,wBAAA;AAhoCR;;AAwoCA;EACE,yBAAA;EACA,yBAAA;EACA,wBAAA;AAroCF;;AAwoCA;EACE;IACE,UAAA;IACA,kCAAA;EAroCF;EAwoCA;IACE,UAAA;IACA,+BAAA;EAtoCF;AACF;AAyoCA;EACE,yBAAA;EACA,yBAAA;EACA,0BAAA;AAvoCF;;AA0oCA;EACE;IACE,UAAA;IACA,mCAAA;EAvoCF;EA0oCA;IACE,UAAA;IACA,+BAAA;EAxoCF;AACF;AA2oCA;EACE,yBAAA;EACA,yBAAA;EACA,+BAAA;AAzoCF;;AA4oCA;EACE;IACE,yBAAA;EAzoCF;AACF;AA4oCA;EACE,yBAAA;EACA,yBAAA;EACA,+BAAA;AA1oCF;;AA6oCA;EACE;IACE,yBAAA;EA1oCF;AACF;AA6oCA;EACE,yBAAA;EACA,yBAAA;EACA,2BAAA;AA3oCF;;AA8oCA;EACE;IACE,UAAA;IACA,+BAAA;EA3oCF;EA8oCA;IACE,UAAA;IACA,kCAAA;EA5oCF;AACF","sourcesContent":["\n$white: #fff;\n$light: #f8f9fa;\n$dark: #343a40;\n$black: #000;\n$blue: #007bff;\n$blue-light: #007bff20;\n$blue-hover: #007bff30;\n$blue-light-opaque: #eff7ff;\n$blue-mid: #007bff99;\n$pblue: #4c75f2;\n$pblue-light: #4c75f210;\n$pblue-hover: #4c75f230;\n$pblue-light-opaque: #eff7ff;\n$pblue-mid: #4c75f299;\n$pblue-dark: #4c75f2dd;\n$cherry: #ff073a;\n$cherry-mid: #ff073a99;\n$cherry-light: #ff073a20;\n$cherry-hover: #ff073a30;\n$cherry-light-opaque: #ffe0e6;\n$red: #dc3545;\n$red-light: #dc354520;\n$red-mid: #dc354599;\n$red-hover: #dc354530;\n$orange: #fd7e14;\n$orange-mid: #fd7e1499;\n$orange-light: #fd7e1420;\n$orange-hover: #fd7e1430;\n$orange-light-opaque: #ffefe2;\n$yellow: #ffc107;\n$yellow-light: #ffc10720;\n$yellow-hover: #ffc10730;\n$yellow-mid: #ffc10799;\n$yellow-light-opaque: #fff7e0;\n$green: #28a745;\n$green-light: #28a74520;\n$green-hover: #28a74530;\n$green-mid: #28a74599;\n$gray: #6c757d;\n$gray-light: #6c757d10;\n$gray-light-opaque: #f6f6f7;\n$gray-hover: #6c757d20;\n$gray-mid: #6c757d99;\n$gray-middark: #6c757d30;\n$gray-dark: #343a40;\n$gray-opaque: #f1f1f1;\n$gray-hover-opaque: #edeeef;\n$gray-hover-darker-opaque: #f6f6f7;\n$purple: #201aa2dd;\n$purple-light: #201aa220;\n$purple-hover: #201aa230;\n$purple-mid: #201aa299;\n$purple-light-opaque: #e3e2f3;\n$pink: #db5581;\n$pink-light: #db558120;\n$pink-hover: #db558130;\n$pink-mid: #db558199;\n$brown: #b6854d;\n$brown-light: #b6854d20;\n$brown-hover: #b6854d30;\n$brown-mid: #b6854d99;\n$brick: #e23028;\n$brick-light: #e2302810;\n$brick-hover: #e2302820;\n\n// Dark mode variables\n$dark-m-gray: #161625;\n$dark-mid-subtext: #bdb8ae;\n$dark-m-white: #e1e1e1;\n$dark-m-blue: #3391ff;\n$dark-m-purple: #9673b9;\n$dark-m-purple-mid: #9673b9bb;\n$dark-m-purple-light: #40008050;\n$dark-m-purple-hover: #40008090;\n\n* {\n  font-family: 'archia';\n}\n\nhtml {\n  overflow-x: hidden;\n  width: 100vw;\n}\n\nbody {\n  -webkit-tap-highlight-color: transparent;\n  -webkit-touch-callout: none;\n  margin: 0;\n  padding: 0;\n}\n\nh1 {\n  font-size: 24px ;\n  font-weight: 900;\n}\n\nh2 {\n  font-size: 18px !important;\n  font-weight: 400;\n}\n\nh3 {\n  font-size: 14px !important;\n  font-weight: 400;\n}\n\nh4 {\n  font-size: 13px !important;\n  font-weight: 900;\n}\n\nh5 {\n  font-size: 12px !important;\n  font-weight: 900;\n}\n\nh6 {\n  font-size: 11px !important;\n  font-weight: 600;\n}\n\n.App {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.arrow-up {\n  border-bottom: 5px solid $gray-mid;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  margin-left: 0.25rem;\n}\n\n.arrow-down {\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid $gray-mid;\n  margin-left: 0.25rem;\n}\n\n.Navbar {\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  height: 4rem;\n  justify-content: space-between;\n\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n\n  .navbar-left {\n    color: $gray-mid;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 600;\n    padding: 1.5rem;\n    text-align: center;\n    width: 3rem;\n\n    &:hover {\n      color: $gray;\n    }\n  }\n\n  .navbar-middle {\n    color: $gray;\n    font-size: 18px;\n    font-weight: 900;\n    text-transform: uppercase;\n\n    span {\n      color: $pblue;\n    }\n  }\n\n  .navbar-right {\n    color: $gray;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 600;\n    padding: 1.5rem;\n    text-align: center;\n    width: 3rem;\n  }\n\n  .language-toggle {\n    cursor: pointer;\n    font-weight: 900;\n    text-transform: uppercase;\n  }\n\n  .expand {\n    background: $gray-light-opaque;\n    color: $gray;\n    display: flex;\n    flex-direction: column;\n    width: 100vw;\n    z-index: 9999;\n\n    & > * {\n      border-bottom: 1px solid $gray-light;\n      border-top: 1px solid $gray-light;\n      padding: 1.5rem;\n      transition: all 0.15s ease-in-out;\n\n      &:hover {\n        background: $pblue-hover;\n      }\n\n      span {\n        &.focused {\n          background: $pblue-light;\n          color: $pblue;\n          padding: 0.25rem;\n        }\n      }\n    }\n\n    .expand-bottom {\n      align-self: flex-start;\n      border: 0;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n\n      h5 {\n        margin: 0;\n      }\n\n      &:hover {\n        background: none;\n      }\n    }\n  }\n}\n\n.Home {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin-left: 9rem;\n  margin-right: 3rem;\n\n  .home-left,\n  .home-right {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .home-left {\n    margin-right: 2.5rem;\n  }\n\n  .home-right {\n    margin-left: 2.5rem;\n  }\n\n  .header {\n    z-index: 99;\n  }\n}\n\n.alert {\n  align-items: flex-start;\n  background: $gray-light;\n  border-radius: 5px;\n  color: $gray;\n  display: flex;\n  flex-direction: row;\n  font-size: 10px;\n  padding: 0.5rem;\n\n  svg {\n    color: $gray-mid;\n    height: 16px;\n    width: 16px;\n  }\n\n  .alert-right {\n    margin-left: 0.25rem;\n    text-align: right;\n    width: 8.25rem;\n\n    a {\n      background: $gray-light;\n      color: $gray;\n      padding-left: 0.1rem;\n      padding-right: 0.1rem;\n\n      &:hover {\n        background: $gray-hover;\n      }\n    }\n\n    &.is-full {\n      width: 100%;\n    }\n  }\n\n  &.is-green {\n    background: $green-light;\n    color: $green;\n\n    svg {\n      stroke: $green-mid;\n    }\n  }\n}\n\n.StateHeader {\n  align-self: center;\n  display: flex;\n  flex-direction: row;\n  height: 5.25rem;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n  position: relative;\n  width: 100%;\n\n  & > * {\n    align-self: flex-start;\n  }\n\n  .header-left {\n    h1,\n    h5 {\n      margin: 0;\n    }\n\n    h1 {\n      color: $brick;\n      max-width: 20rem;\n    }\n\n    h5 {\n      color: $gray;\n      font-weight: 600;\n      margin-top: 0.5rem;\n    }\n  }\n\n  .header-right {\n    color: $purple-mid;\n    display: flex;\n    flex-direction: column;\n    text-align: right;\n\n    h2,\n    h5 {\n      font-weight: 600;\n      margin: 0;\n    }\n\n    h2 {\n      color: $purple;\n      font-weight: 900;\n    }\n\n    a {\n      background: $purple-light;\n      color: inherit;\n      text-decoration: none;\n\n      &:hover {\n        background: $purple-hover;\n      }\n    }\n  }\n}\n\n.State {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin-left: 9rem;\n  margin-right: 3rem;\n\n  .state-left,\n  .state-right {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .state-left {\n    margin-right: 2.5rem;\n    position: relative;\n  }\n\n  .state-right {\n    margin-left: 2.5rem;\n  }\n\n  a {\n    text-decoration: none;\n  }\n\n  .district-bar {\n    margin-bottom: 2.5rem;\n    width: calc(100% - 2rem);\n  }\n\n  .MapExplorer {\n    .header,\n    .map-stats,\n    .map-button,\n    .tabs-map,\n    .last-update,\n    .footnote {\n      display: none;\n    }\n\n    .anchor {\n      display: none;\n    }\n  }\n\n  .TimeseriesExplorer {\n    .anchor {\n      display: none;\n    }\n  }\n}\n\n.StateMeta {\n  align-self: center;\n  display: grid;\n  grid-gap: 1rem;\n  grid-template-columns: repeat(2, 1fr);\n  margin-bottom: 3rem;\n  width: calc(100% - 3rem);\n\n  &.population {\n    display: flex !important;\n    flex-direction: row !important;\n    justify-content: space-between !important;\n    margin: 0;\n    margin-bottom: 2.5rem;\n    margin-top: 2.5rem;\n\n    .alert {\n      margin: 0;\n    }\n  }\n\n  .meta-item {\n    border-radius: 5px;\n    min-height: 6rem;\n    padding-left: 1rem;\n    padding-top: 1rem;\n\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      margin: 0;\n    }\n\n    h5 {\n      font-weight: 600;\n    }\n\n    h2 {\n      font-weight: 600;\n    }\n\n    h3 {\n      font-weight: 600;\n      width: 10rem;\n      word-wrap: break-word;\n    }\n\n    h1 {\n      display: inline-block;\n      font-weight: 600;\n    }\n\n    &.population {\n      min-height: 1rem !important;\n      padding: 0 !important;\n\n      h1,\n      h3 {\n        color: $gray;\n      }\n    }\n\n    .meta-item-top {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      margin-right: 1rem;\n\n      & > * {\n        align-self: center;\n      }\n\n      h3 {\n        width: calc(100% - 2.5rem);\n      }\n\n      svg {\n        align-self: flex-start;\n        cursor: pointer;\n        stroke-width: 2.5px;\n        width: 16px;\n      }\n    }\n\n    .meta-item-middle {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n\n      * {\n        align-self: center;\n      }\n\n      svg {\n        cursor: pointer;\n        margin-right: 1rem;\n      }\n    }\n\n    p {\n      font-weight: 600;\n      margin-bottom: 1.25rem;\n      padding-right: 1rem;\n    }\n\n    &.confirmed {\n      background: $cherry-light;\n\n      h3,\n      h5,\n      svg,\n      p {\n        color: $cherry-mid;\n      }\n\n      h1 {\n        color: $cherry;\n      }\n    }\n\n    &.active {\n      background: $blue-light;\n\n      h3,\n      h5,\n      svg,\n      p {\n        color: $blue-mid;\n      }\n\n      h1 {\n        color: $blue;\n      }\n    }\n\n    &.recovery {\n      background: $green-light;\n\n      h3,\n      h5,\n      svg,\n      p {\n        color: $green-mid;\n      }\n\n      h1 {\n        color: $green;\n      }\n    }\n\n    &.mortality {\n      background: $gray-light;\n\n      h3,\n      h5,\n      svg,\n      p {\n        color: $gray-mid;\n      }\n\n      h1 {\n        color: $gray;\n      }\n    }\n\n    &.cpl {\n      background: $yellow-light;\n\n      h3,\n      h5,\n      svg {\n        color: $orange-mid;\n      }\n\n      h1 {\n        color: $orange;\n      }\n    }\n\n    &.tpl {\n      background: $purple-light;\n\n      h3,\n      h5,\n      svg,\n      p {\n        color: $purple-mid;\n      }\n\n      h1 {\n        color: $purple;\n      }\n    }\n\n    &.tpr {\n      background: $orange-light;\n\n      h3,\n      h5,\n      p,\n      svg {\n        color: $orange-mid;\n      }\n\n      h1 {\n        color: $orange;\n      }\n    }\n  }\n}\n\n.StateDropdown {\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  position: relative;\n\n  .state-name {\n    background: $brick-light;\n    border-radius: 5px;\n    cursor: pointer;\n    padding: 0.25rem;\n\n    &:hover {\n      &:not(.expanded) {\n        background-color: $brick-hover;\n      }\n    }\n  }\n\n  .dropdown {\n    background: $white;\n    border-radius: 5px;\n    height: 25rem;\n    left: -0.25rem;\n    overflow-y: scroll;\n    position: absolute;\n    top: 2.75rem;\n    width: 15rem;\n    z-index: 999;\n\n    .item {\n      color: $red;\n      cursor: pointer;\n      padding: 0.75rem;\n\n      &:hover {\n        background: $red-hover;\n      }\n    }\n  }\n\n  .backdrop {\n    background: $red-light;\n    height: 100vh;\n    left: 0;\n    pointer-events: none;\n    position: fixed;\n    top: 0;\n    width: 100vw;\n    z-index: 10;\n  }\n}\n\n.StatisticDropdown {\n  margin-left: -3px;\n  margin-top: 0.5rem;\n  position: relative;\n\n  .triangle-icon {\n    left: -16px;\n    position: absolute;\n    top: 2px;\n\n    svg {\n      vertical-align: middle !important;\n    }\n  }\n\n  select {\n    appearance: none;\n    background-color: $gray-light;\n    border: 0;\n    border-radius: 3px;\n    color: $gray;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 600;\n    max-width: 14rem;\n    min-width: 3rem;\n    outline-color: $gray-hover;\n    padding: 3px;\n\n    option {\n      background-color: #eee;\n      color: $gray;\n      padding: 3px;\n    }\n\n    &:hover {\n      background-color: $gray-hover;\n    }\n\n    &.confirmed {\n      background-color: $cherry-light;\n      color: $cherry;\n      outline-color: $cherry-hover;\n\n      &:hover {\n        background-color: $cherry-hover;\n      }\n    }\n\n    &.active {\n      background-color: $blue-light;\n      color: $blue;\n      outline-color: $blue-hover;\n\n      &:hover {\n        background-color: $blue-hover;\n      }\n    }\n\n    &.recovered {\n      background-color: $green-light;\n      color: $green;\n      outline-color: $green-hover;\n\n      &:hover {\n        background-color: $green-hover;\n      }\n    }\n\n    &.tested {\n      background-color: $purple-light;\n      color: $purple;\n      outline-color: $purple-hover;\n\n      &:hover {\n        background-color: $purple-hover;\n      }\n    }\n\n    &.other,\n    &.tpr,\n    &.cfr {\n      background-color: $orange-light;\n      color: $orange;\n      outline-color: $orange-hover;\n\n      &:hover {\n        background-color: $orange-hover;\n      }\n    }\n\n    &.vaccinated,\n    &.vaccinated1,\n    &.vaccinated2 {\n      background-color: $pink-light;\n      color: $pink;\n      outline-color: $pink-hover;\n\n      &:hover {\n        background-color: $pink-hover;\n      }\n    }\n\n    &.population {\n      background-color: $brown-light;\n      color: $brown;\n      outline-color: $brown-hover;\n\n      &:hover {\n        background-color: $brown-hover;\n      }\n    }\n  }\n}\n\n.labels {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin-bottom: 1rem;\n\n  .label {\n    align-items: center;\n    background: $gray-light !important;\n    border-radius: 5px !important;\n    color: $gray-mid !important;\n    cursor: pointer;\n    display: flex;\n    flex-direction: row;\n    font-size: 14px;\n    margin-bottom: 0.25rem;\n    margin-right: 0.25rem;\n    padding: 0.25rem 0.5rem;\n    text-transform: capitalize;\n\n    &.is-selected {\n      background: $yellow-hover !important;\n      color: $orange-mid !important;\n\n      &:hover {\n        background: $yellow-hover !important;\n        color: $orange-mid !important;\n      }\n    }\n\n    @media not all and (pointer: coarse) {\n      &:hover {\n        background: $yellow-light !important;\n        color: $orange-mid !important;\n      }\n    }\n\n    .count {\n      align-items: center;\n      background: inherit;\n      border-radius: 50%;\n      color: inherit;\n      display: flex;\n      flex-direction: row;\n      font-size: 12px;\n      height: 1.5rem;\n      justify-content: center;\n      margin-left: 0.25rem;\n      width: 1.5rem;\n    }\n  }\n}\n\n.Banner {\n  background: $red-light;\n  color: $red;\n  display: flex;\n  flex-direction: row;\n  font-size: 12px;\n  font-weight: 600;\n  justify-content: center;\n  text-decoration: none;\n\n  .wrapper {\n    align-items: center;\n    align-self: center;\n    display: flex;\n    justify-content: center;\n    padding: 1rem 0.75rem;\n    padding-left: 7rem;\n    text-align: center;\n    word-wrap: break-word;\n\n    .content {\n      margin: 0 0.5rem;\n    }\n\n    a {\n      align-items: center;\n      background-color: $red-light;\n      color: $red;\n      display: flex;\n      padding: 1px;\n      text-decoration: none;\n      white-space: nowrap;\n\n      &:hover {\n        background-color: $red-hover;\n      }\n    }\n  }\n}\n\n.Search {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 1rem;\n  position: relative;\n  width: 100%;\n\n  & > * {\n    align-self: center;\n  }\n\n  label {\n    color: $gray;\n    font-size: 0.75rem;\n    margin-bottom: 1rem;\n  }\n\n  .line {\n    background: $gray-light;\n    height: 1rem;\n    width: 2px;\n  }\n\n  input {\n    appearance: none !important;\n    background: #1e1e30;\n    border: 0;\n    border-radius: 5px;\n    box-shadow: 0 10px 35px rgba(0, 0, 0, 0.1);\n    color: $gray;\n    font-size: 1rem;\n    height: 4rem;\n    outline: none;\n    padding: 1rem;\n    padding-left: 3rem;\n    width: calc(100% - 0rem);\n  }\n\n  .search-input-wrapper {\n    position: relative;\n    width: 100%;\n  }\n\n  .search-placeholder {\n    color: $gray-mid;\n    font-size: 1rem;\n    left: 3rem;\n    opacity: 0.8;\n    pointer-events: none;\n    position: absolute;\n    top: 1.4rem;\n    transition: opacity 1s;\n\n    &.disappear {\n      opacity: 0;\n    }\n  }\n\n  .search-button {\n    svg {\n      color: $gray-mid;\n      left: 0.75rem;\n      position: absolute;\n      top: 1.25rem;\n      transition: all 0.2s ease-in-out;\n    }\n\n    &.is-expand {\n      svg {\n        left: 0.5rem;\n      }\n    }\n  }\n\n  .close-button {\n    background: $gray-light !important;\n    border-radius: 50%;\n    cursor: pointer;\n    display: flex;\n    flex-direction: row;\n    height: 20px;\n    justify-content: center;\n    position: absolute;\n    right: 1rem;\n    top: 1.35rem;\n    transition: all 0.2s ease-in-out;\n    width: 20px;\n\n    &:hover {\n      background: $gray-hover !important;\n    }\n\n    &.is-expand {\n      right: 0.75rem;\n    }\n\n    svg {\n      align-self: center;\n      position: absolute;\n      stroke: $gray-mid;\n      stroke-width: 3;\n      width: 12px;\n    }\n\n    &.custom {\n      background: $pink-light !important;\n      pointer-events: none;\n      z-index: 0;\n\n      svg {\n        stroke: $pink !important;\n      }\n    }\n  }\n\n  .feature {\n    background: $pink-light;\n    border-radius: 5px;\n    color: $pink;\n    cursor: pointer;\n    font-size: 0.75rem;\n    padding: 0.75rem;\n    text-align: center;\n  }\n\n  .expanded {\n    display: flex;\n    flex-direction: row;\n    margin-top: 2rem;\n    padding: 1rem;\n    padding-bottom: 0;\n    width: calc(100% - 4rem);\n\n    & > * {\n      flex: 1;\n    }\n\n    h4,\n    h3 {\n      color: $gray;\n      font-weight: 600;\n      margin: 0;\n      margin-bottom: 0.5rem;\n    }\n\n    h3 {\n      color: $pblue;\n      margin-bottom: 0.75rem;\n    }\n  }\n\n  .results {\n    padding: 1rem;\n    padding-bottom: 0;\n    width: calc(100% - 2rem);\n\n    a {\n      text-decoration: none !important;\n    }\n\n    .pan-divider {\n      color: $gray;\n      font-weight: 600;\n      padding: 1rem 0;\n    }\n\n    .result,\n    .essential-result {\n      align-self: flex-start;\n      border-bottom: 2px solid $gray-light;\n      color: $gray;\n      cursor: pointer;\n      display: flex;\n      flex-direction: row;\n      font-size: 0.9rem;\n      justify-content: space-between;\n      min-height: 2rem;\n      padding: 1rem;\n      transition: all 0.2s ease-in-out;\n\n      &:hover {\n        background: $gray-light;\n      }\n\n      & > * {\n        align-self: center;\n      }\n\n      .result-name {\n        max-width: 15rem;\n      }\n\n      .result-type {\n        background: $yellow-light;\n        border-radius: 2px;\n        color: $orange;\n        display: flex;\n        flex-direction: row;\n        font-size: 0.75rem;\n        padding: 0.25rem;\n\n        &:hover {\n          background: $yellow-hover;\n        }\n\n        svg {\n          margin-left: 0.25rem;\n          stroke: $orange-mid;\n          stroke-width: 3px;\n        }\n\n        * {\n          align-self: center;\n        }\n      }\n\n      .result-left {\n        display: flex;\n        flex-direction: row;\n\n        * {\n          align-self: center;\n        }\n      }\n\n      .result-zone {\n        border-radius: 50%;\n        height: 0.75rem;\n        margin-left: 0.5rem;\n        width: 0.75rem;\n\n        &.is-red {\n          background: $cherry-light;\n          border: 2px solid $cherry-mid;\n        }\n\n        &.is-orange {\n          background: $orange-light;\n          border: 2px solid $orange-mid;\n        }\n\n        &.is-green {\n          background: $green-light;\n          border: 2px solid $green-mid;\n        }\n      }\n    }\n\n    .essential-result {\n      display: flex;\n      flex-direction: column;\n\n      .result-top {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        width: 100%;\n\n        .result-top-left {\n          display: flex;\n          flex-direction: column;\n\n          .result-location {\n            display: flex;\n            flex-direction: row;\n            font-size: 0.75rem;\n          }\n\n          .result-distance {\n            color: $green;\n            display: flex;\n            flex-direction: row;\n            font-size: 0.75rem;\n          }\n        }\n      }\n\n      .result-category {\n        align-self: flex-start;\n        background: $pink-light;\n        border-radius: 2px;\n        color: $pink;\n        display: flex;\n        flex-direction: row;\n        font-size: 0.75rem;\n        height: 1rem;\n        padding: 0.25rem;\n        text-align: right;\n        text-transform: capitalize;\n\n        &:hover {\n          background: $pink-hover;\n        }\n\n        & > * {\n          align-self: center;\n        }\n\n        svg {\n          margin-left: 0.25rem;\n          stroke-width: 3px;\n          width: 12px;\n        }\n      }\n\n      .result-description {\n        align-self: flex-start;\n        font-size: 0.75rem;\n        margin-bottom: 0.5rem;\n        margin-top: 1rem;\n      }\n\n      .result-contacts {\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n        width: 100%;\n      }\n\n      .result-contact {\n        align-self: flex-start;\n        background: $gray-light;\n        border-radius: 2px;\n        color: $gray;\n        display: flex;\n        flex-direction: row;\n        font-size: 0.75rem;\n        height: 1rem;\n        margin-right: 0.25rem;\n        margin-top: 0.25rem;\n        padding: 0.25rem;\n        text-align: right;\n\n        &:hover {\n          background: $gray-hover;\n        }\n\n        a {\n          color: inherit;\n        }\n\n        & > * {\n          align-self: center;\n        }\n\n        svg {\n          margin-right: 0.25rem;\n          stroke: $gray-mid;\n          stroke-width: 3px;\n          width: 12px;\n        }\n      }\n    }\n  }\n\n  .suggestions {\n    display: flex;\n    flex-direction: column;\n    margin-right: 1rem;\n\n    .suggestion {\n      color: $gray-mid;\n      display: flex;\n      flex-direction: row;\n      padding: 0.1rem;\n\n      div {\n        padding-top: 1px;\n      }\n\n      h4 {\n        cursor: pointer;\n        margin-left: 0.25rem;\n        word-wrap: wrap;\n\n        &:hover {\n          text-decoration: underline;\n          text-decoration-thickness: 2px;\n        }\n      }\n    }\n  }\n}\n\n.header {\n  align-self: center;\n  display: flex;\n  flex-direction: column;\n  max-width: 40rem;\n  width: 100%;\n\n  & > * {\n    align-self: center;\n  }\n}\n\n.ActionsPanel {\n  margin-bottom: 0.3rem;\n  padding-bottom: 1rem;\n  padding-top: 1rem;\n  position: relative;\n  width: calc(100% - 1rem);\n\n  .actions {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    transition: all 1s;\n    width: 100%;\n\n    & > * {\n      align-self: center;\n      margin-left: 0.5rem;\n      margin-right: 0.5rem;\n    }\n\n    h5 {\n      color: $gray;\n      font-weight: 600;\n      margin: 0;\n    }\n\n    svg {\n      cursor: pointer;\n      fill: #a6abb0;\n      stroke: #a6abb0;\n      stroke-width: 0.5;\n      user-select: none;\n      width: 16px;\n\n      &:hover {\n        fill: $gray;\n        stroke: $gray;\n      }\n    }\n\n    .timeline-icon {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n\n      svg {\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n\n        path {\n          align-self: center;\n        }\n      }\n    }\n\n    .bell-icon {\n      height: 24px;\n      position: relative;\n\n      .indicator {\n        background: $pblue;\n        border-radius: 50%;\n        height: 7px;\n        position: absolute;\n        right: -3px;\n        top: -3px;\n        width: 7px;\n      }\n    }\n  }\n}\n\n.Timeline {\n  align-items: center;\n  user-select: none;\n  width: 100%;\n\n  .timeline {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    position: absolute;\n    top: 0;\n\n    .highlight {\n      color: $brown !important;\n      opacity: 0;\n      position: absolute;\n      text-align: center;\n      top: 3.25rem;\n      transform: translate3d(0, 10px, 0);\n      transition: all 0.3s;\n      width: 100%;\n\n      &.current {\n        opacity: 1;\n        transform: translate3d(0, 0, 0);\n      }\n\n      svg {\n        fill: #dc3545dd;\n        pointer-events: none;\n        stroke: none;\n      }\n    }\n\n    .wheel {\n      align-items: center;\n      color: #fff;\n      display: block;\n      height: 3rem;\n      margin-top: -0.75rem;\n      overflow: hidden;\n      width: 100%;\n    }\n\n    .wheel__inner {\n      align-items: center;\n      display: flex;\n      height: 100%;\n      justify-content: center;\n      pointer-events: none;\n      transform-style: preserve-3d;\n      width: 100%;\n    }\n\n    .wheel__slides {\n      height: 100%;\n      margin-top: 2px;\n      position: relative;\n      width: 100%;\n    }\n\n    .wheel__slide {\n      -webkit-backface-visibility: hidden;\n      align-items: center;\n      backface-visibility: hidden;\n      display: flex;\n      height: 100%;\n      justify-content: center;\n      position: absolute;\n      width: 100%;\n\n      h5 {\n        -moz-user-select: -moz-none;\n        -webkit-user-select: none;\n        border-radius: 4px;\n        cursor: pointer;\n        opacity: 0.6;\n        padding: 4px;\n        pointer-events: all;\n        transition: all 0.3s;\n        user-select: none;\n\n        &.current {\n          background-color: #6c757d20;\n          opacity: 0.8;\n\n          &:hover {\n            opacity: 1;\n          }\n        }\n\n        &:hover {\n          background-color: #6c757d30;\n          opacity: 0.8;\n        }\n\n        &::selection {\n          background: transparent !important;\n        }\n      }\n\n      .calendar-icon {\n        align-self: center;\n        cursor: pointer;\n        display: flex;\n        margin-left: 0.2rem;\n        opacity: 0;\n        transition: opacity 0.15s ease-in-out;\n\n        &.show {\n          opacity: 1;\n          pointer-events: all;\n        }\n      }\n    }\n\n    .wheel-buttons {\n      display: flex;\n      justify-content: space-evenly;\n      width: 100%;\n      z-index: 1;\n\n      .wheel-button {\n        align-items: center;\n        color: $gray;\n        display: flex;\n\n        &.left {\n          svg {\n            transform: rotate(180deg);\n          }\n        }\n\n        &.active {\n          svg {\n            fill: $pblue;\n            stroke: none;\n\n            &:hover {\n              fill: $pblue-mid;\n              stroke: none;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .Calendar {\n    align-items: center;\n    display: flex;\n    justify-content: center;\n\n    .react-calendar {\n      border-radius: 5px;\n      line-height: 2em;\n\n      *,\n      *::before,\n      *::after {\n        -moz-box-sizing: border-box;\n        -webkit-box-sizing: border-box;\n        box-sizing: border-box;\n      }\n\n      .react-calendar__navigation {\n        margin-bottom: 1em;\n      }\n\n      button {\n        border: 0;\n        border-radius: 5px;\n        margin: 0.125rem;\n        outline: none;\n\n        &:enabled {\n          &:hover {\n            cursor: pointer;\n          }\n        }\n      }\n    }\n\n    .react-calendar__viewContainer {\n      display: flex;\n    }\n\n    .react-calendar__navigation {\n      font-size: 25px;\n\n      button {\n        background-color: $gray-light;\n        color: $gray;\n        min-width: 44px;\n        padding: 1em 0.5em;\n\n        &:enabled {\n          &:hover {\n            background-color: #6c757d40;\n          }\n        }\n\n        &:disabled {\n          background: none;\n        }\n\n        div {\n          align-items: center;\n          display: flex;\n          justify-content: center;\n        }\n      }\n    }\n\n    .react-calendar__month-view__weekdays {\n      font-size: 0.75em;\n      font-weight: 600;\n      text-align: center;\n      text-transform: uppercase;\n    }\n\n    .react-calendar__month-view__weekdays__weekday {\n      padding: 0.5em;\n    }\n\n    .react-calendar__tile {\n      background: none;\n      color: $gray;\n      max-width: 100%;\n      padding: 1em 0.5em;\n      text-align: center;\n\n      &:enabled {\n        background-color: $gray-light;\n\n        &.react-calendar__tile--now {\n          background-color: #ffff76;\n          color: $black;\n\n          &:hover {\n            background-color: #ffffa9;\n          }\n        }\n\n        &.react-calendar__tile--active,\n        &.react-calendar__tile--hasActive {\n          background-color: #006edc;\n          color: $white;\n\n          &:hover {\n            background-color: #1087ff;\n          }\n        }\n\n        &.react-calendar__month-view__days__day--neighboringMonth {\n          background-color: #6c757d06;\n          color: #6c757d99;\n        }\n\n        &:hover {\n          background-color: $gray-hover;\n        }\n      }\n    }\n\n    .react-calendar__month-view {\n      .react-calendar__tile {\n        flex-basis: calc(100% / 7 - 0.25rem) !important;\n        max-width: calc(100% / 7 - 0.25rem) !important;\n      }\n    }\n\n    .react-calendar__year-view {\n      .react-calendar__tile {\n        flex-basis: calc(100% / 3 - 0.25rem) !important;\n        max-width: calc(100% / 3 - 0.25rem) !important;\n      }\n    }\n\n    .react-calendar__month-view__days__day--weekend {\n      color: $cherry;\n    }\n\n    .react-calendar__year-view,\n    .react-calendar__decade-view,\n    .react-calendar__century-view {\n      .react-calendar__tile {\n        color: $gray;\n        padding: 2em 0.5em;\n      }\n    }\n  }\n}\n\n.button {\n  background: $blue-light;\n  border: 0;\n  border-radius: 5px;\n  color: $blue-mid;\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  font-size: 0.75rem;\n  font-weight: 900;\n  margin-bottom: 0.5rem;\n  margin-top: 0.25rem;\n  outline: none;\n  padding: 0.5rem;\n  text-decoration: none;\n  text-transform: uppercase;\n  transition: background 0.2s ease-in-out;\n\n  svg {\n    padding-right: 6px;\n    stroke-width: 2px;\n    width: 20px;\n  }\n\n  &.is-purple {\n    background: $purple-light;\n    color: $purple-mid;\n\n    &:hover {\n      background: $purple-hover;\n    }\n  }\n\n  &.is-green {\n    background: $green-light;\n    color: $green-mid;\n\n    &:hover {\n      background: $green-hover;\n    }\n  }\n\n  &:hover {\n    background: $blue-hover;\n  }\n\n  & > * {\n    align-self: center;\n  }\n}\n\n.MapSwitcher {\n  align-self: center;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  position: absolute;\n  width: 50%;\n\n  .highlight {\n    pointer-events: none;\n    position: absolute;\n  }\n\n  .highlight,\n  .clickable {\n    border-radius: 5px;\n    cursor: pointer;\n    height: 14rem;\n    width: calc(25%);\n    z-index: 10;\n  }\n\n  .clickable {\n    transition: background 0.15s ease-in-out;\n\n    &:hover {\n      &.is-confirmed {\n        background: $cherry-light;\n      }\n\n      &.is-active {\n        background: $blue-light;\n      }\n\n      &.is-recovered {\n        background: $green-light;\n      }\n\n      &.is-deceased {\n        background: $gray-light;\n      }\n    }\n  }\n}\n\n.Level {\n  align-self: center;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n\n  .level-item {\n    display: flex;\n    flex-direction: column;\n\n    & > * {\n      align-self: center;\n    }\n  }\n\n  h1,\n  h5 {\n    margin-bottom: 0;\n  }\n\n  h1 {\n    font-size: min(3.75vw, 22px) !important;\n    font-weight: 600;\n  }\n\n  h4 {\n    margin-bottom: -0.5rem;\n  }\n\n  h5 {\n    font-weight: 600;\n    overflow-wrap: break-word;\n    text-align: center;\n    width: 100%;\n  }\n\n  .is-confirmed {\n    h1,\n    h5 {\n      color: $cherry;\n    }\n\n    h4 {\n      color: $cherry-mid;\n    }\n  }\n\n  .is-active {\n    h1,\n    h5 {\n      color: $blue;\n    }\n\n    h4 {\n      color: $blue-mid;\n    }\n  }\n\n  .is-recovered {\n    h1,\n    h5 {\n      color: $green;\n    }\n\n    h4 {\n      color: $green-mid;\n    }\n  }\n\n  .is-deceased {\n    h1,\n    h5 {\n      color: $gray;\n    }\n\n    h4 {\n      color: $gray-mid;\n    }\n  }\n\n  .is-tested {\n    h1,\n    h5 {\n      color: $purple;\n    }\n\n    h4 {\n      color: $purple-mid;\n    }\n  }\n\n  .is-vaccinated {\n    h1,\n    h5 {\n      color: $pink;\n    }\n\n    h4 {\n      color: $pink-mid;\n    }\n  }\n\n  .is-tpr {\n    h1,\n    h5 {\n      color: $orange;\n    }\n\n    h4 {\n      color: $orange-mid;\n    }\n  }\n}\n\n.VaccinationHeader {\n  align-items: center;\n  align-self: center;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0.25rem;\n  margin-top: 2rem;\n  width: 100%;\n\n  .level-vaccinated {\n    align-items: center;\n    align-self: center;\n    animation-delay: 200ms;\n    background: $pink-light;\n    border-radius: 5px;\n    color: $pink;\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 0.5rem;\n    padding: 0.5rem;\n\n    div {\n      font-size: 13px;\n      font-weight: 500;\n      margin: 0 0 0 0.25rem;\n    }\n  }\n\n  .progress-bar-wrapper {\n    color: $gray;\n    font-size: 12px;\n    margin-top: 0.5rem;\n    position: relative;\n    width: 100%;\n\n    .progress-bar {\n      background-color: $pink-light;\n      border-radius: 5px;\n      color: $pink;\n      height: 24px;\n      margin-bottom: 0.1rem;\n      margin-top: 0.1rem;\n      position: relative;\n\n      &.value {\n        background-image: linear-gradient(\n          45deg,\n          $pink-mid 25%,\n          $pink-light 25%,\n          $pink-light 50%,\n          $pink-mid 50%,\n          $pink-mid 75%,\n          $pink-light 75%,\n          $pink-light 100%\n        );\n        background-size: 14px 14px;\n        cursor: pointer;\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n        justify-content: center;\n        margin: 0;\n        opacity: 0.6;\n        position: absolute;\n\n        &.opaque {\n          background: $pink-mid;\n        }\n\n        &.highlighted {\n          opacity: 1;\n        }\n\n        span {\n          margin-left: calc(100% + 0.25rem);\n          width: max-content;\n        }\n      }\n    }\n\n    .legend {\n      opacity: 0.6;\n\n      &.highlighted {\n        opacity: 1;\n      }\n\n      .label-wrapper {\n        display: flex;\n\n        .label {\n          cursor: pointer;\n          flex-shrink: 0;\n        }\n      }\n\n      .arrow {\n        cursor: pointer;\n        margin-bottom: 0.2rem;\n        width: fit-content;\n      }\n    }\n  }\n}\n\nabbr {\n  text-decoration: none;\n\n  &.is-cherry {\n    color: $cherry;\n  }\n\n  &.is-blue {\n    color: $blue;\n  }\n\n  &.is-green {\n    color: $green;\n  }\n\n  &.is-gray {\n    color: $gray;\n  }\n}\n\n.TableLoader {\n  display: flex;\n  justify-content: center;\n  margin-top: 2rem;\n}\n\n.Icons {\n  font-size: 12px;\n  font-weight: 600;\n\n  span {\n    font-size: 8px;\n    font-weight: 600;\n    line-height: 6px;\n    position: absolute;\n    right: 5px;\n    top: 5px;\n    user-select: none;\n  }\n}\n\n.table-top {\n  align-items: flex-end;\n  align-self: center;\n  display: flex;\n  flex-direction: row;\n  font-weight: 600;\n  justify-content: space-between;\n  margin-bottom: 0.25rem;\n  width: 100%;\n\n  .table-top-left {\n    display: flex;\n    flex-direction: row;\n  }\n\n  .toggle {\n    align-items: center;\n    background: $gray-light;\n    border-radius: 5px;\n    color: $gray-mid;\n    cursor: pointer;\n    display: flex;\n    height: 2.5rem;\n    justify-content: center;\n    margin-right: 0.25rem;\n    user-select: none;\n    width: 2.5rem;\n\n    &.disabled {\n      cursor: not-allowed;\n    }\n\n    svg {\n      margin: 0.25rem;\n    }\n\n    &:hover {\n      &:not(.disabled) {\n        background: $gray-hover;\n      }\n    }\n  }\n\n  .option-toggle,\n  .expand-table-toggle {\n    &.is-highlighted {\n      background: $green-light;\n      color: $green;\n\n      &:hover {\n        background: $green-hover;\n      }\n    }\n  }\n\n  .info-toggle {\n    &.is-highlighted {\n      background: $yellow-light;\n      color: $yellow;\n\n      &:hover {\n        background: $yellow-hover;\n      }\n    }\n  }\n\n  .lakh-toggle {\n    &.is-highlighted {\n      background: $pink-light;\n      color: $pink;\n\n      &:hover {\n        background: $pink-hover;\n      }\n    }\n  }\n\n  .delta-toggle {\n    &.is-highlighted {\n      background: $blue-light;\n      color: $blue;\n\n      &:hover {\n        background: $blue-hover;\n      }\n    }\n  }\n\n  .expand-table-toggle {\n    color: $gray-mid;\n    margin-left: auto;\n    margin-right: 0;\n\n    &.is-highlighted {\n      svg {\n        transform: rotate(90deg);\n      }\n    }\n\n    svg {\n      cursor: pointer;\n      margin-bottom: 0.25rem;\n      transform: rotate(-90deg);\n      transition: transform 0.15s ease-in-out;\n    }\n  }\n\n  @media (min-width: 769px) {\n    margin-top: 1rem;\n  }\n}\n\n.table-helper {\n  align-self: center;\n  color: $gray;\n  display: flex;\n  flex-direction: column;\n  width: calc(100% - 2rem);\n\n  h5 {\n    color: $gray-mid;\n  }\n\n  .helper-top {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  .info-item {\n    align-items: center;\n    color: $gray;\n    display: flex;\n    flex-direction: row;\n    font-size: 12px;\n    font-weight: 600;\n    height: 1.5rem;\n\n    &:first-child {\n      margin-top: 1rem;\n    }\n\n    :first-child {\n      width: 1.6rem;\n\n      svg {\n        width: 15px;\n      }\n    }\n\n    p {\n      max-width: calc(100% - 1.6rem);\n    }\n\n    svg {\n      color: $gray-mid;\n      margin-bottom: 0.25rem;\n    }\n\n    .is-confirmed {\n      svg {\n        color: $cherry;\n      }\n    }\n\n    .is-active {\n      svg {\n        color: $blue;\n      }\n    }\n\n    .is-recovered {\n      svg {\n        color: $green;\n      }\n    }\n\n    .is-deceased {\n      svg {\n        color: $gray;\n      }\n    }\n\n    .is-tested {\n      svg {\n        color: $purple;\n      }\n    }\n\n    .is-vaccinated,\n    .is-vaccinated1,\n    .is-vaccinated2 {\n      svg {\n        color: $pink;\n      }\n    }\n\n    &.notes {\n      svg {\n        margin-bottom: 0;\n      }\n    }\n\n    &.sort {\n      svg {\n        margin-bottom: 0;\n      }\n    }\n\n    &.abbr {\n      sup {\n        position: relative;\n        top: -0.4em;\n        vertical-align: baseline;\n      }\n    }\n  }\n\n  .text {\n    color: $gray-mid;\n    font-weight: 600;\n\n    a {\n      background: $gray-light;\n      border-bottom: 2px solid $gray-hover;\n      color: $gray;\n      text-decoration: none;\n\n      &:hover {\n        background: $gray-hover;\n      }\n    }\n  }\n}\n\n.table-container {\n  align-self: center;\n  overflow-x: auto;\n  width: 100%;\n}\n\n.table {\n  border-radius: 3px;\n  display: inline-grid;\n  font-size: 12px;\n  grid-template-rows: auto;\n  min-width: 100%;\n\n  .state-meta {\n    grid-column: 1 / -1;\n    left: 0;\n    position: sticky;\n\n    .state-meta-top {\n      align-items: center;\n      display: flex;\n      flex-direction: row-reverse;\n      flex-wrap: wrap;\n      justify-content: space-between;\n      margin-bottom: 1 + 0.25rem;\n      margin-top: 1rem;\n\n      svg {\n        margin-right: 0.5rem;\n      }\n\n      .last-updated {\n        align-items: center;\n        color: $green;\n        display: flex;\n        flex-direction: row;\n      }\n\n      .state-page {\n        align-items: center;\n        background: $yellow-light;\n        border-radius: 5px;\n        color: $orange;\n        cursor: pointer;\n        display: flex;\n        flex-direction: row;\n        padding: 0.75rem;\n\n        p {\n          align-self: flex-end;\n          flex: 1;\n          margin: 0;\n          text-align: right;\n        }\n\n        &:hover {\n          background: $yellow-hover;\n        }\n      }\n    }\n\n    .state-meta-bottom {\n      padding-bottom: 1.5rem;\n\n      .disclaimer {\n        background: $brick-light;\n        border-radius: 5px;\n        color: $brick;\n        margin: auto;\n        padding: 1rem 0.25rem;\n        text-align: center;\n        width: 16rem;\n\n        svg {\n          margin-right: 0.5rem;\n        }\n      }\n    }\n  }\n\n  .row {\n    cursor: pointer;\n    display: contents;\n    width: 100%;\n\n    &:nth-child(odd) {\n      .cell {\n        background: $gray-light;\n      }\n    }\n\n    &.is-highlighted {\n      .cell {\n        background: $gray-hover-opaque !important;\n      }\n    }\n\n    &.heading {\n      .cell {\n        cursor: pointer;\n        user-select: none;\n\n        &:hover {\n          background: $gray-hover-opaque !important;\n        }\n      }\n    }\n\n    &.is-total {\n      position: sticky;\n      top: 0;\n\n      .cell {\n        background: $gray-hover-opaque !important;\n        padding-bottom: 0.75rem;\n      }\n    }\n\n    .cell {\n      align-items: center;\n      border-radius: 3px;\n      color: $gray;\n      display: flex;\n      flex-direction: row;\n      margin-bottom: 0.25rem;\n      padding: 0.5rem;\n      position: relative;\n\n      &:not(:first-child) {\n        flex-basis: 4rem;\n        flex-grow: 1;\n        flex-shrink: 0;\n        justify-content: flex-end;\n      }\n\n      &:first-child {\n        background: $gray-hover-darker-opaque;\n        flex-basis: 7rem;\n        flex-grow: 0;\n        flex-shrink: 0;\n        justify-content: space-between;\n        left: 0;\n        position: sticky;\n        z-index: 11;\n\n        .sort-icon {\n          left: unset;\n          right: 0;\n        }\n      }\n\n      svg {\n        color: $gray-mid;\n        margin-left: 0.2rem;\n        stroke-width: 2.5px;\n      }\n\n      .sort-icon {\n        left: 0;\n        margin-left: 0.25rem;\n        margin-right: 0.25rem;\n        position: absolute;\n        top: 0;\n\n        &.is-confirmed {\n          svg {\n            color: $cherry;\n          }\n        }\n\n        &.is-active {\n          svg {\n            color: $blue;\n          }\n        }\n\n        &.is-recovered {\n          svg {\n            color: $green;\n          }\n        }\n\n        &.is-deceased {\n          svg {\n            color: $gray;\n          }\n        }\n\n        &.is-tested {\n          svg {\n            color: $purple;\n          }\n        }\n\n        &.is-vaccinated,\n        &.is-vaccinated1,\n        &.is-vaccinated2 {\n          svg {\n            color: $pink;\n          }\n        }\n      }\n\n      &.statistic {\n        align-items: flex-end;\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-end;\n\n        .total {\n          font-size: 14px;\n        }\n\n        .is-confirmed {\n          color: $cherry;\n        }\n\n        .is-active {\n          color: $blue;\n        }\n\n        .is-recovered {\n          color: $green;\n        }\n\n        .is-deceased {\n          color: $gray;\n        }\n\n        .is-tested {\n          color: $purple;\n        }\n\n        .is-vaccinated,\n        .is-vaccinated1,\n        .is-vaccinated2 {\n          color: $pink;\n        }\n      }\n\n      &:not(:last-child) {\n        margin-right: 0.25rem;\n      }\n\n      &.heading {\n        background: $gray-light-opaque;\n        font-size: 13px;\n        font-weight: 900;\n        padding: 1.25rem 0.5rem 0.75rem;\n        text-align: right;\n\n        &.state {\n          padding: 1.5rem 0.5rem 0.75rem;\n\n          .sort-icon {\n            top: 0.5rem;\n          }\n        }\n\n        &:hover {\n          background: $gray-hover-opaque !important;\n        }\n\n        svg {\n          margin-left: 0;\n          margin-right: 0.3rem;\n        }\n      }\n\n      .state-name,\n      .district-name {\n        font-size: 14px;\n        font-weight: 600;\n        max-width: 7rem;\n        word-wrap: break-word;\n      }\n    }\n  }\n\n  .spacer-row {\n    grid-column: 1 / -1;\n    left: 0;\n    position: sticky;\n\n    .spacer {\n      color: $gray-mid;\n      margin-bottom: 1 + 0.25rem;\n      margin-top: 1rem;\n      text-align: center;\n\n      p {\n        margin-left: auto;\n        margin-right: auto;\n        width: 10rem;\n      }\n\n      .fold {\n        cursor: pointer;\n\n        &:hover {\n          color: $gray;\n        }\n      }\n    }\n  }\n\n  .intersection {\n    display: block;\n  }\n}\n\n.Table {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 2.5rem;\n}\n\n.paginate {\n  align-items: center;\n  color: $gray;\n  display: flex;\n  justify-content: center;\n  margin-top: 1rem;\n\n  div {\n    background: $gray-light;\n    border-radius: 5px;\n    color: $gray-mid;\n    cursor: pointer;\n    display: flex;\n    padding: 0.5rem;\n\n    &.left {\n      margin-right: 1rem;\n    }\n\n    &.right {\n      margin-left: 1rem;\n    }\n\n    &:hover {\n      &:not(.disabled) {\n        background: $gray-hover;\n      }\n    }\n  }\n\n  h5 {\n    margin: 0;\n  }\n}\n\n#chart {\n  z-index: 10;\n}\n\n.anchor {\n  cursor: pointer;\n  position: absolute;\n  right: 0;\n  user-select: none;\n  z-index: 999;\n\n  svg {\n    color: $gray-mid;\n    transform: rotate(45deg);\n    transition: all 0.1s ease-in-out;\n\n    &:hover {\n      color: $gray;\n    }\n  }\n\n  &.stickied {\n    svg {\n      color: $gray;\n      transform: rotate(90deg);\n    }\n  }\n}\n\n.map-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  &.stickied {\n    position: sticky;\n    top: -6rem;\n  }\n}\n\n.MapExplorer {\n  align-self: center;\n  position: relative;\n  width: 100%;\n\n  &.stickied {\n    position: sticky !important;\n    top: 0;\n  }\n\n  &.hidden {\n    display: none;\n  }\n\n  .anchor {\n    top: -1.5rem;\n  }\n\n  .svg-parent {\n    display: block;\n    margin: auto;\n    margin-top: 2rem;\n    overflow: visible;\n    position: relative;\n    width: 90%;\n\n    &.maplegend {\n      margin-top: 0.6rem;\n      user-select: none;\n      z-index: 1;\n    }\n\n    svg {\n      align-self: center;\n      height: 100%;\n      overflow: visible;\n      width: 100%;\n\n      text {\n        fill: $gray;\n        font-weight: 600;\n        text-align: right;\n      }\n    }\n  }\n\n  .map-button {\n    background: $yellow-light;\n    border-radius: 5px;\n    color: $orange;\n    cursor: pointer;\n    font-size: 0.75rem;\n    font-weight: 900;\n    margin-bottom: 0.25rem;\n    padding: 0.5rem;\n    position: absolute;\n    right: 0;\n    transition: all 0.2s ease-in-out;\n\n    &:hover {\n      background: $yellow-hover;\n    }\n\n    svg {\n      height: 12px;\n      margin-left: 0.25rem;\n      stroke: $orange-mid;\n      stroke-width: 3px;\n      vertical-align: middle;\n      width: 12px;\n    }\n  }\n\n  .panel {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    min-height: 6rem;\n    padding-top: 1rem;\n    position: relative;\n\n    h2 {\n      font-weight: 900;\n      margin-top: 0;\n      transition: color 0.3s ease-in-out;\n      word-wrap: break-word;\n\n      &.confirmed {\n        color: $brick;\n      }\n\n      &.active {\n        color: $blue;\n      }\n\n      &.recovered {\n        color: $green;\n      }\n\n      &.deceased {\n        color: $gray;\n      }\n    }\n\n    h4 {\n      color: $gray-mid;\n      margin: 0;\n      word-wrap: break-word;\n    }\n\n    .panel-left {\n      display: flex;\n      flex: 1;\n      flex-direction: column;\n\n      .district {\n        line-height: 15px;\n        margin: 0;\n        transition: color 0.3s ease-in-out;\n\n        span {\n          font-size: 0.75rem;\n          font-weight: 600;\n        }\n\n        &.confirmed {\n          color: $brick;\n        }\n\n        &.active {\n          color: $blue;\n        }\n\n        &.recovered {\n          color: $green;\n        }\n\n        &.deceased {\n          color: $gray;\n        }\n\n        &.tested {\n          color: $purple;\n        }\n      }\n    }\n\n    .panel-right {\n      color: $gray-mid;\n      display: flex;\n      flex-direction: column;\n\n      .disabled {\n        cursor: not-allowed !important;\n      }\n\n      svg {\n        transition: all 0.3s ease-in-out;\n      }\n\n      .is-highlighted {\n        background: $gray-middark !important;\n\n        &:hover {\n          &:not(.disabled) {\n            background: $gray-hover !important;\n          }\n        }\n      }\n\n      &.is-confirmed {\n        color: $cherry-mid;\n\n        .is-highlighted {\n          background: $cherry-light !important;\n\n          &:hover {\n            &:not(.disabled) {\n              background: $cherry-hover !important;\n            }\n          }\n        }\n      }\n\n      &.is-active {\n        color: $blue-mid;\n\n        .is-highlighted {\n          background: $blue-light !important;\n\n          &:hover {\n            &:not(.disabled) {\n              background: $blue-hover !important;\n            }\n          }\n        }\n      }\n\n      &.is-recovered {\n        color: $green-mid;\n\n        .is-highlighted {\n          background: $green-light !important;\n\n          &:hover {\n            &:not(.disabled) {\n              background: $green-hover !important;\n            }\n          }\n        }\n      }\n\n      &.is-deceased {\n        color: $gray-mid;\n\n        .is-highlighted {\n          background: $gray-middark !important;\n\n          &:hover {\n            &:not(.disabled) {\n              background: $gray-hover !important;\n            }\n          }\n        }\n      }\n\n      &.is-tpr,\n      &.is-cfr,\n      &.is-other {\n        color: $orange-mid;\n\n        .is-highlighted {\n          background: $orange-light !important;\n\n          &:hover {\n            &:not(.disabled) {\n              background: $orange-hover !important;\n            }\n          }\n        }\n      }\n\n      &.is-tested {\n        color: $purple-mid;\n\n        .is-highlighted {\n          background: $purple-light !important;\n\n          &:hover {\n            &:not(.disabled) {\n              background: $purple-hover !important;\n            }\n          }\n        }\n      }\n\n      &.is-vaccinated,\n      &.is-vaccinated1,\n      &.is-vaccinated2 {\n        color: $pink-mid;\n\n        .is-highlighted {\n          background: $pink-light !important;\n\n          &:hover {\n            &:not(.disabled) {\n              background: $pink-hover !important;\n            }\n          }\n        }\n      }\n\n      &.is-population {\n        color: $brown-mid;\n\n        .is-highlighted {\n          background: $brown-light !important;\n\n          &:hover {\n            &:not(.disabled) {\n              background: $brown-hover !important;\n            }\n          }\n        }\n      }\n\n      .switch-type,\n      .switch-statistic {\n        display: flex;\n        flex-direction: row;\n        justify-content: flex-end;\n        margin-bottom: 0.25rem;\n\n        .toggle {\n          align-items: center;\n          background: $gray-light;\n          border-radius: 5px;\n          cursor: pointer;\n          display: flex;\n          flex-direction: row;\n          height: 2.5rem;\n          justify-content: center;\n          margin-left: 0.25rem;\n          user-select: none;\n          width: 2.5rem;\n\n          &.back {\n            margin-right: 0 !important;\n\n            svg {\n              fill: $gray;\n              stroke: transparent;\n            }\n          }\n\n          &:hover {\n            &:not(.disabled) {\n              background: $gray-hover;\n            }\n          }\n\n          svg {\n            height: 100%;\n          }\n        }\n\n        .divider {\n          background: $gray-hover;\n          border-radius: 5px;\n          margin-left: 0.25rem;\n          width: 2px !important;\n        }\n      }\n\n      .switch-statistic {\n        align-self: flex-end;\n        flex-direction: row;\n        position: absolute;\n        top: 5rem;\n\n        .statistic-option {\n          background: none;\n          display: flex;\n          flex-direction: row;\n          height: 1.25rem;\n          margin-bottom: 0.25rem;\n          margin-left: 0.65rem !important;\n          width: 1.25rem;\n\n          span {\n            position: absolute;\n          }\n\n          &:hover {\n            background: none;\n          }\n\n          svg {\n            fill: $gray-hover;\n            stroke: none;\n          }\n\n          &.is-highlighted {\n            svg {\n              fill: $gray;\n              transform: scale(1.25);\n            }\n          }\n\n          &.is-confirmed {\n            svg {\n              fill: $cherry-hover;\n            }\n\n            &.is-highlighted {\n              svg {\n                fill: $cherry;\n              }\n            }\n          }\n\n          &.is-active {\n            svg {\n              fill: $blue-hover;\n            }\n\n            &.is-highlighted {\n              svg {\n                fill: $blue;\n              }\n            }\n          }\n\n          &.is-recovered {\n            svg {\n              fill: $green-hover;\n            }\n\n            &.is-highlighted {\n              svg {\n                fill: $green;\n              }\n            }\n          }\n\n          &.is-deceased {\n            svg {\n              fill: $gray-hover;\n            }\n\n            &.is-highlighted {\n              svg {\n                fill: $gray;\n              }\n            }\n          }\n\n          &.is-vaccinated {\n            svg {\n              fill: $pink-hover;\n            }\n\n            &.is-highlighted {\n              svg {\n                fill: $pink;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    &.bottom {\n      margin-top: 0;\n      padding-top: 0;\n    }\n  }\n\n  #legend,\n  #legend-choro {\n    position: absolute;\n  }\n\n  #chart,\n  #legend,\n  #legend-choro {\n    &:not(.zone) {\n      filter: saturate(1.5);\n    }\n\n    &.zone {\n      filter: saturate(1.25);\n    }\n  }\n\n  .disclaimer {\n    align-items: center;\n    backdrop-filter: saturate(180%) blur(20px);\n    border-radius: 5px;\n    bottom: 50%;\n    display: flex;\n    flex-direction: row;\n    font-size: 12px;\n    left: 0;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 0.5rem;\n    pointer-events: none;\n    position: absolute;\n    right: 0;\n    transition: background, color 0.3s ease-in-out;\n    width: 10rem;\n    z-index: 99;\n\n    &.is-confirmed {\n      background: $cherry-light;\n      color: $cherry;\n    }\n\n    &.is-active {\n      background: $blue-light;\n      color: $blue;\n    }\n\n    &.is-recovered {\n      background: $green-light;\n      color: $green;\n    }\n\n    &.is-deceased {\n      background: $gray-light;\n      color: $gray;\n    }\n\n    span {\n      flex: 1;\n    }\n\n    svg {\n      align-self: flex-start;\n      margin-right: 0.5rem;\n      stroke-width: 2px;\n      width: 16px;\n    }\n  }\n\n  .footnote {\n    color: $gray;\n    margin-bottom: 0;\n    margin-top: 1em;\n    text-align: left;\n    z-index: 1;\n\n    a {\n      border-bottom: 2px solid $gray-hover;\n      text-decoration: none;\n\n      &:hover {\n        background: $gray-hover;\n      }\n    }\n  }\n}\n\n.tabs {\n  display: flex;\n  flex-direction: row;\n  position: relative;\n\n  .tab {\n    background: $gray-light;\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n    color: $gray-mid;\n    cursor: pointer;\n    height: 3.25rem;\n    margin-right: 0.25rem;\n    min-width: 5rem;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    text-align: center;\n\n    &:hover {\n      background: $gray-hover;\n    }\n\n    &.focused {\n      background: $gray-opaque;\n      color: $gray;\n    }\n  }\n}\n\n.tabs-map {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  position: relative;\n  z-index: 99;\n\n  h4 {\n    display: table-cell;\n    font-size: 12px !important;\n    font-weight: 900;\n    height: 2rem;\n    margin-bottom: 0;\n    margin-top: 0;\n    vertical-align: middle;\n  }\n\n  .tab {\n    background: $gray-light;\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px;\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n    color: $gray-mid;\n    cursor: pointer;\n    height: 2rem;\n    margin-right: 0.25rem;\n    margin-top: 0.25rem;\n    min-width: 1.6rem;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    text-align: center;\n    transition: all 0.3s ease-in-out;\n\n    &:hover {\n      background: $gray-hover;\n    }\n\n    &.focused {\n      background: $gray-opaque;\n      color: $gray;\n    }\n\n    &.disabled {\n      background: $gray-opaque;\n      color: $gray-mid;\n    }\n  }\n\n  sup {\n    position: relative;\n    top: -0.5em;\n    vertical-align: top;\n  }\n}\n\n.TimeseriesExplorer {\n  align-self: center;\n  display: flex;\n  flex-direction: column;\n  width: calc(100% - 2rem);\n\n  &.stickied {\n    position: sticky !important;\n    top: -6.5rem;\n  }\n\n  .alert {\n    align-self: flex-end;\n    margin: 0;\n    margin-top: 1rem;\n  }\n\n  .state-selection {\n    display: flex;\n    flex-direction: row;\n    margin-top: 1rem;\n    max-width: calc(100% - 0.6rem);\n\n    .dropdown {\n      min-width: calc(60%);\n\n      select {\n        appearance: none;\n        background-color: #eee;\n        background-image: url('data:image/svg+xml,<svg width=\"24\" height=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m0,6l12,12l12,-12l-24,0z\" fill=\"gray\"/><path fill=\"none\" d=\"m0,0l24,0l0,24l-24,0l0,-24z\"/></svg>');\n        background-position-x: calc(100% - 0.4rem);\n        background-position-y: 50%;\n        background-repeat: no-repeat;\n        background-size: 0.6rem;\n        border: 2px solid #e8e8e9;\n        border-radius: 4px;\n        color: $gray;\n        cursor: pointer;\n        font-weight: 600;\n        padding: 0.5rem;\n        padding-right: 1.4rem;\n        width: 100%;\n\n        &:focus {\n          outline: none;\n        }\n      }\n    }\n\n    .reset-icon {\n      margin: auto;\n      margin-left: 0.75rem;\n      margin-top: 0.5rem;\n\n      svg {\n        color: $gray-mid;\n        cursor: pointer;\n        fill: #a6abb0;\n        stroke: #a6abb0;\n        stroke-width: 0.5;\n        width: 16px;\n\n        &:hover {\n          fill: $gray;\n          stroke: $gray;\n        }\n      }\n    }\n  }\n}\n\n.Timeseries {\n  align-self: center;\n  width: 100%;\n\n  .svg-parent {\n    height: 12rem;\n    margin-bottom: 1rem;\n\n    &.is-confirmed {\n      .stem {\n        stroke: $cherry-mid;\n      }\n\n      .trend-area {\n        fill: $cherry-mid;\n      }\n    }\n\n    &.is-active {\n      .stem {\n        stroke: $blue-mid;\n      }\n\n      .trend-area {\n        fill: $blue-mid;\n      }\n    }\n\n    &.is-recovered {\n      .stem {\n        stroke: $green-mid;\n      }\n\n      .trend-area {\n        fill: $green-mid;\n      }\n    }\n\n    &.is-deceased {\n      .stem {\n        stroke: $gray-mid;\n      }\n\n      .trend-area {\n        fill: $gray-mid;\n      }\n    }\n\n    &.is-tested {\n      .stem {\n        stroke: $purple-mid;\n      }\n\n      .trend-area {\n        fill: $purple-mid;\n      }\n    }\n\n    &.is-vaccinated {\n      .stem {\n        stroke: $pink-mid;\n      }\n\n      .trend-area {\n        fill: $pink-mid;\n      }\n    }\n\n    &.is-tpr {\n      .stem {\n        stroke: $orange-mid;\n      }\n\n      .trend-area {\n        fill: $orange-mid;\n      }\n    }\n\n    &.is-brush {\n      height: 4rem;\n    }\n\n    svg {\n      width: 100%;\n    }\n  }\n}\n\n.timeseries-header {\n  align-self: center;\n  position: relative;\n  width: 100%;\n\n  h1 {\n    color: $gray;\n    margin: 0;\n    margin-bottom: 2rem;\n    text-align: center;\n  }\n\n  .timeseries-options {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    margin-top: 1rem;\n\n    .timeseries-mode {\n      display: flex;\n      flex-direction: row;\n    }\n\n    .scale-modes {\n      align-items: flex-end;\n      bottom: 0;\n      color: $gray;\n      display: flex;\n      flex-direction: row;\n      right: 0;\n      z-index: 99;\n\n      &:hover {\n        label {\n          &.main {\n            color: $gray;\n          }\n        }\n      }\n\n      .timeseries-mode {\n        margin-left: 1rem;\n      }\n\n      & > * {\n        align-self: center;\n      }\n    }\n\n    label {\n      color: $gray-mid;\n      font-size: 0.75rem;\n      font-weight: 900;\n      margin-right: 0.25rem;\n      z-index: 99;\n    }\n  }\n}\n\n.disabled {\n  input {\n    &.switch {\n      background: $gray-light !important;\n      border: $gray-light 2px solid !important;\n      cursor: not-allowed !important;\n\n      &::after {\n        background: $gray-light !important;\n      }\n    }\n  }\n}\n\ninput {\n  &.switch {\n    appearance: none;\n    background-color: #fff;\n    border: 2px solid #d9dadc;\n    border-radius: 10px;\n    cursor: pointer;\n    height: 14px;\n    margin: 0;\n    outline: none;\n    position: relative;\n    transition: all 300ms ease-in-out;\n    width: 24px;\n\n    &::after {\n      background-color: $gray-mid;\n      border-radius: 50%;\n      content: '';\n      height: 10px;\n      left: 0;\n      position: absolute;\n      top: 0;\n      transition: all 300ms ease-in-out;\n      width: 10px;\n    }\n\n    &:checked {\n      background-color: $gray-mid;\n      transition: all 300ms ease-in-out;\n\n      &::after {\n        background-color: $light;\n        left: 10px;\n        transition: all 300ms ease-in-out;\n      }\n    }\n  }\n}\n\n.Timeseries,\n.Minigraph {\n  display: flex;\n  flex-direction: column;\n  margin-top: 1rem;\n  width: 100%;\n\n  .stats {\n    border-radius: 3px;\n    display: flex;\n    flex-direction: column;\n    left: 0.5rem;\n    padding: 0.25rem;\n    pointer-events: none;\n    position: absolute;\n    top: 0.5rem;\n\n    .stats-bottom {\n      display: flex;\n      flex-direction: row;\n\n      h6 {\n        margin-bottom: 0.1rem;\n        margin-left: 0.25rem;\n      }\n\n      & > * {\n        margin-top: auto;\n      }\n    }\n\n    h2,\n    h5,\n    h6 {\n      margin: 0;\n      transition: all 0.15s ease-in-out;\n    }\n\n    h5 {\n      color: $cherry-mid;\n\n      &.title {\n        color: $cherry-mid;\n      }\n    }\n\n    h2,\n    h6 {\n      color: $cherry;\n    }\n\n    &.is-recovered {\n      h5 {\n        color: $green-mid;\n\n        &.title {\n          color: $green-mid;\n        }\n      }\n\n      h2,\n      h6 {\n        color: $green;\n      }\n    }\n\n    &.is-deceased {\n      h5 {\n        color: $gray-mid;\n\n        &.title {\n          color: $gray-mid;\n        }\n      }\n\n      h2,\n      h6 {\n        color: $gray;\n      }\n    }\n\n    &.is-active {\n      h5 {\n        color: $blue-mid;\n\n        &.title {\n          color: $blue-mid;\n        }\n      }\n\n      h2,\n      h6 {\n        color: $blue;\n      }\n    }\n\n    &.is-tested {\n      h5 {\n        color: $purple-mid;\n\n        &.title {\n          color: $purple-mid;\n        }\n      }\n\n      h2,\n      h6 {\n        color: $purple;\n      }\n    }\n\n    &.is-vaccinated {\n      h5 {\n        color: $pink-mid;\n\n        &.title {\n          color: $pink-mid;\n        }\n      }\n\n      h2,\n      h6 {\n        color: $pink;\n      }\n    }\n\n    &.is-tpr {\n      h5 {\n        color: $orange-mid;\n\n        &.title {\n          color: $orange-mid;\n        }\n      }\n\n      h2,\n      h6 {\n        color: $orange;\n      }\n    }\n  }\n\n  .svg-parent {\n    align-self: center;\n    border-radius: 5px;\n    display: flex;\n    justify-content: center;\n    position: relative;\n    width: 100%;\n\n    svg {\n      .domain,\n      .tick {\n        stroke-width: 1.5;\n\n        line {\n          stroke-width: 1.5;\n        }\n      }\n\n      text {\n        font-size: 9px;\n        font-weight: 600;\n        stroke: transparent;\n      }\n    }\n\n    &.is-confirmed {\n      background: $cherry-light;\n\n      svg {\n        .domain,\n        .tick,\n        line {\n          stroke: $cherry;\n        }\n\n        text {\n          color: $cherry-mid;\n        }\n      }\n    }\n\n    &.is-recovered {\n      background: $green-light;\n\n      svg {\n        .domain,\n        .tick,\n        line {\n          stroke: $green;\n        }\n\n        text {\n          color: $green-mid;\n        }\n      }\n    }\n\n    &.is-deceased {\n      background: $gray-light;\n\n      svg {\n        .domain,\n        .tick,\n        line {\n          stroke: $gray;\n        }\n\n        text {\n          color: $gray-mid;\n        }\n      }\n    }\n\n    &.is-active {\n      background: $blue-light;\n\n      svg {\n        .domain,\n        .tick,\n        line {\n          stroke: $blue;\n        }\n\n        text {\n          color: $blue-mid;\n        }\n      }\n    }\n\n    &.is-tested {\n      background: $purple-light;\n\n      svg {\n        .domain,\n        .tick,\n        line {\n          stroke: $purple;\n        }\n\n        text {\n          color: $purple-mid;\n        }\n      }\n    }\n\n    &.is-vaccinated {\n      background: $pink-light;\n\n      svg {\n        .domain,\n        .tick,\n        line {\n          stroke: $pink;\n        }\n\n        text {\n          color: $pink-mid;\n        }\n      }\n    }\n\n    &.is-tpr {\n      background: $orange-light;\n\n      svg {\n        .domain,\n        .tick,\n        line {\n          stroke: $orange;\n        }\n\n        text {\n          color: $orange-mid;\n        }\n      }\n    }\n\n    &.is-brush {\n      .overlay {\n        fill: #6c757d40;\n        pointer-events: all;\n      }\n\n      .selection {\n        cursor: move;\n        stroke: none;\n      }\n\n      svg {\n        .domain,\n        .tick,\n        line {\n          stroke: $gray;\n        }\n\n        text {\n          color: $gray;\n        }\n      }\n    }\n  }\n}\n\n.Minigraph {\n  align-self: center;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin: 0;\n  margin-bottom: 2rem;\n  margin-top: 1rem;\n\n  .svg-parent {\n    background: transparent !important;\n  }\n}\n\n.floating-buttons {\n  bottom: 1rem;\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  position: fixed;\n  right: 1rem;\n  width: 3rem;\n  z-index: 1;\n\n  button {\n    backdrop-filter: saturate(180%) blur(2px);\n    background: $yellow-mid;\n    border: 0;\n    border-radius: 50%;\n    color: $orange;\n    cursor: pointer;\n    display: flex;\n    flex-direction: row;\n    margin: 0.25rem;\n    outline: none;\n    padding: 0.75rem;\n    transition: all 0.2s ease-in-out;\n\n    &:hover {\n      background: #ffa500;\n\n      svg {\n        stroke: #ffa500;\n      }\n    }\n\n    svg {\n      align-self: center;\n      stroke: $orange;\n    }\n  }\n}\n\n.Links {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.link {\n  align-self: center;\n  margin-bottom: 1rem;\n  margin-top: 1rem;\n  width: 34rem;\n\n  a {\n    background: $blue-light;\n    color: $blue;\n    font-weight: 900;\n    text-decoration: none;\n    text-transform: uppercase;\n    transition: background 0.2s ease-in-out;\n    word-wrap: break-word;\n\n    &:hover {\n      background: $blue-hover;\n    }\n  }\n\n  h3 {\n    color: $gray-dark;\n    font-weight: 900;\n    margin-bottom: 0;\n  }\n}\n\nfooter {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 4rem;\n  margin-top: 4rem;\n  width: 100%;\n\n  & > * {\n    align-self: center;\n    text-align: center;\n  }\n\n  h5 {\n    color: $gray;\n    font-weight: 600;\n    margin: 0;\n    margin-bottom: 2rem;\n  }\n\n  svg {\n    margin-right: 0.5rem;\n    padding: 0.25rem;\n  }\n\n  .telegram {\n    color: $blue-mid;\n\n    &:hover {\n      color: $blue;\n    }\n  }\n\n  .github {\n    color: $gray-mid;\n\n    &:hover {\n      color: $gray;\n    }\n  }\n\n  .instagram {\n    color: $pink-mid;\n\n    &:hover {\n      color: $pink;\n    }\n  }\n\n  .twitter {\n    color: $pblue-mid;\n\n    &:hover {\n      color: $pblue;\n    }\n  }\n\n  .api {\n    color: $yellow-mid;\n\n    &:hover {\n      color: $yellow;\n    }\n  }\n\n  .mail {\n    color: $brown-mid;\n\n    &:hover {\n      color: $brown;\n    }\n  }\n}\n\n.Volunteers {\n  align-items: center;\n  align-self: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-bottom: 1.5rem;\n  margin-left: 6rem;\n  margin-top: 4rem;\n  min-height: 30rem;\n  width: calc(100% - 6rem);\n\n  .wrapper {\n    max-width: 80%;\n\n    .description {\n      background: $blue-light;\n      border-radius: 0.25rem;\n      color: $blue;\n      font-size: 14px;\n      line-height: 1.5;\n      margin-bottom: 3rem;\n      padding: 1rem;\n      text-align: justify;\n      text-justify: inter-word;\n    }\n  }\n\n  .members {\n    display: grid;\n    grid-auto-rows: 6.5rem;\n    grid-column-gap: 1%;\n    grid-row-gap: 1rem;\n    grid-template-columns: repeat(auto-fit, minmax(20rem, 1fr));\n    width: 80%;\n\n    .last {\n      display: flex;\n      position: relative;\n\n      .Member {\n        background-color: $gray-light-opaque;\n        box-sizing: border-box;\n        height: 100%;\n        position: absolute;\n        width: 70%;\n\n        &:hover {\n          background-color: $gray-hover-opaque;\n        }\n\n        &.second {\n          background-color: $white;\n          left: 15%;\n\n          &:hover {\n            background-color: $gray-hover-opaque;\n          }\n        }\n\n        &.third {\n          left: 30%;\n        }\n      }\n    }\n\n    .Member {\n      align-items: center;\n      background-color: $gray-light;\n      border-radius: 0.25rem;\n      display: flex;\n      flex-direction: row;\n      padding: 1rem;\n      position: relative;\n      text-decoration: none;\n\n      > a {\n        height: 100%;\n        left: 0;\n        position: absolute;\n        top: 0;\n        width: 100%;\n      }\n\n      &:hover {\n        background-color: $gray-hover;\n      }\n\n      .image {\n        aspect-ratio: 1;\n        border-radius: 10px;\n        height: 100%;\n        margin-right: 1rem;\n\n        svg {\n          border-radius: 10px;\n          height: 100%;\n          width: 100%;\n        }\n      }\n\n      .link-external {\n        align-self: flex-start;\n        color: $gray;\n        margin-left: 1rem;\n      }\n\n      .details {\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n        min-width: 0;\n        pointer-events: none;\n        position: relative;\n        white-space: nowrap;\n        width: 100%;\n\n        > * {\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n\n        .name {\n          color: #343a40ee;\n          font-weight: 600;\n          margin: 0;\n          margin-bottom: 0.25rem;\n        }\n\n        .bio {\n          color: $blue;\n          font-size: 12px;\n          margin: 0;\n          margin-bottom: 0.25rem;\n        }\n\n        .socials {\n          align-items: center;\n          cursor: pointer;\n          display: flex;\n          line-height: 1.5rem;\n          margin-top: auto;\n          transition: opacity 0.15s ease-in-out;\n\n          .icon {\n            pointer-events: all;\n          }\n\n          svg {\n            margin-right: 0.5rem;\n          }\n\n          .github {\n            color: #6c757dbb;\n\n            &:hover {\n              color: $gray;\n            }\n          }\n\n          .linkedin {\n            color: $blue-mid;\n\n            &:hover {\n              color: $blue;\n            }\n          }\n\n          .instagram {\n            color: $pink-mid;\n\n            &:hover {\n              color: $pink;\n            }\n          }\n\n          .twitter {\n            color: $pblue-mid;\n\n            &:hover {\n              color: $pblue;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.About {\n  display: flex;\n  flex-direction: column;\n  min-height: 30rem;\n  width: 100%;\n\n  & > * {\n    align-self: center;\n    margin-bottom: 1.5rem;\n    width: 34rem;\n  }\n\n  & > *:first-child {\n    margin-top: 4rem;\n  }\n\n  h2 {\n    font-weight: 600;\n    margin: 0;\n    text-transform: none;\n  }\n\n  .question {\n    color: $gray-dark;\n    margin: 0;\n    margin-bottom: 0.25rem;\n  }\n\n  .answer {\n    color: $blue;\n    line-height: 1.5rem;\n  }\n\n  a {\n    background: $blue-light;\n    color: $blue;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.pills {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n\n  > button {\n    background-color: $yellow-light;\n    border: 2px $yellow-light solid;\n    border-bottom: 0;\n    border-top: 0;\n    color: $orange;\n    cursor: pointer;\n    font-size: 10px !important;\n    font-weight: 600;\n    margin: 0;\n    padding: 10px 15px;\n    text-align: center;\n    transition: background 0.25s ease-in-out;\n\n    &:hover {\n      background: $yellow-hover;\n    }\n\n    &.selected {\n      background-color: $yellow-mid;\n    }\n\n    &:focus {\n      &:not(:focus-visible) {\n        outline: none;\n      }\n    }\n\n    &:first-of-type {\n      border: 0;\n      border-bottom-left-radius: 5px;\n      border-top-left-radius: 5px;\n    }\n\n    &:last-of-type {\n      border: 0;\n      border-bottom-right-radius: 5px;\n      border-top-right-radius: 5px;\n    }\n  }\n}\n\n.updates-header {\n  align-self: center;\n  color: $gray-dark;\n  width: 100%;\n\n  h2 {\n    color: $pblue;\n    font-weight: 900;\n  }\n\n  h3 {\n    color: $blue-mid;\n    font-weight: 900;\n\n    &:hover {\n      svg {\n        color: $blue;\n      }\n    }\n\n    svg {\n      height: 1rem;\n    }\n  }\n}\n\n.updates-footer {\n  align-self: center;\n  color: $gray-dark;\n  margin-left: auto;\n\n  .telegram {\n    color: $blue;\n\n    &:hover {\n      color: $purple;\n    }\n  }\n\n  h4 {\n    color: $blue-mid;\n    font-weight: 900;\n    margin-top: 0.5rem;\n\n    svg {\n      height: 1rem;\n      margin-bottom: -0.1rem;\n      margin-left: 0.25rem;\n    }\n\n    &:hover {\n      color: $blue;\n    }\n  }\n}\n\n.updates {\n  align-self: center;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 1rem;\n  min-height: 22rem !important;\n  width: 100%;\n\n  .update {\n    background: $gray-light;\n    border-radius: 5px;\n    margin-bottom: 0.5rem;\n    padding: 0.75rem;\n    transition: all 0.2s ease-in-out;\n\n    &:hover {\n      background: $gray-hover;\n    }\n\n    h5,\n    h4 {\n      margin: 0;\n    }\n\n    h5 {\n      color: $gray-mid;\n      margin-bottom: 0.15rem;\n    }\n\n    h4 {\n      color: $gray;\n      font-weight: 600;\n    }\n  }\n\n  .button {\n    background: $pblue-light;\n    color: $pblue;\n    display: flex;\n    flex-direction: row;\n    height: 3rem;\n    width: 13rem;\n\n    & > * {\n      align-self: center;\n    }\n\n    &:hover {\n      background: $pblue-hover;\n    }\n  }\n\n  a {\n    color: inherit;\n    display: flex;\n    flex-direction: row;\n    text-decoration: none;\n\n    & > * {\n      align-self: center;\n    }\n  }\n}\n\n.district-bar {\n  align-self: center;\n  display: flex;\n  flex-direction: column;\n\n  .district-bar-bottom {\n    .button {\n      background: $gray-light;\n      color: $gray;\n      flex-basis: 15%;\n      font-weight: 600;\n      height: 2.5rem;\n      justify-content: center;\n      margin-top: 0.75rem;\n      text-transform: unset;\n      width: 5rem;\n\n      &:hover {\n        background: $gray-hover;\n      }\n    }\n  }\n\n  .district-bar-top {\n    align-self: center;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    width: 100%;\n\n    &.expanded {\n      flex-direction: column;\n    }\n\n    h2 {\n      font-weight: 900;\n      margin-bottom: 0.5rem;\n      margin-top: 0;\n\n      &.confirmed {\n        color: $red;\n      }\n\n      &.active {\n        color: $blue;\n      }\n\n      &.recovered {\n        color: $green;\n      }\n\n      &.deceased {\n        color: $gray;\n      }\n\n      &.vaccinated {\n        color: $pink;\n      }\n    }\n  }\n\n  .district-bar-left {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n  }\n\n  .district-bar-right {\n    display: flex;\n    flex-basis: 15rem;\n    flex-grow: 1;\n    justify-content: center;\n    position: relative;\n\n    .happy-sign {\n      display: flex;\n      flex-direction: row;\n      position: absolute;\n      top: 4rem;\n    }\n\n    .DeltaBarGraph {\n      margin-top: 1rem;\n      width: 100%;\n\n      svg {\n        width: 100%;\n\n        .label {\n          font-size: 11px;\n          font-weight: 900;\n          text-anchor: middle;\n        }\n      }\n    }\n  }\n\n  .districts {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    width: 10rem;\n\n    &.is-grid {\n      display: grid;\n      grid-auto-flow: column;\n      grid-gap: 0.5rem;\n      padding-bottom: 0.5rem;\n      width: 100%;\n    }\n\n    .district {\n      display: flex;\n      flex-direction: row;\n      height: 2.5rem;\n      justify-content: flex-start;\n      margin-right: 0.5rem;\n\n      h2,\n      h5 {\n        color: $gray;\n        font-weight: 600;\n        margin: 0;\n      }\n\n      h5 {\n        display: inline-block !important;\n        margin-left: 0.5rem;\n        margin-top: 0.15rem;\n        width: auto !important;\n      }\n\n      & > * {\n        align-self: center;\n      }\n\n      .delta {\n        display: flex;\n        flex-direction: row;\n        margin-left: 0.5rem;\n        margin-top: 4px;\n\n        h6 {\n          margin: 0;\n\n          &.confirmed {\n            color: $red-mid;\n          }\n\n          &.active {\n            color: $blue-mid;\n          }\n\n          &.recovered {\n            color: $green-mid;\n          }\n\n          &.deceased {\n            color: $gray-mid;\n          }\n\n          &.vaccianted {\n            color: $pink-mid;\n          }\n        }\n\n        svg {\n          stroke-width: 4;\n          vertical-align: bottom;\n          width: 10px;\n\n          &.confirmed {\n            color: $red-mid;\n          }\n\n          &.active {\n            color: $blue-mid;\n          }\n\n          &.recovered {\n            color: $green-mid;\n          }\n\n          &.deceased {\n            color: $gray-mid;\n          }\n\n          &.vaccinated {\n            color: $pink-mid;\n          }\n        }\n\n        & > * {\n          align-self: center;\n        }\n      }\n    }\n  }\n}\n\n.LanguageSwitcher {\n  align-self: center;\n  display: flex;\n  flex-direction: column;\n  margin-left: 5rem;\n  width: 34rem;\n\n  h3 {\n    align-self: center;\n    color: $pblue;\n    font-weight: 600;\n    margin-bottom: 2rem;\n  }\n\n  .close-button {\n    align-self: center;\n    background: $pblue-light;\n    border-radius: 50%;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    min-height: 1rem;\n    min-width: 1rem;\n    padding: 1rem;\n\n    &:hover {\n      background: $pblue-hover;\n    }\n\n    svg {\n      color: $pblue-mid;\n      stroke-width: 2.5px;\n\n      &:hover {\n        color: $pblue;\n      }\n    }\n  }\n\n  .languages {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    margin-bottom: 2.5rem;\n    min-height: 10rem;\n\n    .language {\n      border-radius: 5px;\n      color: $pblue-mid;\n      cursor: pointer;\n      display: flex;\n      flex-direction: column;\n      font-weight: 600;\n      justify-content: center;\n      padding: 1rem;\n      user-select: none;\n\n      &:hover {\n        color: $pblue;\n      }\n\n      &.is-highlighted {\n        background: $pblue-light;\n        color: $pblue;\n      }\n    }\n  }\n}\n\n.SunMoon {\n  cursor: pointer;\n}\n\n.Tooltip {\n  background-color: $black !important;\n  border-radius: 8px !important;\n  color: $white;\n  font-size: 13px !important;\n  font-weight: 600;\n  padding: 0.5rem;\n\n  .message {\n    margin: 0;\n\n    :not(:last-child) {\n      margin-bottom: 0.5rem;\n    }\n  }\n}\n\n.frac {\n  display: inline-block;\n  letter-spacing: 0.001em;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n\n  span {\n    display: block;\n    padding: 0.1em;\n\n    &.bottom {\n      border-top: thin solid;\n    }\n  }\n}\n\n@media (min-width: 769px) {\n  .Home,\n  .State {\n    padding-top: 5rem;\n  }\n\n  .Navbar {\n    background: $gray-light-opaque;\n    flex-direction: column;\n    height: 100%;\n    justify-content: flex-start;\n    min-width: 5rem;\n    position: fixed;\n    z-index: 999;\n\n    .navbar-left {\n      margin-bottom: 0.5rem;\n      margin-top: auto;\n      order: 3;\n      text-align: center;\n    }\n\n    .navbar-middle {\n      font-size: 0.6rem;\n      order: 1;\n      padding-bottom: 2rem;\n      padding-top: 2rem;\n      text-align: center;\n      width: 46px;\n      word-wrap: break-word;\n    }\n\n    .navbar-right {\n      align-items: center;\n      background: $gray-light-opaque;\n      display: flex;\n      flex-direction: column;\n      order: 2;\n      padding-bottom: 0;\n      padding-top: 0;\n\n      span {\n        display: flex;\n        flex-direction: row;\n        height: 1.5rem;\n        justify-content: center;\n        margin-bottom: 1.5rem;\n        margin-top: 1.5rem;\n\n        &:hover {\n          color: $pblue-dark;\n        }\n      }\n    }\n\n    .expand {\n      background: $gray-light-opaque;\n      flex-direction: column;\n      height: calc(100% - 5.5rem);\n      padding-left: 0;\n      padding-top: 5.75rem;\n      top: 0;\n      width: 15rem;\n\n      & > * {\n        border: 0;\n        color: $gray;\n        font-weight: 600;\n        height: 1.5rem;\n        width: 12rem;\n      }\n    }\n  }\n\n  .dark-mode {\n    .Navbar,\n    .expand,\n    .navbar-right {\n      background: #1e1e30 !important;\n    }\n  }\n\n  .State {\n    .state-left,\n    .state-right {\n      min-width: 33rem;\n      width: 40%;\n    }\n  }\n\n  .Home {\n    .home-left,\n    .home-right {\n      min-width: 33rem;\n      width: 40%;\n\n      &.expanded {\n        width: min(100%, max(71rem, calc(80% + 5rem)));\n      }\n    }\n\n    .home-left {\n      &.expanded {\n        margin-bottom: 2.5rem;\n        margin-right: 0;\n      }\n    }\n\n    .home-right {\n      &.expanded {\n        flex-direction: row;\n        margin-left: 0;\n      }\n    }\n  }\n\n  .map-container {\n    &.expanded {\n      margin-right: 2.5rem;\n      width: 50%;\n    }\n  }\n\n  .TimeseriesExplorer {\n    &.expanded {\n      margin-left: 2.5rem;\n      width: calc(50% - 2rem);\n    }\n  }\n\n  footer {\n    margin-bottom: 5rem;\n  }\n}\n\n@media (max-width: 769px) {\n  .table-container,\n  .header,\n  .TimeseriesExplorer,\n  .map-container,\n  .Links,\n  .Summary,\n  .Volunteers,\n  .About,\n  .updates,\n  .updates-header,\n  .StateMeta,\n  .timeline,\n  .table-top,\n  .LanguageSwitcher,\n  .VaccinationHeader {\n    width: calc(100% - 2rem);\n  }\n\n  .Home,\n  .State {\n    display: flex;\n    flex-direction: column;\n    margin-left: 0;\n    margin-right: 0;\n    padding-top: 1rem;\n    width: 100%;\n\n    .home-left,\n    .home-right,\n    .state-left,\n    .state-right {\n      display: flex;\n      flex-direction: column;\n      margin: 0;\n      width: 100%;\n    }\n  }\n\n  .map-container {\n    align-self: center;\n  }\n\n  .MapExplorer {\n    .svg-parent {\n      width: 100%;\n    }\n\n    .header {\n      margin-top: 2rem;\n    }\n  }\n\n  .link,\n  .faq {\n    width: calc(100% - 2rem);\n  }\n\n  .Timeseries {\n    .svg-parent {\n      width: 100%;\n    }\n  }\n\n  .Minigraph {\n    .svg-parent {\n      padding: 0;\n    }\n  }\n\n  .map-stats {\n    .stats {\n      .timestamp {\n        width: 4.5rem;\n      }\n    }\n  }\n\n  a {\n    &.button {\n      display: flex;\n      flex: row;\n      justify-content: center;\n      width: 10rem;\n\n      & > * {\n        align-self: center;\n      }\n\n      svg {\n        width: 38px;\n      }\n    }\n  }\n\n  .Banner {\n    .wrapper {\n      flex-direction: column;\n      padding-left: 0.75rem;\n      width: 100%;\n\n      .content {\n        margin: 0.5rem 0;\n      }\n    }\n  }\n\n  .cards-container {\n    padding: 0.5rem;\n\n    .cards {\n      .card {\n        flex: 0 1 100%;\n        height: 25rem;\n        margin-bottom: 0;\n      }\n\n      .chart-title {\n        padding: 20px 0 10px;\n      }\n\n      .card-big {\n        height: 30rem;\n      }\n    }\n  }\n\n  .Demographics {\n    margin-left: 0;\n    width: 100%;\n\n    .select {\n      .react-date-picker__calendar {\n        position: fixed;\n        top: 2.3rem !important;\n      }\n    }\n\n    .header {\n      margin: 0;\n      padding-left: 1rem;\n      padding-right: 1rem;\n      width: calc(100% - 2rem);\n    }\n\n    .reminder {\n      padding-bottom: 1rem;\n      padding-top: 1rem;\n      width: calc(100% - 4rem);\n    }\n\n    .Patients {\n      width: calc(100% - 2rem);\n    }\n\n    .modal {\n      .modal-content {\n        width: calc(100% - 5rem);\n\n        .meta {\n          height: 20rem;\n        }\n      }\n    }\n\n    .filters-left {\n      flex-wrap: wrap;\n      justify-content: space-between;\n    }\n\n    .filters {\n      align-self: center;\n      height: auto;\n      justify-content: center;\n      padding: 0.5rem;\n    }\n  }\n\n  .patients-summary {\n    width: calc(100% - 2rem);\n\n    .modal {\n      .modal-content {\n        width: calc(100% - 5rem);\n\n        .meta {\n          height: 20rem;\n        }\n      }\n    }\n  }\n\n  .patientdb-wrapper {\n    padding-left: 1rem !important;\n    padding-right: 1rem !important;\n\n    .Patients {\n      width: 100%;\n    }\n\n    .day {\n      justify-content: center;\n      width: 100%;\n    }\n  }\n\n  .Navbar {\n    .expand {\n      height: calc(100% - 4rem);\n      overflow: auto;\n      transform: none !important;\n    }\n\n    .expand-bottom {\n      margin-top: auto;\n    }\n\n    .navbar-right {\n      span {\n        display: none;\n\n        &:first-child {\n          display: initial;\n        }\n      }\n    }\n  }\n\n  .Search {\n    .result-name {\n      max-width: 10rem !important;\n    }\n  }\n\n  .State {\n    .MapExplorer,\n    .StateHeader {\n      width: calc(100% - 2rem);\n    }\n\n    .district-bar {\n      width: calc(100% - 3rem);\n\n      h1 {\n        padding-left: 0;\n      }\n    }\n  }\n\n  .StateMeta {\n    display: grid;\n    grid-gap: 1rem;\n    grid-template-rows: repeat(auto-fit, minmax(5rem));\n    margin-bottom: 2.5rem;\n\n    .meta-item {\n      min-width: 1rem;\n    }\n  }\n\n  .timeline {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .LanguageSwitcher {\n    margin-left: 0;\n  }\n\n  .VaccinationHeader {\n    margin-bottom: 2rem;\n    margin-top: 1rem;\n  }\n\n  .timeseries-header {\n    .timeseries-options {\n      flex-direction: column;\n\n      .moving-average {\n        margin-top: 0.75rem;\n      }\n    }\n  }\n\n  .MapSwitcher {\n    .highlight,\n    .clickable {\n      height: 13rem;\n    }\n  }\n\n  .Volunteers {\n    margin-left: 0;\n\n    .wrapper,\n    .members {\n      max-width: 100%;\n      width: 100%;\n    }\n  }\n}\n\n// Dark Mode\n\n.dark-mode {\n  background: #161625 !important;\n  color: #bdbdbd;\n\n  .switch-wrapper > div {\n    background: #161625 !important;\n  }\n\n  .is-tested {\n    color: $dark-m-purple !important;\n\n    svg {\n      color: $dark-m-purple !important;\n    }\n  }\n\n  .expand {\n    background: #1e1e30 !important;\n  }\n\n  .Navbar,\n  .expand {\n    border-right: 0;\n\n    .navbar-middle {\n      color: #bdbdbd;\n    }\n  }\n\n  .table {\n    .cell {\n      &:first-child {\n        background: #1e1e30 !important;\n      }\n\n      &.heading {\n        background: #1e1e30 !important;\n\n        &:hover {\n          background: #212130 !important;\n        }\n      }\n    }\n\n    .is-highlighted,\n    .is-total {\n      .cell {\n        background: #1e1e30 !important;\n      }\n    }\n  }\n\n  .Search {\n    input {\n      background: #1e1e30 !important;\n    }\n  }\n\n  .State {\n    .header-right {\n      h5 {\n        color: #9673b9bb !important;\n      }\n\n      h2 {\n        color: #9673b9 !important;\n      }\n\n      a {\n        background: $dark-m-purple-light !important;\n      }\n    }\n\n    .breadcrumb {\n      ul {\n        background: #1e1e30 !important;\n\n        &::after {\n          border-bottom-color: #1e1e30 !important;\n        }\n\n        li {\n          a {\n            color: $gray !important;\n\n            &:hover {\n              color: $white !important;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .StateHeader {\n    .header-right {\n      color: $dark-m-purple-mid;\n\n      h2 {\n        color: $dark-m-purple;\n      }\n\n      a {\n        background: $dark-m-purple-light;\n\n        &:hover {\n          background: $dark-m-purple-hover !important;\n        }\n      }\n    }\n  }\n\n  .MapExplorer {\n    #chart,\n    #legend-choro {\n      &.zone {\n        filter: none;\n      }\n\n      &:not(.zone) {\n        filter: invert(1) hue-rotate(180deg) saturate(1.5) url('#balance-color');\n      }\n    }\n\n    .maplegend {\n      background: #161625 !important;\n    }\n\n    .meta {\n      h1 {\n        &.tested {\n          color: #9673b9 !important;\n        }\n      }\n\n      h2 {\n        &.tested {\n          color: #9673b9 !important;\n        }\n      }\n    }\n\n    .panel {\n      .panel-left {\n        .tested {\n          color: $dark-m-purple !important;\n        }\n      }\n    }\n\n    .stats {\n      &.tested {\n        background: $dark-m-purple-light !important;\n\n        h1 {\n          color: #9673b9 !important;\n        }\n\n        h5,\n        h6 {\n          color: #9673b9bb !important;\n        }\n\n        svg {\n          stroke: #9673b9bb !important;\n\n          &:hover {\n            stroke: #9673b9 !important;\n          }\n        }\n      }\n    }\n\n    .disclaimer {\n      color: $gray-light-opaque;\n    }\n  }\n\n  .Timeseries,\n  .Minigraph {\n    .stats {\n      &.is-tested {\n        h5 {\n          color: $dark-m-purple-mid !important;\n\n          &.title {\n            color: $dark-m-purple-mid !important;\n          }\n        }\n\n        h2,\n        h6 {\n          color: $dark-m-purple !important;\n        }\n      }\n    }\n\n    .svg-parent {\n      &.is-tested {\n        background: $dark-m-purple-light !important;\n\n        svg {\n          circle,\n          .domain,\n          .tick {\n            stroke: $dark-m-purple !important;\n          }\n\n          circle {\n            fill: $dark-m-purple !important;\n          }\n\n          .trend,\n          line {\n            stroke: #9673b999 !important;\n          }\n\n          .trend-area {\n            fill: #9673b999 !important;\n          }\n\n          text {\n            color: $dark-m-purple-mid !important;\n            stroke: transparent;\n          }\n        }\n      }\n\n      &.is-brush {\n        .handle--custom {\n          stroke: $gray-light-opaque;\n        }\n      }\n    }\n  }\n\n  .tpl {\n    background: $dark-m-purple-light !important;\n\n    h3,\n    h5,\n    svg,\n    p {\n      color: #9673b9bb !important;\n    }\n\n    h1 {\n      color: #9673b9 !important;\n    }\n  }\n\n  .tab {\n    &.focused {\n      background: #1e1e30 !important;\n      color: #bdbdbd !important;\n    }\n  }\n\n  .pills {\n    button {\n      &.selected {\n        background: #{$yellow}50;\n      }\n    }\n  }\n\n  .TimeseriesExplorer {\n    .state-selection {\n      .dropdown {\n        select {\n          background: #1e1e30;\n          background-image: linear-gradient(45deg, transparent 50%, $gray 50%),\n          linear-gradient(135deg, $gray 50%, transparent 50%);\n          background-position: calc(100% - 13px) 50%, calc(100% - 8px) 50%;\n          background-repeat: no-repeat;\n          background-size: 5px 5px, 5px 5px;\n          border-color: #9494941a;\n        }\n      }\n    }\n  }\n\n  input {\n    &.switch {\n      background-color: #161625 !important;\n      border: 2px solid $gray-mid !important;\n\n      &:checked {\n        background-color: #6c757d99 !important;\n\n        &::after {\n          background-color: #cfcfcf !important;\n        }\n      }\n\n      &::after {\n        background-color: #cfcfcf !important;\n      }\n    }\n  }\n\n  .disabled {\n    input {\n      &.switch {\n        background: $dark !important;\n        border: $gray-light 2px solid !important;\n        opacity: 0.7;\n\n        &::after {\n          background: $gray !important;\n        }\n      }\n    }\n  }\n\n  .Volunteers {\n    .members {\n      .last {\n        .Member {\n          &:hover {\n            background-color: #212130;\n          }\n\n          &.second {\n            background-color: $dark-m-gray;\n\n            &:hover {\n              background-color: #212130;\n            }\n          }\n        }\n      }\n\n      .Member {\n        background-color: #1e1e30;\n\n        &:hover {\n          background-color: $gray-hover;\n        }\n\n        .details {\n          .name {\n            color: $gray;\n          }\n        }\n      }\n    }\n  }\n\n  .About {\n    .question {\n      color: $gray !important;\n    }\n  }\n\n  .Demographics {\n    .filters {\n      background: #1e1e30 !important;\n      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.12), inset 0 -1px 0 0 #1e1e30;\n    }\n\n    .legend {\n      background: #1e1e30 !important;\n    }\n\n    .react-date-picker {\n      background: #1e1e30;\n      border-color: #9494941a !important;\n    }\n\n    .modal-content {\n      background: #1e1e30 !important;\n    }\n\n    .modal {\n      background: #1e1e30bb !important;\n    }\n  }\n\n  .StateDropdown {\n    .dropdown {\n      background: #1e1e30 !important;\n    }\n  }\n\n  .StatisticDropdown {\n    select {\n      option {\n        background: #1e1e30;\n        color: $gray;\n      }\n    }\n  }\n\n  .TableLoader {\n    svg {\n      rect {\n        fill: #1e1e30 !important;\n      }\n    }\n  }\n}\n\n// Animation Support\n\n.fadeInUp {\n  animation-duration: 0.45s;\n  animation-fill-mode: both;\n  animation-name: fadeInUp;\n}\n\n@keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    transform: translate3d(0, 20px, 0);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n.fadeInDown {\n  animation-duration: 0.45s;\n  animation-fill-mode: both;\n  animation-name: fadeInDown;\n}\n\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    transform: translate3d(0, -20px, 0);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n.rotateDownRight {\n  animation-duration: 0.25s;\n  animation-fill-mode: both;\n  animation-name: rotateDownRight;\n}\n\n@keyframes rotateDownRight {\n  100% {\n    transform: rotate(-90deg);\n  }\n}\n\n.rotateRightDown {\n  animation-duration: 0.25s;\n  animation-fill-mode: both;\n  animation-name: rotateRightDown;\n}\n\n@keyframes rotateRightDown {\n  0% {\n    transform: rotate(-90deg);\n  }\n}\n\n.fadeOutDown {\n  animation-duration: 0.45s;\n  animation-fill-mode: both;\n  animation-name: fadeOutDown;\n}\n\n@keyframes fadeOutDown {\n  0% {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n\n  100% {\n    opacity: 0;\n    transform: translate3d(0, 20px, 0);\n  }\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
